{
    "specialties": {
        "allgemeinmedizin": "General Medicine",
        "anaesthesiology": "Anaesthesiology",
        "occupationalMedicine": "Occupational Medicine",
        "ophthalmology": "Ophthalmology",
        "surgery": "Surgery",
        "gynecology": "Gynaecology and Obstetrics",
        "ent": "Ear, Nose and Throat",
        "dermatology": "Dermatology and Venereology",
        "humanGenetics": "Human Genetics",
        "hygiene": "Hygiene and Environmental Medicine",
        "internalMedicine": "Internal Medicine",
        "pediatrics": "Paediatrics and Adolescent Medicine",
        "childPsychiatry": "Child and Adolescent Psychiatry and Psychotherapy",
        "laboratoryMedicine": "Laboratory Medicine",
        "microbiology": "Microbiology, Virology and Infectious Disease Epidemiology",
        "maxillofacialSurgery": "Oral and Maxillofacial Surgery",
        "neurosurgery": "Neurosurgery",
        "orthopedics": "Orthopedics and Trauma Surgery",
        "neurology": "Neurology",
        "nuclearMedicine": "Nuclear Medicine",
        "publicHealth": "Public Health",
        "pathology": "Pathology",
        "pharmacology": "Pharmacology",
        "phoniatrics": "Phoniatrics and Paediatric Audiology",
        "rehabilitationMedicine": "Physical and Rehabilitation Medicine",
        "physiology": "Physiology",
        "plasticSurgery": "Plastic and Aesthetic Surgery",
        "psychiatry": "Psychiatry and Psychotherapy",
        "psychosomatics": "Psychosomatic Medicine and Psychotherapy",
        "radiology": "Radiology",
        "forensicMedicine": "Forensic Medicine",
        "radiotherapy": "Radiation Oncology",
        "transfusionMedicine": "Transfusion Medicine",
        "urology": "Urology",
        "dentistry": "Dentistry"
    },
    "language": {
        "title": "Language",
        "description": "Choose the display language for the interface."
    },
    "login": {
        "welcome": "Welcome back",
        "subtitle": "Enter your Praxis' id and your user's email and password to access your account",
        "praxisId": "Praxis ID",
        "praxisIdPlaceholder": "praxisid",
        "email": "Email",
        "emailPlaceholder": "username@gmail.com",
        "password": "Password",
        "invalidCredentials": "Invalid credentials",
        "tooManyAttempts": "Too many login attempts. Please wait 15 minutes and try again.",
        "accountLocked": "Too many failed attempts. Try again at {{time}}.",
        "capsLock": "Caps Lock is on",
        "emailNotVerified": "Please verify your email address before signing in.",
        "signIn": "Sign in",
        "questions": "Questions? Please contact:",
        "or": "or call",
        "noAccount": "Don't have an account?",
        "register": "Register",
        "forgotPassword": "Forgot password?",
        "forgotPasswordTitle": "Reset password",
        "forgotPasswordSubtitle": "Enter your Praxis ID and email address. We'll send you a link to reset your password.",
        "forgotPasswordSent": "If an account with those details exists, a reset link has been sent by email.",
        "forgotPasswordSend": "Send link",
        "forgotPasswordBack": "Back to login",
        "resetPasswordTitle": "New password",
        "resetPasswordSubtitle": "Enter your new password.",
        "resetPasswordNew": "New password",
        "resetPasswordConfirm": "Confirm password",
        "resetPasswordMismatch": "Passwords do not match.",
        "resetPasswordTooShort": "Password must be at least 8 characters.",
        "resetPasswordSuccess": "Your password has been changed successfully.",
        "resetPasswordInvalid": "This link is invalid or has expired.",
        "resetPasswordSubmit": "Set password"
    },
    "register": {
        "title": "Create your account",
        "alreadyHaveAccount": "Already have an account?",
        "signIn": "Sign in",
        "step1": "Praxis",
        "step1Desc": "Set up your practice profile",
        "step2": "Extra Info",
        "step2Desc": "Specialization, address & contact",
        "step3": "Banking",
        "step3Desc": "Banking and billing details",
        "step4": "Plan",
        "step4Desc": "Choose your subscription",
        "step5": "Team",
        "step5Desc": "Add doctors and staff",
        "next": "Next",
        "back": "Back",
        "backToLogin": "Back to login",
        "submit": "Complete registration",
        "submitting": "Registering...",
        "praxisName": "Practice name",
        "praxisEmail": "Email",
        "password": "Password",
        "confirmPassword": "Confirm password",
        "suggestedId": "Login ID",
        "suggestedIdHint": "Used at login",
        "regenerate": "Regenerate",
        "padPraxisId": "PAD billing ID (optional)",
        "specialization": "Specialization(s)",
        "logo": "Logo (optional)",
        "logoUpload": "Click to upload",
        "phones": "Phone number(s)",
        "addPhone": "+ Add phone",
        "street": "Street",
        "streetNumber": "No.",
        "plz": "ZIP / Postcode",
        "city": "City",
        "country": "Country",
        "iban": "IBAN",
        "bic": "BIC / SWIFT",
        "taxNumber": "Tax number",
        "selectPlan": "Choose your plan",
        "perMonth": "/ mo",
        "trialNotice": "All plans include a 14-day free trial. No credit card required.",
        "sepaNotice": "Your IBAN is used to set up a SEPA Direct Debit mandate. The first payment will be collected after the free trial ends.",
        "smsPostNotice": "For Basic and Pro plans, SMS sending and postal dispatch are charged separately per use.",
        "manageSubscriptionNotice": "You can change or cancel your subscription anytime in Settings → Subscription.",
        "priceExclVat": "All prices exclusive of VAT.",
        "selected": "Selected",
        "planFeatureSms": "SMS",
        "planFeatureSmsIncluded": "SMS included",
        "planFeatureCardPayment": "Card payment in the patient portal (SumUp) – coming soon",
        "planFeatureCustomTeam": "Custom team size",
        "planFeatureUnlimitedInvoices": "Unlimited invoices",
        "planBasic": "Basic",
        "planPlus": "Plus",
        "planPro": "Pro",
        "planEnterprise": "Enterprise",
        "teamTitle": "Team members",
        "adminBadge": "Admin",
        "member": "Member",
        "addMember": "Add member",
        "planLimitReached": "Your current plan does not allow more members. Please upgrade your plan.",
        "editMember": "Edit member",
        "unnamedMember": "Unnamed member",
        "save": "Save",
        "cancel": "Cancel",
        "edit": "Edit",
        "remove": "Remove",
        "salutation": "Salutation",
        "memberTitle": "Title",
        "firstName": "First name",
        "lastName": "Last name",
        "specialty": "Specialty",
        "memberEmail": "Email",
        "memberPassword": "Password",
        "confirmMemberPassword": "Confirm password",
        "userRights": "Role",
        "avatar": "Photo",
        "uploadPhoto": "Click to upload",
        "memberIban": "IBAN (optional)",
        "memberBic": "BIC (optional)",
        "memberTaxNumber": "Tax number (optional)",
        "basicOneMember": "The Basic plan includes one doctor account.",
        "planMembersInfo": "Your {{plan}} plan includes up to {{max}} team member(s).",
        "planDoctorInfo": "{{plan}}: {{doctorCount}}/{{maxDoctors}} doctor(s) used",
        "planStaffInfo": "{{staffCount}}/{{maxStaff}} staff used",
        "errorTooManyDoctors": "Your plan allows {{max}} doctor(s), but you have {{count}}. Please remove a doctor or upgrade your plan.",
        "errorTooManyStaff": "Your plan allows {{max}} staff member(s), but you have {{count}}. Please remove a staff member or upgrade your plan.",
        "extraDoctorInfo": "Each additional doctor beyond your plan limit costs €39/month.",
        "memberOverageInfo": "You have reached the maximum number of members. Each additional doctor beyond your plan limit costs €39/month. Each additional staff member (assistant / accounting) beyond the plan limit costs €9.90/month. To add more members, please contact us.",
        "ibanFallbackInfo": "If an admin or doctor does not have their own IBAN, the practice IBAN will be displayed to patients for incoming payments.",
        "ibanFallbackNotice": "No IBAN entered — the practice IBAN will be used for this member's payments.",
        "roleAdmin": "Admin",
        "roleDoctor": "Doctor",
        "roleMedicalAssistant": "Medical assistant",
        "roleAccounting": "Accounting",
        "successTitle": "You're all set!",
        "successMsg": "Your practice has been registered. Please note your Login ID — you will need it every time you sign in.",
        "yourPraxisId": "Your Login ID:",
        "verifyEmailNotice": "We sent a verification email to {{email}}. Please verify your email address before signing in.",
        "goToLogin": "Sign in now",
        "errorPraxisName": "Practice name is required.",
        "errorEmail": "A valid email address is required.",
        "errorPasswordLength": "Password must be at least 8 characters.",
        "errorPasswordMatch": "Passwords do not match.",
        "errorPraxisId": "Login ID is required.",
        "errorIdTaken": "This Login ID is already taken. Please choose another.",
        "errorIban": "IBAN is required.",
        "errorIbanFormat": "Invalid IBAN format.",
        "errorSpecialization": "Please select at least one specialization.",
        "errorStreet": "Street is required.",
        "errorStreetNumber": "Street number is required.",
        "errorPlz": "Postal code is required.",
        "errorCity": "City is required.",
        "errorPhone": "At least one phone number is required.",
        "errorNoAdmin": "Please add at least one admin member.",
        "errorPlan": "Please select a plan.",
        "errorFirstName": "First name is required.",
        "errorLastName": "Last name is required.",
        "errorGeneral": "Registration failed. Please try again.",
        "suggestedIds": "Suggestions",
        "idChecking": "Checking…",
        "idAvailable": "Available",
        "idTaken": "Already taken",
        "praxisIdNotice": "Your Login ID, together with your email and password, is required every time you sign in.",
        "adminNotice": "Your first name, last name, email and password will be used for the mandatory administrator account of this practice.",
        "otpTitle": "Verify your email",
        "otpHint": "We sent a 6-digit code to {{email}}.",
        "otpConfirm": "Confirm & register",
        "otpResend": "Resend code",
        "otpInvalid": "Invalid or expired code. Please try again.",
        "otpTooMany": "Too many attempts. Please wait 10 minutes and try again.",
        "otpSendError": "Failed to send code. Please try again later.",
        "staffOverageInfo": "Each additional staff member (assistant / accounting) beyond the plan limit costs €9.90/month.",
        "streetAndNumber": "Street & house number",
        "sepaConsentText": "I authorise Exipnon GmbH to collect payments from my account by SEPA direct debit for recurring use of Medinvoice®. I may revoke this authorisation at any time directly with Exipnon GmbH.",
        "errorIbanConsent": "Please accept the SEPA direct debit mandate.",
        "passwordHint": "Min. 8 chars · 1 uppercase · 1 special character",
        "errorPasswordStrength": "Password must contain at least one uppercase letter and one special character.",
        "addLaterNote": "You can add more team members at any time later under Settings.",
        "adminNameMissing": "Please enter your first and last name to continue.",
        "errorIbanRegistered": "This IBAN is already linked to a Medinvoice account. Please sign in or contact support.",
        "emailInfoTitle": "Two emails will be sent",
        "emailInfoPraxisLabel": "Praxis email",
        "emailInfoPraxisDesc": "Will receive a 6-digit confirmation code to verify the registration.",
        "emailInfoAdminLabel": "Administrator email",
        "emailInfoAdminDesc": "Will receive a verification link after successful confirmation. This must be clicked before the first login is possible.",
        "emailInfoConfirm": "Got it, send code",
        "errorPraxisExists": "This email address is already linked to a praxis. Please sign in."
    },
    "nav": {
        "home": "Home",
        "recipients": "Recipients",
        "patients": "Patients",
        "invoices": "Invoices",
        "bank": "Bank",
        "praxisSoftwareSync": "Sync",
        "uploads": "Uploads",
        "settings": "Settings",
        "docs": "Documentation",
        "logout": "Logout",
        "myProfile": "My Profile",
        "assistant": "Assistant",
        "charges": "Monthly Charges",
        "menuToggle": "Open menu",
        "menuClose": "Close menu",
        "mainNavigation": "Main navigation"
    },
    "bank": {
        "title": "Bank Transactions",
        "leadConnected": "<strong>{{total}} transactions synced.</strong> <em>{{unmatched}} unmatched, {{auto}} auto-matched, {{reviewed}} reviewed.</em>"
    },
    "roles": {
        "doctor": "Doctor",
        "admin": "Admin",
        "medicalAssistant": "Medical Assistant",
        "accounting": "Accounting",
        "user": "User",
        "firstLogin": "First login"
    },
    "dashboard": {
        "title": "Daily Briefing",
        "welcomeBack": "Welcome back,",
        "staffSubtitle": "Manage patient invoices, track payment status, and keep records up to date.",
        "invoicesThisMonth": "Invoices this month",
        "quotaTip": "{{count}} of {{allowance}} invoices used. Each additional invoice is charged at €{{rate}}.",
        "pvsSavingsPositive": "Saving {{amount}} vs. a PVS billing service this month",
        "pvsSavingsNegative": "{{amount}} more than a PVS billing service this month",
        "pvsHistoryTitle": "Savings vs. a PVS billing service",
        "pvsHistoryCurrent": "Current",
        "pvsHistoryPositive": "Saved {{amount}}",
        "pvsHistoryNegative": "{{amount}} more expensive",
        "pvsHistoryNotConfigured": "Not configured",
        "pvsHistoryEmpty": "No billing history yet.",
        "pvsHistoryOpenCharges": "Open in Billing →",
        "totalOutstanding": "Outstanding balance",
        "openPosten": "Outstanding Invoices",
        "openPostenCount_one": "{{count}} invoice",
        "openPostenCount_other": "{{count}} invoices",
        "openPostenTotal": "Total outstanding",
        "openPostenEmpty": "No outstanding invoices.",
        "openPostenNoReminder": "No reminder yet",
        "openPostenReminded": "Reminded",
        "openPostenCritical": "Final notice",
        "pendingToSend": "Pending to send",
        "pendingToSendCount_one": "{{count}} invoice",
        "pendingToSendCount_other": "{{count}} invoices",
        "billed": "Billed",
        "collected": "Paid",
        "uploaded": "Uploaded",
        "sent": "Sent",
        "paid": "Paid",
        "recipients": "Recipients",
        "patients": "Patients",
        "pendingInvoices": "Pending Invoices",
        "overdue": "Overdue",
        "invoices": "Invoices",
        "openInvoices": "Open",
        "dunningStatus": "Dunning Status",
        "overview": "Overview",
        "toggleActivity": "Toggle activity & todos",
        "toggleOverview": "Toggle overview & dunning",
        "toggleBank": "Toggle bank details",
        "toggleSectionsHint": "These icons show or hide dashboard sections. Your layout is saved for next time.",
        "toggleSectionsHintDismiss": "Got it",
        "boot": {
            "loading": "Loading your data…",
            "invoices": "Fetching invoices…",
            "patients": "Preparing patients list…",
            "recipients": "Preparing recipients list…",
            "calculating": "Calculating amounts…",
            "sub": "This can take a moment on slower networks."
        },
        "kpiHelp": {
            "moreAbout": "More information: {{topic}}",
            "outstanding": "Open balance: sent invoices that are not yet fully paid (excludes written-off / cancelled).",
            "sent": "Gross total of invoices sent in the current calendar year (paid or unpaid).",
            "paid": "Total amount received (including partial payments).",
            "overdue": "Remaining balance of sent invoices in dunning (M1/M2/M3/legal) that are not yet paid."
        },
        "overdueBreakdown": "Overdue Breakdown",
        "overdueTotalFines": "Total dunning fines",
        "overdueBaseAmounts": "Invoice amounts",
        "overdueNoData": "No overdue invoices",
        "toggleTimeline": "Toggle invoice timeline",
        "noDunning": "No dunning",
        "friendly": "Friendly",
        "demanding": "Demanding",
        "final": "Final",
        "legal": "Legal",
        "open": "Open",
        "invoicesIssued": "Invoices Issued in",
        "statsButton": "Statistics",
        "help": "Help",
        "stats": {
            "title": "Practice Statistics",
            "monthOverMonth": "Month-over-month",
            "newPatients": "New patients",
            "invoicesCreated": "Invoices created",
            "patientsAndInvoices": "Patients & Invoices",
            "sentAndPaid": "Sent & Paid",
            "popularServices": "Most popular services",
            "mostUsed": "Most frequently billed",
            "topEarning": "Highest revenue",
            "noServices": "No services recorded yet.",
            "serviceCount": "{{count}}×"
        },
        "timeline": {
            "title": "Invoice Timeline",
            "total": "Total",
            "paid": "Paid",
            "unpaid": "Unpaid",
            "pad": "PAD Imported",
            "thisMonth": "This Month",
            "thisYear": "This Year",
            "last3m": "Last 3M",
            "last6m": "Last 6M",
            "last12m": "Last 12M",
            "allTime": "All Time"
        },
        "summaryPie": {
            "title": "Invoice Summary",
            "total": "Outstanding balance",
            "yearTotal": "Year total",
            "active": "Active",
            "outstanding": "Outstanding",
            "overdue": "Overdue",
            "paid": "Paid",
            "sent": "Sent",
            "m1": "M1 – Reminder",
            "m2": "M2 – Demand",
            "m3": "M3 – Final"
        },
        "unsentInvoices": "{{count}} invoice not sent",
        "unsentInvoices_other": "{{count}} invoices not sent",
        "noEmail": "{{count}} recipient without email",
        "noEmail_other": "{{count}} recipients without email",
        "noPhone": "{{count}} recipient without phone",
        "noPhone_other": "{{count}} recipients without phone",
        "unansweredQuestions": "{{count}} unanswered question",
        "unansweredQuestions_other": "{{count}} unanswered questions",
        "questionnaireNoInvoice": "{{count}} invoice not sent (questionnaire submitted)",
        "questionnaireNoInvoice_other": "{{count}} invoices not sent (questionnaire submitted)"
    },
    "activity": {
        "title": "Activity",
        "empty": "No activity in the last {{n}} days.",
        "emptyHint": "This is normal when nothing recent matched your filters. Try another filter or check back later.",
        "invoicePaid": "Invoice {{readableId}} paid",
        "invoiceViewed": "Invoice {{readableId}} opened by recipient",
        "dunningAdvanced": "Dunning level {{dunningLevel}} — Invoice {{readableId}}",
        "portalRegistered": "Recipient registered on the portal",
        "smsOtpUsed": "Recipient verified via SMS",
        "unsentReminder": "Invoice {{readableId}} not sent ({{daysSinceCreation}}d)",
        "questionSubmitted": "Recipient submitted a question ({{questionCategory}})",
        "questionnaireFilled": "Recipient signed the consent (Einwilligung)",
        "bankTransactionMatched": "Bank transfer matched to invoice {{readableId}}",
        "billingCharged": "Monthly subscription charged — €{{amount}} ({{transactionRef}})",
        "overpaymentDetected": "Overpayment detected on invoice {{readableId}} (+€{{amount}})",
        "found": "{{count}} found · last {{n}} days",
        "filter": {
            "all": "All",
            "paid": "Paid",
            "bank": "Bank",
            "unsent": "Not sent",
            "dunning": "Dunning",
            "portal": "Portal"
        }
    },
    "todos": {
        "title": "To-Do",
        "allDone": "All caught up!",
        "allDoneHint": "No invoices need your attention right now.",
        "unsentInvoices": "{{count}} invoice not sent",
        "unsentInvoices_other": "{{count}} invoices not sent",
        "consentMissing": "{{count}} invoice can't be sent — consent missing",
        "consentMissing_other": "{{count}} invoices can't be sent — consent missing",
        "noEmail": "{{count}} recipient without email",
        "noEmail_other": "{{count}} recipients without email",
        "noPhone": "{{count}} recipient without phone",
        "noPhone_other": "{{count}} recipients without phone",
        "unansweredQuestions": "{{count}} unanswered question",
        "unansweredQuestions_other": "{{count}} unanswered questions",
        "questionnaireNoInvoice": "{{count}} invoice not sent (consent signed)",
        "questionnaireNoInvoice_other": "{{count}} invoices not sent (consent signed)",
        "overdueUnmatched": "{{count}} overdue invoice to review",
        "overdueUnmatched_other": "{{count}} overdue invoices to review",
        "overpaidInvoices": "{{count}} invoice overpaid",
        "overpaidInvoices_other": "{{count}} invoices overpaid",
        "unmatchedBankTx": "{{count}} bank transaction not matched to an invoice",
        "unmatchedBankTx_other": "{{count}} bank transactions not matched to an invoice",
        "doublePayments": "{{count}} invoice paid twice",
        "doublePayments_other": "{{count}} invoices paid twice"
    },
    "patients": {
        "title": "Patients",
        "fetching": "Fetching...",
        "search": "Name or email…",
        "add": "Add patient",
        "selected": "selected",
        "noFound": "No patients found",
        "createdSuccess": "Patient created successfully",
        "deleteTitle": "Delete Patient",
        "editPatient": "Edit patient",
        "deletePatient": "Delete patient",
        "failedDelete": "Failed to delete patient. Please try again.",
        "otherDoctorHint": "Belongs to {{name}}",
        "otherDoctorHintUnknown": "Belongs to another doctor",
        "deleteNTitle": "Delete {{count}} Patient(s)",
        "count_one": "{{count}} Patient",
        "count_other": "{{count}} Patients",
        "recipientsCount": "{{count}} Invoice Recipients",
        "lead": "<strong>{{total}} patients · {{recipients}} invoice recipients</strong> on the books. <em>{{withOpen}} have open invoices.</em>",
        "viewAll": "All",
        "viewWithOpen": "With open invoices",
        "viewAllPaid": "All paid up",
        "viewMissingEmail": "Missing email",
        "viewMinors": "Minors",
        "advancedFilters": "Advanced filters",
        "exportCsv": "Export CSV",
        "selfPayer": "Self",
        "noEmail": "— no email —",
        "noInvoicesYet": "no invoices yet",
        "open": "Open patient",
        "noTel": "No tel",
        "sortLabel": "Sort: {{label}}",
        "bulkQuestionnaireBtn": "Send consent request",
        "bulkQuestionnaireTitle": "Send questionnaire to {{count}} patient(s)",
        "bulkQuestionnaireCanSend": "{{count}} ready to send",
        "bulkQuestionnaireNoEmail": "{{count}} missing email",
        "bulkQuestionnairePostOnly": "{{count}} post only",
        "bulkQuestionnaireSend": "Send",
        "bulkQuestionnaireSending": "Sending…",
        "bulkQuestionnaireSelectAll": "Select all",
        "bulkQuestionnaireDone_one": "{{count}} questionnaire sent",
        "bulkQuestionnaireDone_other": "{{count}} questionnaires sent",
        "bulkQuestionnaireDonePartial": "{{sent}} of {{total}} questionnaires sent — {{failed}} failed",
        "bulkQuestionnaireDonePartialReason": "{{sent}} of {{total}} questionnaires sent — {{failed}} failed ({{reason}})",
        "bulkQuestionnaireAlreadySent": "Already sent",
        "bulkQuestionnaireOpened": "Opened",
        "bulkQuestionnaireSubmitted": "Submitted",
        "bulkQuestionnaireNoRecipient": "No account holder",
        "bulkQuestionnaireNoEmailReason": "No email",
        "bulkQuestionnairePostOnlyReason": "Post only — paper consent only",
        "bulkQuestionnaireReason": "Reason"
    },
    "recipients": {
        "title": "Patients",
        "search": "Search patients or recipients",
        "add": "+ Add patient",
        "noFound": "No patients found",
        "createdSuccess": "Patient created successfully",
        "noRecipient": {
            "title_one": "1 patient without a billing recipient",
            "title_other": "{{count}} patients without a billing recipient",
            "lead": "Nothing can be done for these patients yet – no invoice, no consent, no sending. Assign a billing recipient first; for minors, a parent or guardian.",
            "born": "born {{date}}",
            "minor": "Minor",
            "fromSync": "From practice software",
            "assign": "Assign recipient",
            "assigned": "Billing recipient assigned",
            "delete": "Delete",
            "deleteSyncNote": "This can't be undone. If the practice software sends this patient again, they will reappear here.",
            "deleteBlocked_one": "This patient has 1 invoice and can't be deleted here. Assign a billing recipient first – you'll then see the invoice in the patient record and can decide there.",
            "deleteBlocked_other": "This patient has {{count}} invoices and can't be deleted here. Assign a billing recipient first – you'll then see the invoices in the patient record and can decide there.",
            "deleteFailed": "The patient could not be deleted. Please try again."
        },
        "deleteTitle": "Delete patient",
        "deleteRecipient": "Delete recipient",
        "sendQuestionnaire": "Send Consent Request",
        "sending": "Sending…",
        "send": "Send",
        "sendPortalLink": "Send portal link",
        "noEmail": "(no email address on file)",
        "noEmailShort": "no email",
        "noPhone": "(no phone number on file)",
        "noAddressShort": "no address",
        "portalRegistered": "Portal registered",
        "questionnaireSent": "Consent request sent",
        "questionnaireOpened": "Consent request opened",
        "questionnaireSubmitted": "Consent signed",
        "questionnaireReceived": "Questionnaire received — patient details have been updated.",
        "viewQuestionnaire": "View questionnaire answers",
        "viewConsent": "View consent",
        "consentManualDigital": "Consent – digital send (manually set)",
        "consentManualPost": "Consent – by post (manually set)",
        "consentMissingFor": "Consent missing for: {{names}}",
        "consentMissingForHint": "Every patient needs their own consent. These patients were added after it was signed – have the consent signed again; it then names all patients. Until then their invoices can't be sent.",
        "questionnaireResend": "Resend questionnaire",
        "editRecipient": "Edit patient",
        "failedDelete": "Failed to delete patient. Please try again.",
        "deleteNTitle": "Delete {{count}} patient(s)",
        "sendQuestionnaireTo": "Send a questionnaire link to",
        "willAlsoDelete": "The following will also be deleted:",
        "deleteConfirm": "Are you sure? This cannot be undone.",
        "deleteCascadeIntro": "This will also permanently delete:",
        "deleteAlsoLinked_one": "{{count}} linked patient record",
        "deleteAlsoLinked_other": "{{count}} linked patient records",
        "deleteAlsoInvoices_one_open": "1 open invoice",
        "deleteAlsoInvoices_one_paid": "1 paid invoice",
        "deleteAlsoInvoices_allPaid": "{{count}} invoices (all paid)",
        "deleteAlsoInvoices_withOpen": "{{count}} invoices, {{open}} of which are open",
        "deleteAlsoInvoices_sent": "{{sent}} sent, {{notSent}} not sent",
        "deleteAlsoInvoices_dunning": "M1: {{m1}}, M2: {{m2}}, M3: {{m3}}, Legal: {{legal}}",
        "samePersonBadge": "Patient is the same person",
        "samePersonPatientsCol": "Same as name above",
        "showQuestionnaireNotSubmitted": "Consent open",
        "questionnaireNotSubmitted": "Questionnaire not submitted",
        "showInvoiceNotSent": "Not sent",
        "invoiceNotSent": "Invoice not sent",
        "count_one": "{{count}} patient",
        "count_other": "{{count}} patients",
        "lead": "<strong>{{total}} patients · {{recipientCount}} invoice recipients</strong> on the books. {{withOpen}} have open invoices, {{noEmail}} have no email.",
        "viewAll": "All",
        "viewWithOpen": "Open invoices",
        "viewNotSent": "Invoice not sent",
        "viewNoEmail": "No email",
        "sortNameAsc": "Name A→Z",
        "sortNameDesc": "Name Z→A",
        "sortOpenDesc": "Most open invoices",
        "sortNotSentDesc": "Not sent first",
        "exportCsv": "Export CSV",
        "importCsv": "Import CSV"
    },
    "invoiceTemplates": {
        "settingsTitle": "Invoice templates",
        "settingsDescription": "Services you often bill together – e.g. “Check-up” or “Vaccination”. Insert them in step 3 of “Create invoice”.",
        "new": "New template",
        "newTitle": "New template",
        "editTitle": "Edit template",
        "insert": "Insert template",
        "insertTitle": "Insert template",
        "saveAs": "Save as template",
        "saveNeedsLines": "Enter services with a GOÄ code first",
        "saveTitle": "Save as template",
        "name": "Name",
        "namePlaceholder": "e.g. Check-up",
        "shareWithPractice": "Share with the whole practice",
        "linesToSave_one": "{{count}} service will be saved: {{codes}}",
        "linesToSave_other": "{{count}} services will be saved: {{codes}}",
        "save": "Save template",
        "saving": "Saving …",
        "saved": "Template “{{name}}” saved.",
        "inserted_one": "Template “{{name}}” inserted ({{count}} service).",
        "inserted_other": "Template “{{name}}” inserted ({{count}} services).",
        "shared": "Practice",
        "personal": "Personal",
        "searchPlaceholder": "Search template or GOÄ code",
        "loading": "Loading templates …",
        "emptyWizard": "No templates yet. Save a day's services with “Save as template” – or create templates in the settings.",
        "emptySettings": "No templates yet. Create one here – or save a day's services as a template while creating an invoice.",
        "manage": "Manage templates",
        "noMatch": "No template matches “{{query}}”.",
        "lineCount_one": "{{count}} service",
        "lineCount_other": "{{count}} services",
        "usedCount_zero": "not used yet",
        "usedCount_one": "used once",
        "usedCount_other": "used {{count}} times",
        "byColleague": "by a colleague",
        "editNamed": "Edit template “{{name}}”",
        "deleteNamed": "Delete template “{{name}}”",
        "deleteTitle": "Delete template?",
        "deleteMessage": "The template “{{name}}” will be deleted. Invoices already created don't change.",
        "deleteSharedMessage": "The template “{{name}}” will be deleted for the whole practice. Invoices already created don't change.",
        "delete": "Delete",
        "total": "Total",
        "fixLines": "Please correct the marked services.",
        "dayN": "Day {{n}}",
        "dayCount_one": "{{count}} day",
        "dayCount_other": "{{count}} days",
        "insertedDays_one": "Template “{{name}}” inserted.",
        "insertedDays_other": "Template “{{name}}” spread over {{count}} treatment days from here.",
        "skippedDays_one": "{{count}} day of the template wasn't inserted – there's no further treatment day for it (step 2).",
        "skippedDays_other": "{{count}} days of the template weren't inserted – there aren't enough further treatment days (step 2).",
        "saveScope": "What to save?",
        "scopeDay": "This day only",
        "scopeAll_one": "All {{count}} treatment days",
        "scopeAll_other": "All {{count}} treatment days",
        "linesToSaveDays_one": "{{count}} service on {{days}} days will be saved: {{codes}}",
        "linesToSaveDays_other": "{{count}} services on {{days}} days will be saved: {{codes}}",
        "fromInvoiceSkipped_one": "{{count}} expense from the practice software (e.g. material) isn't taken over – on invoices created by hand, expenses go with a service.",
        "fromInvoiceSkipped_other": "{{count}} expenses from the practice software (e.g. material) aren't taken over – on invoices created by hand, expenses go with a service.",
        "addDay": "Add treatment day",
        "removeDay": "Remove day {{n}}",
        "removeDayShort": "Remove day",
        "emptyDay": "This day has no service yet – add one or remove the day.",
        "errors": {
            "NAME_TAKEN": "There's already a template with this name.",
            "TOO_MANY_TEMPLATES": "Your practice has reached the maximum of {{limit}} templates. Delete templates you no longer need.",
            "INVALID_NAME": "Please enter a name.",
            "INVALID_LINES": "The template needs at least one complete service.",
            "NOT_YOURS": "Only the person who created this template, or an admin, can change it.",
            "load": "The templates couldn't be loaded.",
            "generic": "That didn't work. Please try again."
        }
    },
    "invoiceDrafts": {
        "button": "Drafts",
        "title": "Invoice drafts",
        "empty": "No open drafts.",
        "noPatient": "No patient chosen yet",
        "atStep": "at {{step}}",
        "updated": "last {{when}}",
        "delete": "Delete draft “{{name}}”",
        "continue": "Continue"
    },
    "goaLineEditor": {
        "confirmRow": "Add",
        "rowAdded": "Added",
        "rowUpdated": "Updated",
        "price": "Base fee (€)",
        "justificationRequired": "Required – factor above {{threshold}}",
        "move": "Drag to move",
        "moveRow": "Move line {{position}} of {{count}} – arrow keys up/down",
        "justificationList": "Saved justifications",
        "justificationNumberTip": "Tip: type the number + Enter",
        "manageJustifications": "Manage justifications",
        "saveJustification": "Save as justification",
        "justificationSaved": "Saved to justifications",
        "justificationSaveFailed": "Couldn't save – please try again."
    },
    "justifications": {
        "settingsTitle": "Justifications",
        "settingsDescription": "Saved justifications (Begründungen) for services above the threshold. They're offered in every service's justification field – the number + Enter inserts one directly. Shared by the whole practice.",
        "loading": "Loading justifications …",
        "empty": "No justifications yet. Add one below – or save one while entering a service with \"Save as justification\".",
        "textN": "Justification {{n}}",
        "moveUp": "Move justification {{n}} up",
        "moveDown": "Move justification {{n}} down",
        "deleteN": "Delete justification {{n}}",
        "addLabel": "New justification",
        "addPlaceholder": "e.g. child very restless, examination difficult",
        "add": "Add",
        "save": "Save changes",
        "saving": "Saving …",
        "discard": "Discard",
        "saved": "Saved.",
        "errors": {
            "load": "The justifications couldn't be loaded.",
            "save": "Saving failed – please try again.",
            "duplicate": "A justification is in the list twice.",
            "duplicateRow": "This justification is in the list twice.",
            "invalid": "Every justification needs a text (300 characters at most).",
            "tooMany": "At most {{max}} justifications."
        }
    },
    "invoiceCreate": {
        "title": "New invoice",
        "stepsLabel": "Steps to a new invoice",
        "stepOf": "Step {{current}} of {{total}}",
        "steps": {
            "patient": "Patient",
            "treatment": "Treatment",
            "services": "Services",
            "check": "Check",
            "preview": "Preview"
        },
        "stepHeadings": {
            "patient": "Who is the invoice for?",
            "treatment": "Treatment",
            "services": "Services",
            "check": "Check",
            "preview": "Preview"
        },
        "stepLeads": {
            "patient": "Pick a patient or add a new one – together with the person who pays the invoice.",
            "treatment": "Treating doctor, treatment days and diagnoses. As with every invoice, the invoice date is the day it's sent.",
            "services": "GOÄ codes with quantity, factor and justification, plus expenses and material costs.",
            "check": "Every billing note in one place, before the invoice is created.",
            "preview": "The invoice at a glance, its PDF and what happens after it's sent."
        },
        "entry": "Create invoice",
        "creating": "Creating …",
        "createAndSend": "Create & send",
        "createSendAfterConsent": "Create, send after consent",
        "creatingAndSending": "Creating and sending …",
        "created": {
            "created": "Invoice {{number}} was created.",
            "sent": "Invoice {{number}} was created and sent by email.",
            "waitsForConsent": "Invoice {{number}} was created. It goes out by email as soon as consent is signed.",
            "notSent": "Invoice {{number}} was created but not sent:",
            "reasons": {
                "LEGAL_NOT_ACCEPTED": "Consent is missing.",
                "NO_RECIPIENT_EMAIL": "No email address on file.",
                "POST_ONLY": "The patient only receives post.",
                "EMAIL_FAILED": "The email couldn't be delivered. Check the email settings and send again.",
                "other": "Please send it again here."
            }
        },
        "draft": {
            "idle": "Saved as a draft as soon as you enter something",
            "saving": "Saving draft …",
            "saved": "Draft saved",
            "savedAt": "Draft saved · {{time}}",
            "error": "Draft not saved.",
            "retry": "Try again",
            "discard": "Discard draft",
            "discardTitle": "Discard draft?",
            "discardMessage": "Everything entered for this invoice is deleted. The patient and their details stay.",
            "missing": "This draft no longer exists – maybe an invoice was already created from it. You're starting a new invoice.",
            "loading": "Loading draft …",
            "info": "Everything you enter is saved as a draft automatically. You can stop at any time and continue later under Invoices → Drafts."
        },
        "exit": {
            "button": "Exit",
            "unsavedTitle": "Exit without saving?",
            "unsavedMessage": "The last changes couldn't be saved as a draft and will be lost."
        },
        "check": {
            "ready": "All set – the invoice can be created.",
            "blocked": "Please fix the points marked in red before creating the invoice.",
            "patient": "Patient and invoice recipient",
            "patientMissing": "No patient chosen yet",
            "paidBy": "paid by {{name}}",
            "treatment": "Treatment",
            "services": "Services",
            "delivery": "Delivery",
            "deliveryLoading": "Loading contact details …",
            "deliveryBoth": "By email and by post",
            "deliveryPostOnly": "By post only – no email address on file",
            "deliveryEmailOnly": "Digital only – no complete postal address",
            "deliveryNone": "Neither email nor postal address – please add them in the patient record",
            "consent": "Consent",
            "consentMissing": "Not signed yet – creating works, sending only once consent is given.",
            "goa": "GOÄ check",
            "goaOk": "No exclusions, frequency limits kept.",
            "goaLoading": "Checking …",
            "goaFailed": "The GOÄ check wasn't possible just now. You can still create the invoice.",
            "goaFindings_one": "{{count}} finding – please review and confirm below.",
            "goaFindings_other": "{{count}} findings – please review and confirm below.",
            "goaAllAcked_one": "{{count}} finding confirmed.",
            "goaAllAcked_other": "{{count}} findings confirmed.",
            "goaPending": "Almost done – please confirm the GOÄ findings below.",
            "goaFindingsTitle": "GOÄ findings",
            "goaFindingsLead": "Please review these services against the GOÄ billing rules. Correct them in step 3 – or confirm that you bill them like this on purpose (e.g. with a justification).",
            "goaDuplicate": "No. {{nr}} on {{date}} entered {{count}} times – give the time or organ in the justification",
            "goaConflict": "No. {{a}} and No. {{b}} on {{date}} – can't be billed together",
            "goaOverLimit": "No. {{nr}} on {{date}} {{billed}} times – {{max}} allowed per session",
            "goaMissingCode": "No. {{nr}} on {{date}} without No. {{requires}}",
            "goaNoDate": "no date",
            "goaAck": "Bill like this on purpose",
            "goaFix": "Change services",
            "legal": {
                "title": "Note on GOÄ billing",
                "intro": "Medinvoice® supports the creation of private invoices under the German medical fee schedule (GOÄ).",
                "introChecker": "Medinvoice® supports the creation and checking of private invoices under the German medical fee schedule (GOÄ). The notes and check functions provided are for support only and do not replace your own review.",
                "responsibility": "Responsibility for the accuracy, completeness and lawfulness of the invoice lies with the billing doctors or the billing practice.",
                "liability": "To the extent permitted by law, Medinvoice® accepts no liability for incorrect GOÄ codes, inadmissible combinations of services, incorrect factors or other billing errors."
            },
            "rules": {"onlyWith":"No. {{nr}} on {{date}} next to No. {{others}} – not billable like this","limit":"No. {{nr}}: {{count}} times {{window}} – {{max}} allowed","limitPerUnit":"No. {{nr}} on {{date}} {{count}} times – {{max}} allowed {{per}}, please check","limitNeedsReason":"No. {{nr}}: {{count}} times {{window}} – more than {{max}} needs a justification","tierOver":"No. {{nr}}: {{count}} tests – this tier holds {{max}}","tierOrder":"No. {{nr}} only once No. {{previous}} is full ({{count}} of {{size}})","tierTotal":"No. {{nr}}: {{count}} tests together – {{max}} allowed per treatment case","repeatTime":"No. {{nr}} on {{date}} {{count}} times – time needed on each line","repeatReason":"No. {{nr}} on {{date}} {{count}} times – a justification is needed as well as the time","onceBeside":"No. {{nr}}: {{count}} times in the treatment case next to No. {{beside}} – billable once only","detail":"No. {{nr}} on {{date}} – the invoice has to name {{detail}}","comboReason":"No. {{nr}} on {{date}} next to each other – justification needed"},
            "ruleWindow": {"treatmentCase":"in the treatment case","calendarYear":"in the calendar year","sixMonths":"in six months","year":"in twelve months","invoice":"on this invoice","session":"per session","day":"on the day"},
            "ruleDetail": {"time":"the time","organ":"the organ","medication":"the medication","examinationType":"the type of examination","parameters":"the parameters examined","viruses":"the viruses examined","germs":"the germs examined","fungi":"the fungi examined","parasites":"the parasites examined","markers":"the markers examined","material":"the material and microorganism","skeletalPart":"the part of the skeleton","tissue":"the tissue","services":"the individual services","indication":"the indication"},
            "rulePer": {"material":"per material","fungus":"per fungus","joint":"per joint","skeletalPart":"per part of the skeleton","side":"per side","visit":"per visit","identification":"per identification"},
            "goaSingleRate": "No. {{nr}} on {{date}} at factor {{factor}} – billable at the single rate (factor 1) only",
            "billingNotes": "Billing notes",
            "billingNotesPending": "Almost done – please confirm the billing notes below.",
            "billingNotesLead": "Please review these services. Correct them in step 3 – or confirm that you bill them like this on purpose.",
            "billingNotesConfirmFirst_one": "Please first confirm {{count}} billing note in step 4.",
            "billingNotesConfirmFirst_other": "Please first confirm {{count}} billing notes in step 4.",
            "goaUpgrade": "With Pro, Medinvoice also checks here which GOÄ codes can't be billed together and how often a code is allowed per session.",
            "goaConfirmFirst_one": "Please first confirm {{count}} GOÄ finding in step 4.",
            "goaConfirmFirst_other": "Please first confirm {{count}} GOÄ findings in step 4.",
            "goaToCheck": "To step 4"
        },
        "suggestions": {
            "title": "Suggestions",
            "diagnosisTitle": "Matching the diagnoses",
            "upgrade": "With Plus, Medinvoice suggests services and factors here – from your own invoices.",
            "basis": {
                "doctor": "From your {{count}} invoices – updated every night.",
                "praxis": "From your practice's {{count}} invoices – there aren't enough of your own yet.",
                "templates": "Not enough invoices yet for suggestions from your billing – for now from your templates.",
                "none": "No basis for suggestions yet."
            },
            "kind": {
                "add": "Add No. {{code}} ({{date}})",
                "remove": "Check No. {{code}} ({{date}})",
                "factor": "No. {{code}}: factor {{factor}} instead of {{current}} ({{date}})"
            },
            "reasons": {
                "pair": {
                    "doctor": "In {{share}} % of your treatments with No. {{base}} you also bill No. {{code}} ({{together}} of {{visits}}).",
                    "praxis": "In {{share}} % of your practice's treatments with No. {{base}}, No. {{code}} is billed too ({{together}} of {{visits}})."
                },
                "diagnosis": {
                    "doctor": "With “{{diagnosis}}” you bill No. {{code}} in {{share}} % of cases ({{together}} of {{invoices}} invoices).",
                    "praxis": "With “{{diagnosis}}” your practice bills No. {{code}} in {{share}} % of cases ({{together}} of {{invoices}} invoices)."
                },
                "factor": {
                    "doctor": "Your usual factor for No. {{code}} is {{factor}} ({{lines}} of {{total}} times).",
                    "praxis": "Your practice's usual factor for No. {{code}} is {{factor}} ({{lines}} of {{total}} times)."
                },
                "neverTogether": {
                    "doctor": "You've never billed No. {{code}} and No. {{other}} on the same day, though you use both often ({{codeVisits}} and {{otherVisits}} times). A mistake? Apply removes No. {{code}}.",
                    "praxis": "Your practice has never billed No. {{code}} and No. {{other}} on the same day, though both are common ({{codeVisits}} and {{otherVisits}} times). A mistake? Apply removes No. {{code}}."
                },
                "template": "Your template “{{template}}” also has No. {{code}} with these services."
            },
            "apply": "Apply",
            "dismiss": "Dismiss",
            "showAll": "Show all {{count}}",
            "showFewer": "Show fewer"
        },
        "preview": {
            "to": "Invoice to",
            "patient": "Patient",
            "doctor": "Treating doctor",
            "colCode": "GOÄ",
            "colDescription": "Service",
            "colQty": "Qty",
            "colFactor": "Factor",
            "colAmount": "Amount",
            "justification": "Justification: {{text}}",
            "fees": "Services",
            "material": "Expenses",
            "total": "Total",
            "afterCreate": "Medinvoice assigns the invoice number and date (= the day it's sent). After creating, the invoice opens – you can send it from there.",
            "viewPdf": "View PDF",
            "pdfLoading": "Creating PDF …",
            "pdfFailed": "The preview couldn't be created. Please try again.",
            "pdfCardTitle": "Check the invoice as a PDF",
            "pdfCardLead": "Exactly how the recipient gets it – still numbered “VORSCHAU”. Nothing is created.",
            "pdfIncomplete":"Available once patient, treatment and services are complete.",
            "sendNow": "With “Create & send” the invoice goes out by email to {{email}} right away.",
            "sendAfterConsent": "Consent is still missing. With “Create, send after consent” the invoice goes out by email to {{email}} as soon as it's signed.",
            "sendNone": "Sending isn't possible here:",
            "sendNoneReasons": {
                "emailOff": "Email sending is switched off in the settings. Send the invoice from its page after creating it.",
                "postOnly": "The patient only receives post. Send the invoice by post from its page after creating it.",
                "noEmail": "No email address on file. Send the invoice by post after creating it, or add the email address.",
                "consent": "Consent is missing. Get it in step 1 – or create now and send later."
            },
            "pdfTitle": "Invoice preview (not created yet)"
        },
        "schedule": {
            "title": "If you send the invoice today",
            "loading": "Working out the dates …",
            "unavailable": "The dates couldn't be loaded.",
            "sent": "Sent – this is the invoice date",
            "due": "Due – overdue from the next day",
            "level1": "Payment reminder (M1)",
            "level2": "Dunning notice (M2)",
            "level3": "Final notice (M3)",
            "level4": "Collections handover possible",
            "sendMode": {
                "email": "by email",
                "letter": "by post",
                "both": "by email and post"
            },
            "fee": "fee {{fee}}",
            "legalSelf": "you decide and hand over yourself",
            "legalPaywise": "handover to Paywise – you trigger it",
            "hint": "Dunning runs automatically according to Settings → Dunning, as long as the invoice isn't paid and dunning isn't paused. If it's sent later, all dates move accordingly."
        },
        "createErrors": {
            "TRIAL_INVOICE_LIMIT": "During the trial you can have at most {{limit}} invoices. Please activate your subscription to create more.",
            "OWNER_REQUIRED": "Please choose the doctor the invoice belongs to in the Treatment step.",
            "PATIENT_NOT_FOUND": "The patient wasn't found – please choose them again in the first step.",
            "NO_RECIPIENT": "This patient has no invoice recipient.",
            "INVALID_SERVICES": "Some services are incomplete – please check the Services step.",
            "NO_SERVICES": "The invoice has no services.",
            "NO_DIAGNOSIS": "The invoice needs at least one diagnosis (step 2).",
            "generic": "The invoice couldn't be created. Please try again."
        },
        "patient": {
            "searchPlaceholder": "Search name or date of birth …",
            "searchHint": "Type the name or date of birth, e.g. “Schmidt 1980”.",
            "loading": "Loading patients",
            "results": "Matching patients",
            "paidBy": "paid by {{name}}",
            "noResults": "No patient found for “{{query}}”.",
            "createNew": "Add a new patient",
            "createNewHint": "Together with the person who pays the invoice – the patient themselves or e.g. a parent.",
            "born": "born {{date}}",
            "changePatient": "Choose another patient",
            "noRecipient": "This patient has no invoice recipient. Set who pays the invoice in the patient record.",
            "loadingRecipient": "Loading invoice recipient …",
            "recipient": "Invoice recipient",
            "self": "self",
            "noAddress": "No complete postal address",
            "noEmail": "No email address",
            "consent": "Consent",
            "consentDigital": {
                "signed": "signed",
                "requested": "requested",
                "missing": "missing",
                "postOnly": "post only"
            },
            "consentPost": {
                "signed": "signed",
                "covered": "allowed by digital consent",
                "missing": "missing"
            },
            "consentNotRequired": "Your practice doesn't require consent for sending.",
            "noDeliveryWay": "Neither email nor postal address on file – the invoice can't be sent like this. Add contact details in the patient record.",
            "openRecord": "Open patient record"
        },
        "consent": {
            "leadMissing": "Consent for sending is still missing. Request it now – you can create the invoice without it.",
            "leadRequested": "The consent link was sent and is waiting for a signature. Send it again or get consent on site.",
            "leadPost": "This patient only receives invoices by post. They consent to that on paper or by QR code.",
            "leadNotNamed": "The consent on file doesn't cover {{patient}} – every patient needs their own. Have it signed again; the form names all of the recipient's patients. You can create the invoice without it.",
            "postAlreadySigned": "Consent for post is already on file.",
            "present": "Patient is at the practice",
            "absent": "Patient isn't here",
            "qr": "Show QR code",
            "qrHint": "Scans with their phone and signs there",
            "qrTitle": "Consent by QR code",
            "qrDialogHint": "The patient scans the code with their phone, completes their details and signs. This window closes once consent arrives.",
            "qrPostTitle": "Consent to postal delivery",
            "qrPostHint": "Scans with their phone and signs consent to postal delivery",
            "qrAlt": "Consent QR code for {{name}}",
            "qrLoading": "Creating QR code…",
            "waiting": "Waiting for the signature…",
            "paper": "Sign on paper",
            "paperHint": "Print the form, confirm the signature",
            "email": "Send link by email",
            "emailAgain": "Send link by email again",
            "emailConfirm": "Send the consent link for {{name}} to",
            "noEmail": "No email address on file",
            "sms": "Send link by SMS",
            "smsAgain": "Send link by SMS again",
            "smsCost": "€0.09",
            "smsCostNote": "This SMS costs €0.09. The link is valid for 30 days.",
            "smsTo": "To",
            "smsLanguage": "Language",
            "noPhone": "No phone number on file",
            "send": "Send",
            "sending": "Sending…",
            "emailSent": "Consent link sent to {{email}}.",
            "smsSent": "Consent link sent by SMS to {{phone}}.",
            "signed": "Consent signed – the invoice can be sent.",
            "paperSaved": "Paper consent saved.",
            "errors": {
                "qr": "The QR code couldn't be created. Please try again.",
                "email": "The email couldn't be sent. Please try again.",
                "sms": "The SMS couldn't be sent. Please try again.",
                "postOnly": "This patient only receives post – consent works on paper or by QR code only."
            }
        },
        "treatment": {
            "doctor": "Treating doctor",
            "doctorPlaceholder": "Please choose",
            "doctorStaffHint": "Invoices always belong to one of the practice's doctors.",
            "doctorOthersHint": "You may also create invoices for colleagues – without a choice it's your own.",
            "doctorLoading": "Loading …",
            "days": "Treatment days",
            "daysHint": "You'll enter the services for each day in the next step.",
            "removeDay": "Remove {{date}}",
            "newDay": "Another treatment day",
            "addDay": "Add day",
            "noTreatmentDay": "At least one treatment day is needed.",
            "treatmentInFuture": "A treatment day is in the future.",
            "diagnoses": "Diagnoses",
            "diagnosisPlaceholder": "e.g. I10.90 Essential hypertension",
            "addDiagnosis": "Add",
            "diagnosisHint": "Press Enter to add. Diagnoses appear on the invoice in this order.",
            "diagnosisSuggestions": "Suggestions",
            "frequentDiagnoses": "Used often",
            "icdCaption": "ICD-10-GM",
            "icdTerm": "also: {{term}}",
            "icdSource": "Source: ICD-10-GM {{version}}, BfArM. Die Erstellung erfolgt unter Verwendung der maschinenlesbaren Fassung des BfArM.",
            "icdSourceLink": "Sources",
            "certainty": "Certainty",
            "certaintyNames": {
                "G": "confirmed",
                "V": "suspected",
                "A": "ruled out",
                "Z": "condition after"
            },
            "side": "Side",
            "addSide": "Add side",
            "sideNames": {
                "R": "right",
                "L": "left",
                "B": "both sides"
            },
            "relatedTitle": "Often entered together",
            "relatedAdd": "Add “{{text}}”",
            "relatedReason": {
                "doctor": "On {{share}} % of your invoices with “{{diagnosis}}” ({{together}} of {{invoices}}).",
                "praxis": "On {{share}} % of your practice's invoices with “{{diagnosis}}” ({{together}} of {{invoices}})."
            },
            "removeDiagnosis": "Remove “{{text}}”",
            "noDiagnosis": "Please enter at least one diagnosis – without one, private health insurers usually don't reimburse an invoice.",
            "summaryOneDay": "Treatment on {{date}}",
            "summaryDays_one": "{{count}} treatment day",
            "summaryDays_other": "{{count}} treatment days",
            "summaryDiagnoses_zero": "No diagnosis",
            "summaryDiagnoses_one": "{{count}} diagnosis",
            "summaryDiagnoses_other": "{{count}} diagnoses"
        },
        "services": {
            "dayTitle": "Treatment on {{date}}",
            "emptyDay": "No service entered for this day yet. Add one, or remove the day in the Treatment step.",
            "fixToContinue": "Please complete the services marked in red to continue.",
            "problems": {
                "codeMissing": "GOÄ code missing",
                "descriptionMissing": "Description missing",
                "priceMissing": "Base fee missing",
                "factorOutOfRange": "Factor outside the allowed range",
                "justificationMissing": "A justification is needed above the threshold",
                "materialIncomplete": "Expense without description or amount"
            },
            "summaryLines_one": "{{count}} service",
            "summaryLines_other": "{{count}} services",
            "summaryMaterial": "incl. expenses {{amount}}"
        },
        "overview": "Overview",
        "overviewCollapse": "Collapse overview",
        "overviewExpand": "Expand overview",
        "summaryDone": "Done",
        "summaryCurrent": "In progress",
        "change": "Change",
        "back": "Back",
        "next": "Next",
        "footerWarnings_one": "{{count}} warning on the services – show",
        "footerWarnings_other": "{{count}} warnings on the services – show",
        "total": "Total",
        "create": "Create",
        "noPermission": "You don't have permission to create invoices. Please ask your practice administrator."
    },
    "invoices": {
        "title": "Invoices",
        "search": "Invoice or patient…",
        "upload": "Upload Invoice",
        "uploadHistory": "Upload History",
        "uploadHistoryTitle": "Upload History",
        "uploadHistoryEmpty": "No uploads yet.",
        "uploadHistoryId": "Invoice No.",
        "uploadHistoryPatient": "Patient",
        "uploadHistoryFile": "File",
        "uploadHistoryDate": "Date",
        "uploadHistoryInvoices": "Invoices",
        "uploadHistoryAmount": "Amount",
        "uploadHistoryStatus": "Status",
        "noFound": "No invoices found",
        "overdueAt": "Overdue since {{date}}",
        "overdue": "Overdue",
        "showPaid": "Show paid",
        "showWrittenOff": "Show written off",
        "lead": "<strong>{{total}} invoices</strong> on file. <em>{{open}} open, {{overdue}} overdue, {{unsent}} not yet sent.</em>",
        "viewAll": "All",
        "viewOpen": "Open",
        "viewOverdue": "Overdue",
        "viewUnsent": "Not sent",
        "viewPaid": "Paid",
        "viewWrittenOff": "Written off",
        "exportCsv": "Export CSV/DATEV",
        "sortLabel": "Sort: {{label}}",
        "daysOverdue": "{{days}} d overdue",
        "daysOverdueWithFine": "{{days}} d overdue · incl. €{{fine}} fine",
        "dueInDays": "due in {{days}} d",
        "createdAgo": "created {{days}} d ago",
        "askedAgo": "asked {{days}} d ago",
        "paidAfterSent": "paid {{date}} · {{days}} d after sent",
        "selectedCount": "{{count}} selected",
        "showingRange": "Showing {{from}}–{{to}} of {{total}}",
        "send": "Send",
        "sendPortalLink": "Send portal link",
        "sendViaPost": "Send via post",
        "delete": "Delete",
        "view": "View",
        "selected": "selected",
        "addTags": "Add tags",
        "bulkTagsApplied_one": "Tag added to {{count}} invoice",
        "bulkTagsApplied_other": "Tag added to {{count}} invoices",
        "count_one": "{{count}} Invoice",
        "count_other": "{{count}} Invoices",
        "perPage": "Per page:",
        "total": "total",
        "selectAll": "Select all",
        "filterPatients": "Filter by patient name",
        "patientAccountHint": "Invoice recipient: {{account}}",
        "linkedAccountHolder": "Invoice recipient for this patient",
        "ownerSystem": "No doctor assigned",
        "ownerUnknown": "Unknown doctor",
        "ownerTitle": "Invoice of {{name}}",
        "bulkSend": {
            "title": "Send {{count}} portal link(s)",
            "willSend": "{{count}} will be sent for the first time",
            "willResend": "{{count}} already sent — will receive a new link",
            "noEmail": "{{count}} missing email address",
            "postOnly": "{{count}} post only (digital sending disabled)",
            "legalNotAccepted": "{{count}} awaiting signed consent (Einwilligung)",
            "cannotSend": "{{count}} skipped (paid or written off)",
            "done_one": "{{count}} portal link sent",
            "done_other": "{{count}} portal links sent",
            "donePartial": "{{sent}} of {{total}} portal links sent — {{failed}} failed",
            "donePartialReason": "{{sent}} of {{total}} portal links sent — {{failed}} failed ({{reason}})"
        },
        "bulkLetter": {
            "title": "Send {{count}} invoice(s) via post",
            "canSend": "{{count}} ready to send",
            "noAddress": "{{count}} missing address",
            "noConsent": "{{count}} without consent (Einwilligung)",
            "letterSent": "{{count}} already sent by post",
            "cannotSend": "{{count}} skipped (paid or written off)",
            "pages": "Pages",
            "cost": "Cost",
            "total": "Total cost",
            "totalPartial": "Total cost (partial)",
            "done_one": "{{count}} letter sent",
            "done_other": "{{count}} letters sent",
            "donePartial": "{{sent}} of {{total}} letters sent — {{failed}} failed",
            "donePartialReason": "{{sent}} of {{total}} letters sent — {{failed}} failed ({{reason}})"
        },
        "bulkDelete": {
            "title": "Delete {{count}} invoice(s)",
            "willDelete": "{{count}} will be deleted",
            "cannotDelete": "{{count}} cannot be deleted (sent, paid, written off, or in dunning)"
        },
        "csvExport": {
            "title": "Export CSV/DATEV",
            "step1": "Filter invoices",
            "step2": "Choose columns",
            "fromDate": "From date",
            "toDate": "To date",
            "status": "Status",
            "statusAll": "All statuses",
            "statusOpen": "Open",
            "statusPaid": "Paid",
            "statusOverdue": "Overdue",
            "statusWrittenOff": "Written off",
            "amountMin": "Min. amount (€)",
            "cancel": "Cancel",
            "next": "Next",
            "back": "Back",
            "export": "Export",
            "invoiceCount": "{{count}} invoices match",
            "formatCsv": "CSV",
            "formatCsvDesc": "Custom columns, opens in Excel",
            "formatExtf": "DATEV / EXTF",
            "formatExtfDesc": "Buchungsstapel file for your Steuerberater",
            "checkingReadiness": "Checking DATEV settings…",
            "datevReady": "DATEV settings are configured — ready to export.",
            "datevNotReady": "DATEV settings are incomplete.",
            "datevGoToSettings": "Go to Settings → DATEV",
            "columnsHint": "Choose which columns to include in the export.",
            "selectAll": "Select all",
            "selectNone": "Deselect all",
            "columnsSelected": "{{count}} columns selected",
            "colInvoiceNr": "Invoice number",
            "colDate": "Date",
            "colDueDate": "Due date",
            "colPatient": "Patient",
            "colRecipient": "Recipient",
            "colAmount": "Amount (€)",
            "colPaid": "Paid (€)",
            "colStatus": "Status",
            "colDunning": "Dunning level",
            "colTag": "Tag"
        }
    },
    "praxisSoftwareSync": {
        "title": "Practice Software Sync",
        "openSettings": "Open settings",
        "description": "Automatically sync patient data (GDT) and invoice files (.dat / PADneXt .xml) from your practice software's local export folders — no manual upload needed. Chrome/Edge only.",
        "unsupportedBrowser": "This feature requires Chrome or Edge. Please continue using the manual upload on the Invoices page in this browser.",
        "gdtFolder": "Patient data folder (GDT)",
        "datFolder": "Invoice data folder (.dat, PADneXt .xml)",
        "connected": "Connected",
        "notConnected": "Not connected",
        "needsReconnect": "Permission needed",
        "folderNotFound": "The {{folder}} could not be found — it may have been renamed, moved, or deleted. Please reconnect it.",
        "checkingConnection": "Checking…",
        "connectBtn": "Connect folder",
        "reconnectBtn": "Reconnect",
        "disconnectBtn": "Disconnect folder",
        "syncNow": "Sync now",
        "syncing": "Syncing…",
        "uploading": "Uploading",
        "processing": "Processing",
        "lastSync": "Last sync",
        "logUploaded": "Uploaded",
        "logInvoicesUploaded_one": "{{count}} invoice uploaded",
        "logInvoicesUploaded_other": "{{count}} invoices uploaded",
        "logPatientCreated": "Patient created",
        "logPatientCreatedNeedsRecipient": "Patient created — needs a billing recipient assigned (minor, no guardian in source data)",
        "logPatientUpdated": "Patient updated",
        "logSkipped": "Skipped — awaiting staff confirmation next time",
        "unknownError": "Unknown error",
        "nothingToSync": "No new or changed files found.",
        "syncAlreadyRunning": "A sync is already running — please wait a moment.",
        "blockingTitle": "Syncing with your practice software…",
        "blockingStep": "File {{index}} of {{total}}",
        "blockingWarning": "Please don't navigate away or close this tab until the sync finishes.",
        "badgeSyncing": "Syncing with practice software…",
        "badgeDone": "Done — data is up to date",
        "reviewTitleNew": "New patient from practice software",
        "reviewTitleUpdate": "Updated patient from practice software",
        "reviewAlreadyImportedBadge": "Already imported",
        "reviewPatientSummaryHeading": "From the practice software",
        "reviewRecipientHeading": "Billing recipient",
        "reviewSelfDisabledMinor": "This patient is a minor — pick or add a billing recipient instead.",
        "reviewRecipientRequired": "Please choose or add a billing recipient.",
        "reviewContinue": "Continue",
        "reviewRecipientLater": "Assign later",
        "reviewCancel": "Cancel import",
        "reviewAdd": "Add",
        "reviewSave": "Save",
        "reviewAddConsentBtn": "Add and send Einwilligung",
        "reviewSaveConsentBtn": "Save and send Einwilligung",
        "reviewAgentProcessed": "This patient was already processed by the desktop app at {{time}}.",
        "reviewQrTitle": "Scan to complete consent",
        "reviewQrLead": "Let the patient scan this code with their phone to sign consent on the spot.",
        "reviewQrFailed": "Could not generate the QR code. The patient was still saved — you can send consent from the Patients page instead.",
        "logConsentSent": "consent link sent",
        "logConsentFailed": "consent link failed ({{reason}})",
        "logImportCancelled": "Import cancelled — patient reverted",
        "logCancelFailed": "cancel failed ({{reason}})",
        "logRecipientAssigned": "Billing recipient assigned",
        "autoParseLabel": "Allow auto-parsing of connected folder data",
        "autoParseOnNote": "Auto-processing is on (Settings → Praxis Software Sync).",
        "autoParseOffNote": "Auto-processing is off — new files wait for confirmation (Settings → Praxis Software Sync).",
        "autoParseDesc": "When on, new or changed files are processed automatically. When off (default), you'll be asked to confirm before each new or changed file is parsed.",
        "confirmTitle": "New files detected",
        "confirmIntro_one": "{{count}} new or changed file was found. Start parsing it?",
        "confirmIntro_other": "{{count}} new or changed files were found. Start parsing them?",
        "confirmTitleRecheck": "Re-checking already processed files",
        "confirmIntroRecheck_one": "{{count}} file was checked again — it was already processed before and hasn't changed. Start parsing it anyway?",
        "confirmIntroRecheck_other": "{{count}} files were checked again — they were already processed before and haven't changed. Start parsing them anyway?",
        "confirmAlreadyProcessed": "Already processed",
        "confirmAlreadyProcessedHint": "This file was already processed before and hasn't changed since.",
        "confirmDecline": "Not now",
        "confirmStart": "Start parsing",
        "resultsTitle": "Sync results",
        "summaryInvoices": "Invoices",
        "summaryAccountPatients": "Recipients",
        "summaryLinkedPatients": "Linked patients",
        "summaryTotal": "Total amount",
        "summarySamePerson": "{{count}} invoice where the billed patient is the invoice recipient",
        "summarySamePerson_other": "{{count}} invoices where the billed patient is the invoice recipient",
        "duplicateUploadSame": "You already uploaded this file on {{date}}.",
        "duplicateUploadOther": "This file was already uploaded by {{name}} on {{date}}.",
        "duplicateUploadUnknownDoctor": "another member of the practice",
        "emailsSent": "{{count}} email sent",
        "emailsSent_other": "{{count}} emails sent",
        "emailsFailed": "{{count}} send failed – please send manually",
        "emailsFailed_other": "{{count}} sends failed – please send manually",
        "sendFailuresTitle": "These invoices weren't sent",
        "sendFailureReasonNO_RECIPIENT_EMAIL": "No email address on file",
        "sendFailureReasonLEGAL_NOT_ACCEPTED": "Consent (Einwilligung) not yet signed — send it first",
        "sendFailureReasonPOST_ONLY": "Patient is marked \"Post only\"",
        "sendFailureReasonEMAIL_FAILED": "Email delivery failed",
        "sendFailureReasonUnknown": "Could not be sent",
        "whatsNextMissingEmailBody": "Complete recipient details — at least one imported recipient has no email yet. Email is required to send invoices, portal links, and questionnaires.",
        "whatsNextNeedsRecipientBody_one": "1 patient was synced without a billing recipient — they're a minor and the practice software record didn't include a parent/guardian. Assign a recipient before invoicing them.",
        "whatsNextNeedsRecipientBody_other": "{{count}} patients were synced without a billing recipient — they're minors and the practice software record didn't include a parent/guardian. Assign a recipient before invoicing them.",
        "whatsNextPatientsCta": "Go to patients",
        "patientsSyncedTitle": "{{count}} patient synced",
        "patientsSyncedTitle_other": "{{count}} patients synced",
        "badgeCreated": "New",
        "badgeUpdated": "Updated",
        "badgeNeedsRecipient": "Needs recipient",
        "filesFailedTitle": "These files failed",
        "confirmDisconnect": "Disconnect the {{folder}}? Medinvoice will stop reading it until you reconnect.",
        "confirmBreakdownPatients": "{{count}} patient file (GDT)",
        "confirmBreakdownPatients_other": "{{count}} patient files (GDT)",
        "confirmBreakdownInvoices": "{{count}} invoice file (.dat)",
        "confirmBreakdownInvoices_other": "{{count}} invoice files (.dat)",
        "gdtFolderShort": "Patient data",
        "datFolderShort": "Invoice data",
        "panelTitle": "Practice Software Sync",
        "dashboardNudge": "Connect your practice software's export folders to sync patient and invoice data automatically — no manual upload.",
        "pendingBadge": "{{count}} file awaiting confirmation",
        "pendingBadge_other": "{{count}} files awaiting confirmation",
        "panelNoActivity": "No activity yet",
        "goToPage": "Open Sync",
        "pageLeadConnected": "Last synced {{datetime}}.",
        "activityTitle": "Activity",
        "logColTime": "Time",
        "logColType": "Type",
        "logColFile": "File",
        "logColResult": "Result",
        "clearLog": "Clear",
        "confirmClearLog": "Clear the activity log? This only removes the history shown here — it doesn't affect any synced patients or invoices."
    },
    "devices": {
        "title": "Device management",
        "description": "Desktop apps connected to this practice. The desktop app watches your practice software's export folder and imports patients automatically, without a browser tab open.",
        "rowTitle": "Enrolled devices",
        "rowDesc": "Generate a one-time code to enroll a new device, or manage existing ones below.",
        "generateBtn": "Generate enrollment code",
        "generating": "Generating…",
        "refreshBtn": "Refresh",
        "enrollmentCodeLabel": "Enrollment code",
        "renewalCodeLabel": "Renewal code",
        "codeExpires": "Expires {{time}}",
        "copyBtn": "Copy",
        "copied": "Copied",
        "copyError": "Could not copy to clipboard.",
        "loadError": "Could not load devices.",
        "generateError": "Could not generate an enrollment code.",
        "renewError": "Could not generate a renewal code.",
        "revokeError": "Could not revoke this device.",
        "deleteError": "Could not delete this device.",
        "emptyState": "No devices enrolled yet.",
        "neverSeen": "Never",
        "detailsApp": "Desktop app {{version}}",
        "detailsGdt": "GDT {{version}}",
        "colLabel": "Device",
        "colLastSeen": "Last seen",
        "colStatus": "Status",
        "colExpires": "Expires",
        "colShared": "Shared PC",
        "colActions": "Actions",
        "sharedLabel": "Shared PC",
        "sharedHint": "Multiple doctors use this PC — the desktop app will ask which doctor each import is for, instead of assuming whoever enrolled it.",
        "sharedToggleError": "Could not update — try again.",
        "status": {
            "active": "Active",
            "expiring_soon": "Renew soon",
            "expired": "Expired",
            "revoked": "Revoked"
        },
        "connection": {
            "connected": "Connected",
            "notConnected": "Not connected"
        },
        "renewBtn": "Renew",
        "renewing": "Renewing…",
        "revokeBtn": "Revoke",
        "revokeConfirm": "Revoke \"{{label}}\"? It will immediately lose access and cannot be undone.",
        "deleteBtn": "Delete",
        "deleteConfirm": "Delete \"{{label}}\"? This removes it completely, including its connection history, and cannot be undone. Only possible while it isn't currently connected."
    },
    "syncMethod": {
        "prompt": "How should patient files reach Medinvoice? Pick one.",
        "status": {
            "folderConnected": "Folder connected",
            "notSetUp": "Not set up",
            "unsupported": "Not supported in this browser",
            "devicesConnected_one": "{{count}} device connected",
            "devicesConnected_other": "{{count}} devices connected",
            "notConnected": "Not connected",
            "paused": "Paused"
        },
        "pausedBanner": "Desktop app sync is paused — nothing will be imported until this is turned back off in Settings → Praxis Software Sync.",
        "label": "Sync method",
        "browser": {
            "title": "In the browser",
            "caption": "Reads the export folders while Medinvoice is open in a tab. Handles patient and invoice files."
        },
        "agent": {
            "title": "Desktop app (Windows)",
            "caption": "Runs in the background on the practice PC — no tab needed. Patient files, and invoice files too if you like."
        },
        "leadAgent": "Install the desktop app on the practice PC and it imports patient files by itself.",
        "unsupportedBrowser": "This browser can't read folders, so patient files need another route — see below.",
        "unsupported": {
            "title": "This browser can't read folders",
            "titleNamed": "{{browser}} can't read folders",
            "text": "Syncing from your practice software's export folder in the browser needs Chrome, Edge or another Chromium-based browser. Firefox and Safari don't offer folder access.",
            "optionBrowser": "Open Medinvoice in Chrome, Edge, Opera or Vivaldi on this computer and connect the folder there.",
            "optionApp": "Or install the desktop app on the practice PC (Windows). It imports patient files in the background and works with any browser.",
            "cta": "Use the desktop app",
            "hint": "Invoice files (.dat / PADneXt .xml) can still be uploaded manually on the Invoices page in any browser."
        },
        "agentNeedsAdmin": "Only a Doctor, an Admin or someone with settings access can set up the desktop app. Ask them to enroll this PC.",
        "invoiceNote": "The desktop app can watch invoice files (.dat / PADneXt .xml) too, if you gave it an invoice folder when you connected it. Prefer to sync invoices in the browser instead?",
        "invoiceNoteAction": "Switch to browser"
    },
    "praxisSoftwareSyncSettings": {
        "description": "Shared policy for both the browser folder sync and the desktop app. Live connection status, folders, and devices are on the Praxis Software Sync page — see the nav.",
        "loadError": "Could not load these settings.",
        "saveError": "Could not save these settings.",
        "autoParseTitle": "Process new files automatically",
        "autoParseDesc": "New or changed invoice files (PAD/PADneXt) are imported automatically. The usual upload dialog appears.",
        "autoSendConsentTitle": "Send Einwilligung automatically",
        "autoSendConsentDesc": "When a synced patient needs consent and an email address is on file, the link can be sent right away from the dialog. Currently applies to the desktop app only.",
        "syncPausedTitle": "Pause desktop app sync",
        "syncPausedDesc": "Stops the desktop app from importing anything, without revoking any device. Turn this back off to resume — nothing needs to be re-enrolled.",
        "importTitle": "Importing invoice files",
        "matrixTitle": "What happens when …",
        "matrixDesc": "For each event, choose whether it is filed in the patient's record in your practice software, and whether a pop-up on this PC comes with it.",
        "colEvent": "Event",
        "colPractice": "Practice software",
        "colPopup": "Pop-up on this PC",
        "consentTitle": "Signed consent",
        "consentHint": "The patient signs the Einwilligung",
        "invoiceSentTitle": "Invoice sent",
        "invoiceSentHint": "The invoice email goes to the patient",
        "paidTitle": "Invoice paid",
        "paidHint": "The invoice is paid in full"
    },
    "syncHowItWorks": {
        "button": "How it works",
        "title": "How syncing works",
        "aboutTitle": "What does this mean?",
        "about": "The practice software sync transfers the patient and invoice data your practice software has already exported into Medinvoice automatically. There are two ways: in the browser, or with the desktop app for Windows.",
        "done": "Got it",
        "tabsLabel": "Choose a method",
        "factsCovers": "Reads",
        "factsNeeds": "Needs",
        "factsRuns": "Runs",
        "browser": {
            "tab": "In the browser",
            "facts": {
                "covers": "Patient and invoice files",
                "needs": "Chrome, Edge or another Chromium browser (Opera, Vivaldi …) — not Firefox or Safari",
                "runs": "Only while Medinvoice is open in a tab"
            },
            "note": "Nothing is imported while the tab is closed."
        },
        "agent": {
            "tab": "Desktop app (Windows)",
            "facts": {
                "covers": "Patient files (GDT), invoice files too if you like",
                "needs": "Windows 10 or 11, any browser",
                "runs": "In the background, no tab needed"
            },
            "note": "Automatic import is switched on separately for your environment. If the app reports it is disabled, contact support."
        }
    },
    "syncGuide": {
        "analogy": "Medinvoice connects to your practice software the same way an ECG or spirometer does: the practice software drops the patient's data as a GDT file into a folder, and Medinvoice picks it up from there. Transferring the invoice file works the same way, through the private billing export (PAD / PADneXt).",
        "clipLabel": "Short video: {{title}}",
        "gdtHelp": {
            "question": "Not sure how to set up the GDT device and its folder in your practice software?",
            "contact": "Write to us at",
            "subject": "with the subject “{{subject}}” and we'll help you."
        },
        "jump": {
            "devices": "Go to download and enrollment code",
            "folders": "Go to the folders"
        },
        "phases": {
            "prepare": {
                "title": "Prepare your practice software",
                "lead": "Once: you or your practice software vendor set up a GDT device called “Medinvoice” that writes patient data into a folder.",
                "items": {
                    "invoices": "Invoices (optional): have the private billing export (PAD / PADneXt) write into its own folder."
                }
            },
            "install": {
                "title": "Install the desktop app",
                "lead": "Recommended: install the desktop app on the sync PC, for the write-back. Also install it on any other computers used for onboarding patients.",
                "items": {
                    "download": "On the Sync page under “Device management”, click “Download for Windows” and open the downloaded file.",
                    "smartscreen": "If “Windows protected your PC” appears → click “More info” → “Run anyway”. The publisher must read “exipnon GmbH”.",
                    "autostart": "Leave “Start Medinvoice Desktop-App automatically when Windows starts” ticked. The desktop app then runs in the background after every restart."
                }
            },
            "connect": {
                "title": "Connect it to Medinvoice",
                "lead": "When the installer finishes, the app starts and opens a new tab in your browser: “Medinvoice mit Ihrer Praxissoftware verbinden”.",
                "items": {
                    "code": "On the Sync page, click “Generate enrollment code” and copy the code. It works once, for 30 minutes.",
                    "setupTab": "Paste the code into the new tab. Closed it? Right-click the Medinvoice icon in the taskbar → “Einstellungen / Verbindung…”.",
                    "folders": "Choose the GDT export folder from step 1, optionally the invoice folder and a PDF folder for importing documents (signed consent etc.). Then click “Verbinden”.",
                    "sharedPc": "Several doctors share this PC? Go to “Registered devices” → turn on “Shared PC” — the desktop app then asks, for every invoice file upload, which doctor it belongs to.",
                    "test": "Test it: send a patient to the “Medinvoice” device — a tab opens within a few seconds. Nothing? Right-click the icon → “Jetzt synchronisieren”."
                }
            },
            "daily": {
                "title": "How it works day to day",
                "lead": "Click the “Medinvoice” interface button → your practice software puts a patient file (GDT) into the folder you set up → the desktop app takes the data over automatically. Medinvoice doesn't need to be open. A dialog opens in a separate window.",
                "items": {
                    "extras": "The app can hand signed consents back to your practice software as PDFs — the GDT import has to be set up there for that. Set it in Settings → Praxis Software Sync."
                }
            },
            "connectBrowser": {
                "title": "Connect the folder",
                "lead": "Right here on this page, on the PC that can see the export folder.",
                "items": {
                    "browser": "Use Chrome, Edge, Opera or Vivaldi. Firefox and Safari can't read folders.",
                    "connect": "Click “Connect folder” next to “Patient data folder” and choose the GDT export folder from step 1. For invoices, the same next to “Invoice data folder”.",
                    "allow": "When the browser asks whether Medinvoice may view the folder, click “View files” or “Allow”. Medinvoice only reads the folders you chose.",
                    "test": "Test it: send a patient to the “Medinvoice” device — Medinvoice responds in this tab within a minute."
                }
            },
            "dailyBrowser": {
                "title": "Day to day",
                "lead": "New files are picked up while Medinvoice is open in a tab on this PC. Nothing is imported while the tab is closed.",
                "items": {
                    "keepOpen": "Open Medinvoice in the morning and leave the tab open. If the browser asks again after a restart, click “Reconnect”.",
                    "export": "Send the patient to the “Medinvoice” device in your practice software — the file lands in the folder and Medinvoice picks it up.",
                    "confirm": "Unless automatic processing is on, Medinvoice asks briefly before reading new files.",
                    "review": "A window opens in this tab for each patient: check the details, choose the billing recipient, done. “Cancel import” undoes everything."
                }
            }
        },
        "pvs": {
            "tested": "Already tested with MEDICAL OFFICE (T2med, tomedo and medatixx are coming soon).",
            "specTitle": "Values you need",
            "spec": {
                "name": {
                    "label": "Device name",
                    "value": "e.g. Medinvoice",
                    "hint": "Any name, so you can find it again later."
                },
                "satzart": {
                    "label": "Record type (Satzart)",
                    "value": "6301 – Stammdaten übermitteln",
                    "hint": "Sometimes called “send patient data”. 6302 works as well."
                },
                "folder": {
                    "label": "Export folder",
                    "value": "e.g. C:\\Medinvoice\\GDT",
                    "hint": "You choose exactly this folder in Medinvoice afterwards."
                },
                "fileName": {
                    "label": "File name",
                    "value": "e.g. for MEDICAL OFFICE: MO2MEDI.GDT\ne.g. for T2med: T2med2MEDI.*",
                    "hint": "If your software asks for one: the file must end in .gdt or a number like .001 — Medinvoice doesn't read other files."
                },
                "returnFolder": {
                    "label": "Write-back (import into the practice software)",
                    "value": "Example import folder in MEDICAL OFFICE: C:\\GDT",
                    "hint": "Optional, desktop app only: a separate folder for documents sent back to the practice software, e.g. C:\\GDT\\Medinvoice-PDF."
                }
            }
        },
        "tray": {
            "title": "The icon in the taskbar",
            "caption": "Bottom right next to the clock, often hidden behind the ^ arrow. Tip: drag the icon out of the arrow menu onto the taskbar so it's always visible.",
            "legendLabel": "Icon status",
            "menu": "Right-click the icon for its menu (in German): “Jetzt synchronisieren” checks the folder right away, “Einstellungen / Verbindung…” reopens setup (change folders without a new code, or renew with one), “Beenden” closes the app.",
            "states": {
                "running": {
                    "label": "Läuft",
                    "meaning": "Green — running",
                    "todo": "All good, nothing to do."
                },
                "enrolling": {
                    "label": "Noch nicht verbunden",
                    "meaning": "Grey — not connected yet",
                    "todo": "Finish setup (step 3)."
                },
                "renewSoon": {
                    "label": "Verbindung bald erneuern",
                    "meaning": "Amber — access expires soon",
                    "todo": "Click “Renew” in the device list and paste the code via “Einstellungen / Verbindung…”."
                },
                "revoked": {
                    "label": "Neu verbinden nötig",
                    "meaning": "Red — access expired or revoked",
                    "todo": "Connect again with a new enrollment code."
                },
                "attention": {
                    "label": "Ein Patient muss geprüft werden",
                    "meaning": "Blue — a patient needs your decision",
                    "todo": "See “Needs your attention” on this page."
                }
            }
        },
        "reviewTab": {
            "title": "A new tab for every patient",
            "otherTab": "Medinvoice – Invoices",
            "newBadge": "New",
            "caption": "For every new patient file the app opens a tab in your default browser (in German): check the details, then “Hinzufügen” (add) — or “Hinzufügen und Einwilligung senden” (add and send consent) if there is no consent yet. The patient is already saved at that point; “Import abbrechen” (cancel import) reverts it. The tab closes by itself afterwards. Invoice files open a “Datei hochladen” (upload file) tab the same way."
        },
        "glossary": {
            "title": "Terms explained",
            "gdt": {
                "term": "GDT",
                "text": "Gerätedatentransfer — the standard practice software uses to hand patient data to devices like ECGs or spirometers. Medinvoice uses the same route."
            },
            "pad": {
                "term": "PAD / PADneXt",
                "text": "Private billing export formats, the same ones billing services receive. PAD is the older format (.dat), PADneXt the newer one (.xml)."
            },
            "exportFolder": {
                "term": "Export folder",
                "text": "The folder your practice software writes these files into. Medinvoice reads only this folder — nothing else on the PC."
            },
            "tray": {
                "term": "Taskbar / notification area",
                "text": "The bar along the bottom of the screen. Next to the clock sit small icons of running programs — including the Medinvoice app's."
            },
            "code": {
                "term": "Enrollment code",
                "text": "A one-time code the desktop app uses to sign in to your practice. Valid for 30 minutes; just generate a new one after that."
            }
        }
    },
    "agentDownload": {
        "rowTitle": "Desktop app for Windows",
        "rowDesc": "Install it on the computer that runs your practice software, then enroll it with a code from below. It imports files, sends signed consents back to the practice software and can show short pop-ups.",
        "btn": "Download for Windows",
        "version": "Version {{version}}",
        "unavailable": "The installer isn't available for download yet.",
        "privacy": "Desktop app privacy notice"
    },
    "paperConsentRequests": {
        "title": "Paper consent requested",
        "description": "Patients who scanned the QR code and chose to sign on paper instead of the digital signature.",
        "born": "Born {{date}}",
        "handledBtn": "Done",
        "handledError": "Could not mark this as done."
    },
    "identityReviews": {
        "title": "Differing details — review required",
        "description": "Patients who entered a different name or address on the questionnaire than what's on file."
    },
    "agentAttention": {
        "title": "Needs your attention",
        "description": "Patients the desktop app imported on its own, and imports it held back.",
        "ambiguousTitle": "Held back — two patients match",
        "ambiguousHint": "The desktop app did not import these because more than one existing patient has the same name and date of birth. Open the patients and remove or merge the duplicate; the next export from your software then imports normally.",
        "unknownPatient": "Unknown patient",
        "born": "Born {{date}}",
        "externalId": "Software ID {{id}}",
        "candidates": "Existing patients:",
        "candidateLink": "Patient {{n}}",
        "dismissBtn": "Dismiss",
        "dismissError": "Could not dismiss this entry.",
        "undoTitle": "Recently imported — can be undone",
        "created": "New patient created",
        "updated": "Existing patient updated",
        "minutesLeft_one": "{{count}} min left to undo",
        "minutesLeft_other": "{{count}} min left to undo",
        "undoBtn": "Undo",
        "undoConfirm": "Undo the import of {{name}}? A newly created patient is removed again; an updated patient goes back to the previous values.",
        "undoAlreadyDone": "This import was already undone.",
        "undoExpired": "The undo window for this import has closed.",
        "undoNotFound": "This import could not be found.",
        "undoError": "Could not undo this import."
    },
    "cardQr": {
        "button": "Card payment by QR",
        "title": "Card payment – invoice {{id}}",
        "imageAlt": "QR code for card payment at SumUp",
        "amount": "€ {{amount}}",
        "hint": "The patient scans the code with their phone and pays at SumUp by card, Apple Pay or Google Pay.",
        "waiting": "Waiting for payment …",
        "paid": "€ {{amount}} paid. The invoice is marked as paid.",
        "expired": "The QR code has expired.",
        "failed": "The card payment could not be started.",
        "newCode": "Create a new QR code"
    },
    "cardPay": {
        "button": "Card payment",
        "qr": "QR code",
        "qrHint": "Patient pays with their own phone",
        "terminal": "Card terminal",
        "terminalHint": "Send the amount to the SumUp terminal"
    },
    "cardReader": {
        "button": "Send to card terminal",
        "title": "Card terminal – invoice {{id}}",
        "loading": "Looking for the card terminal …",
        "choose": "Send to which card terminal?",
        "sending": "Sending the amount to the terminal …",
        "hint": "The amount is on “{{name}}”. The patient holds their card or phone to the terminal.",
        "declined": "The payment did not go through (declined or cancelled at the terminal).",
        "timeout": "No answer from the terminal. If the patient paid, the payment is booked automatically.",
        "offline": "The card terminal is not online. Please check that it is switched on and connected to Wi-Fi.",
        "busy": "A payment is already waiting at the terminal. Please wait a moment or cancel it there.",
        "nothingDue": "Nothing is left to pay on this invoice.",
        "failed": "The payment could not be sent to the terminal.",
        "cancel": "Cancel at terminal",
        "sendAgain": "Send again"
    },
    "sumup": {
        "title": "Card payment (SumUp)",
        "description": "Patients pay in the patient portal by card, Apple Pay or Google Pay. The money goes straight to your SumUp account.",
        "ownAccount": "My SumUp account",
        "praxisAccount": "Practice account",
        "ownAccountHint": "Card payments for your own invoices go to this account.",
        "praxisAccountHint": "The practice's shared SumUp account. Card payments for your invoices go here. Only an admin can connect it.",
        "praxisAccountAskAdmin": "Not connected yet – ask an admin to connect the practice account.",
        "usePraxis": "Use the practice's SumUp instead",
        "usePraxisSaveFailed": "Your choice could not be saved.",
        "notUsed": "connected, not in use",
        "ownDisabledHint": "You're using the practice account. Close \"Use the practice's SumUp instead\" to connect your own account.",
        "summary": "Patients pay by card in the portal or by QR code at the desk.",
        "notConnected": "not connected",
        "connectedAs": "connected to {{name}}",
        "needsReconnect": "connection expired, please reconnect",
        "connect": "Connect with SumUp",
        "reconnect": "Reconnect",
        "connecting": "Opening…",
        "disconnect": "disconnect",
        "confirmDisconnect": "Disconnect SumUp? Patients will no longer be able to pay by card.",
        "connectSuccess": "SumUp is connected. Patients now see card payment in the portal.",
        "connectFailed": "Connecting to SumUp failed. Please try again.",
        "connectCancelled": "Connecting to SumUp was cancelled.",
        "scopeMissing": "SumUp did not grant the payment permission. Please contact Medinvoice support.",
        "comingSoon": "Coming soon.",
        "notAvailableYet": "You can connect your SumUp account here as soon as card payment is enabled.",
        "howItWorks": "You need your own SumUp business account. The portal then shows \"Pay by card\"; paid invoices are marked as paid automatically. Medinvoice never sees card details. Only card payments started in Medinvoice (portal, QR code at the desk, sent to the card terminal) are recorded automatically. Medinvoice can't see amounts you enter yourself on the SumUp terminal or in the SumUp app, or your own SumUp links – please mark those invoices as paid manually.",
        "feesNotice": "SumUp charges you a fee per payment. A surcharge for patients is not permitted by law.",
        "switchesTitle": "Where card payment is offered",
        "switchesDesc": "Applies to the whole practice. In all three cases paid invoices are marked as paid automatically.",
        "switchesAdminOnly": "Applies to the whole practice. Only admins can change this.",
        "portalTitle": "In the patient portal",
        "portalDesc": "Patients see \"Pay by card\" next to the bank transfer and pay on SumUp's payment page.",
        "deskQrTitle": "By QR code at the desk",
        "deskQrDesc": "\"Card payment by QR\" button on open invoices. The patient scans the code and pays with their own phone.",
        "terminalTitle": "On the card terminal",
        "terminalDesc": "\"Send to card terminal\" button on open invoices, once a SumUp Solo is paired.",
        "saveFailed": "The changes could not be saved.",
        "terminalNoReader": "No terminal paired yet – pair one above under \"Card terminals\".",
        "deskQrSaveFailed": "The setting could not be saved.",
        "terminalsTitle": "Card terminals (SumUp Solo)",
        "terminalsEmpty": "Pair a SumUp Solo to send an invoice's amount to the terminal with one click.",
        "terminalsReconnect": "To use card terminals, please reconnect SumUp once.",
        "pairReader": "Pair terminal",
        "pairSteps": "On the Solo: log out (Settings → Device settings → About → Log out), then Connections → API → Connect. Enter the code it shows here (valid for 5 minutes).",
        "pairCode": "Pairing code",
        "pairName": "Name",
        "pairNamePlaceholder": "e.g. Front desk",
        "pairNameDefault": "Front desk",
        "pairSubmit": "Pair",
        "pairing": "Pairing …",
        "pairCancel": "Cancel",
        "pairInvalidCode": "The code has 8 or 9 characters.",
        "pairRejected": "SumUp did not accept the code. It is valid for 5 minutes – please create a new one on the terminal.",
        "pairFailed": "The terminal could not be paired. Please try again.",
        "unpairReader": "Remove terminal",
        "confirmUnpair": "Remove card terminal “{{name}}”? Afterwards also disconnect it on the device (Connections → API → Disconnect).",
        "unpairFailed": "The terminal could not be removed.",
        "tabCardPayments": "Card payments",
        "paymentsHint": "Card payments from the patient portal. Each one is already booked on its invoice. SumUp pays them out to your bank account in batches.",
        "noPayments": "No card payments yet",
        "colAccount": "SumUp account",
        "colInvoice": "Invoice",
        "colPayer": "Payer",
        "colTransaction": "SumUp transaction",
        "praxisAccountShort": "Practice account",
        "payoutChip": "SumUp payout",
        "payoutTooltip": "Batched payout of your card payments. The individual payments are already booked on their invoices. Don't match it; mark it as reviewed."
    },
    "finapi": {
        "panelTitle": "Bank deposits",
        "panelTitleBank": "Bank deposits from {{bank}}",
        "unknownCounterpart": "Unknown",
        "autoMatched": "Auto-matched to invoice",
        "autoMatchedCount": "Matched {{count}} invoices",
        "manuallyMatched": "Manually matched to invoice",
        "manuallyMatchedCount": "Manually matched {{count}} invoices",
        "possibleDuplicate": "Invoice {{readableId}} already paid — possible duplicate payment",
        "notifyPatientDuplicate": "Notify patient",
        "notifyingPatient": "Sending…",
        "patientNotified": "Patient notified",
        "bankConnection": "Bank Connection",
        "notConnected": "Not connected",
        "connected": "Connected",
        "connectDesc": "Connect your bank account to automatically match payments to invoices.",
        "settingsDesc": "Connect your bank account via BANKSapi to automatically detect incoming payments and match them to invoices. Your banking credentials are handled exclusively by BANKSapi.",
        "tanNotice": "When you connect, your bank asks you to approve a TAN. It usually shows a generic text such as “data request” or “account information service”, often without the name Medinvoice: our partner BANKSapi only reads your account transactions. That's expected.",
        "dashboardNudge": "Connect your bank in Settings → Bank Details to see balances and match payments.",
        "dashboardNudgeStaff": "No bank account is connected yet. Doctors connect their account in Settings → Bank Details.",
        "connectBtn": "Connect Bank",
        "goToSettings": "Configure in Settings",
        "confirmDisconnect": "Disconnect your bank account? All connection data will be removed.",
        "duplicateAccountWarning": "This bank account is already connected under {{names}}. Please disconnect one of the two (Settings → Bank Details, logged in as that account).",
        "totalBalance": "Total Balance",
        "lastSync": "Last sync",
        "syncFailedTitle": "Sync couldn't run right now",
        "syncFailedHint": "This can happen occasionally. Your data is unaffected — please try again in a few minutes.",
        "syncFailedLastSync": "Last successful sync: {{datetime}}",
        "sync": "Sync now",
        "disconnect": "Disconnect",
        "syncing": "Syncing transactions…",
        "manualMatch": "Assign to invoice",
        "unmatch": "Remove assignment",
        "unmatching": "Removing assignment…",
        "manualMatchTitle": "Assign transaction to invoice",
        "searchPlaceholder": "Search transactions…",
        "manualMatchSearch": "Search invoice ID, amount, patient…",
        "manualMatchPersonSearch": "Search by patient or recipient…",
        "manualMatchNone": "No open invoices found",
        "manualMatchSelected_one": "{{count}} selected",
        "manualMatchSelected_other": "{{count}} selected",
        "manualMatchConfirm": "Confirm match",
        "matching": "Matching…",
        "accountHolder": "Invoice recipient",
        "billedPatient": "Billed patient",
        "recipient": "Recipient",
        "patient": "Patient",
        "loading": "Loading…",
        "pendingLabel": "Pending transactions",
        "fetching": "Fetching your bank's data…",
        "ignore": "Mark irrelevant",
        "unignore": "Restore",
        "connecting": "Connecting…",
        "retry": "Retry",
        "connectFailed": "Connection failed. Please try again.",
        "lockedNotice": "BANKSapi temporarily locked the connection (423). Please wait a few minutes and try again. Tip: avoid clicking Connect multiple times in a row — it can trigger the lock.",
        "tabIncoming": "Incoming",
        "tabOutgoing": "Outgoing payments",
        "noOutgoingTransactions": "No outgoing payments.",
        "refundMatchTitle": "Match refund to invoice",
        "refundMatchNone": "No paid invoices found",
        "refundAmountLabel": "Refund amount",
        "remainingLabel": "Remaining",
        "paidLabel": "Paid",
        "amountToAddLabel": "Amount to add",
        "amountToRemoveLabel": "Amount to remove",
        "effectAdd": "Adds {{amount}} to the invoice's paid amount",
        "effectRemove": "Removes {{amount}} from the invoice's paid amount",
        "statAutoMatched": "Auto-matched",
        "statUnmatched": "Unmatched",
        "statReviewed": "Manually reviewed",
        "tabAll": "All",
        "colDate": "Date",
        "colAccount": "Account",
        "colAmount": "Amount",
        "filterAmountMax": "Max amount",
        "colCounterpart": "Payer / Sender",
        "colPurpose": "Purpose",
        "colStatus": "Status",
        "colAction": "Action",
        "multiAccountSummary": "{{count}} connected accounts",
        "statusOpen": "Open",
        "statusMatched": "Matched",
        "statusReviewed": "Reviewed",
        "suggestionsTitle": "Suggestions",
        "matchPopupTitle": "Match transaction",
        "viewAll": "View all",
        "selectedTransaction": "Selected transaction",
        "possibleInvoices": "Possible invoices",
        "showMoreInvoices": "Show more invoices",
        "showLessInvoices": "Show less",
        "noInvoiceSelected": "Select a transaction to see suggestions.",
        "noMatchHint": "No matching invoice? Mark as reviewed and handle it manually.",
        "matchOwnerHint": "Received on {{name}}'s account — only sent, open invoices of {{name}} and invoices from the desktop app are listed.",
        "markReviewed": "Mark as reviewed",
        "dueOn": "Due {{date}}",
        "noTransactions": "No transactions.",
        "bestMatch": "Best match",
        "transactionLimitLabel": "Number of transactions shown",
        "transactionLimitDesc": "How many of the most recent transactions (per direction) are fetched and shown ({{min}}–{{max}})."
    },
    "invoicePage": {
        "generating": "Generating…",
        "sendLink": "Send invoice via link",
        "resendLink": "Resend invoice via link",
        "sendViaPost": "Send via Post",
        "viewPdf": "View PDF",
        "pdfNotSent": "PDF unavailable — link has not been sent to the recipient yet",
        "emailFailed": "Email delivery failed — the recipient's email address may be invalid",
        "noEmail": "Recipient has no email address",
        "legalNotAccepted": "This invoice cannot be sent digitally — the recipient has not yet signed the consent (Einwilligung). You can still send it by post.",
        "postConsentRequired": "This invoice cannot be sent by post — the recipient has not yet signed the consent form (Einwilligung).",
        "postOnlyBlocked": "This patient is marked \"Post only\" — invoices can only be sent by post, digital sending is disabled.",
        "amountMismatch": "Stored amount (€ {{stored}}) does not match the sum of services (€ {{calculated}}).",
        "amountMismatchShort": "Amount does not match the sum of services",
        "amountMismatchFlagged": "Amount mismatch flagged.",
        "amountMismatchDetail": "Original PAD upload totaled {{stored}} but exam line items sum to {{calculated}}.",
        "amountMismatchReview": "Review on the Exams tab.",
        "markAsPaid": "Mark as Paid",
        "writeOff": "Write Off",
        "markPaidTitle": "Mark as paid",
        "markPaidMsg": "Mark invoice {{id}} as fully paid?",
        "markPaidConfirm": "Mark as Paid",
        "writeOffTitle": "Write off invoice",
        "writeOffMsg": "Write off invoice {{id}}?",
        "writeOffConfirm": "Write Off",
        "reopenTitle": "Reopen invoice",
        "reopenMsg": "Reopen invoice {{id}}? It will be reset to open.",
        "reopenConfirm": "Reopen",
        "sendEmailTitle": "Send email",
        "sendEmailAlreadySent": "An email was already sent on {{date}}. ",
        "sendEmailMsg": "Send another email for invoice {{id}} to {{name}}?",
        "sendEmailConfirm": "Send",
        "saving": "Saving…",
        "savingChangesMessage": "Saving the changes…",
        "saveChanges": "Save Changes",
        "notFound": "Invoice not found",
        "tab_details": "Details",
        "tab_exams": "Services",
        "tab_log": "Audit Log",
        "tab_portal": "Portal",
        "tab_questions": "Questions",
        "tab_notes": "Notes",
        "portalTitle": "Portal",
        "portalNoActivity": "No portal activity yet",
        "portalLoading": "Loading…",
        "portalColDate": "Date",
        "portalColEvent": "Event",
        "portalColDetails": "Details",
        "portalEventRegister": "Registered",
        "portalEventLogin": "Logged in",
        "portalEventSmsOtp": "SMS OTP sent",
        "portalEventPdfDownloaded": "PDF downloaded",
        "portalEventInvoiceViewed": "Invoice viewed",
        "notesOnlyVisibleToYou": "These notes are private — only visible to you here. They are never shared with the patient.",
        "notesSave": "Save note",
        "notesClear": "Clear",
        "notesPlaceholder": "Add a private note about this invoice…",
        "notesSaved": "Note saved",
        "noQuestions": "No questions found.",
        "hasQuestion": "Recipient has submitted a question",
        "exams": "Services",
        "noExams": "No services found.",
        "goaCatalogButton": "GOÄ codes",
        "goaCatalogTitle": "GOÄ codes",
        "goaRulesButton": "GOÄ rules",
        "goaRulesTitle": "GOÄ exclusion rules",
        "goaRulesIntro": "These GOÄ codes may not be billed together on the same treatment day under the fee schedule. Currently covered: sections B, C, E–O.",
        "goaRulesEmpty": "No rules found.",
        "goaRulesSearchPlaceholder": "Search by GOÄ code…",
        "goaRulesCount": "{{count}} rule",
        "goaRulesCount_other": "{{count}} rules",
        "goaCatalogSearchPlaceholder": "Search by Nr. or description…",
        "goaCatalogEmpty": "No codes found.",
        "goaScopeSpecialty": "My specialty",
        "goaScopeAll": "All specialties",
        "goaSearchHint": "Search only covers your specialty. Switch to all specialties above for a broader search.",
        "goaCatalogCount": "{{count}} code",
        "goaCatalogCount_other": "{{count}} codes",
        "goaConflictBadge": "{{count}} possible billing mistake",
        "goaConflictBadge_other": "{{count}} possible billing mistakes",
        "goaBaseCodeBadge": "{{count}} base service missing",
        "goaBaseCodeBadge_other": "{{count}} base services missing",
        "goaBaseCodeLine": "No. {{nr}} needs one of these services on the same day: No. {{requires}}.",
        "goaMaxCountBadge": "{{count}} possible frequency issue",
        "goaMaxCountBadge_other": "{{count}} possible frequency issues",
        "duplicateCodeError": "This code is already listed",
        "duplicateCodeBanner": "These GOÄ codes are listed more than once: {{codes}}",
        "duplicateCodeHint": "That's possible if it is medically justified. Give the time or the organ examined in the justification.",
        "goaConflictRowTooltip": "Possible GOÄ billing mistakes in this invoice",
        "goaConflictTabTooltip": "Possible GOÄ billing mistakes in the services",
        "goaConflictTitle": "Possible billing mistakes",
        "goaConflictIntro": "These GOÄ codes are normally not billed together according to the fee schedule. Please review the line items and adjust them if needed.",
        "goaConflictDateLabel": "Date of service",
        "goaConflictNoDate": "No service date recorded — please check manually.",
        "logEmpty": "No log entries yet.",
        "logDate": "Date",
        "logAction": "Action",
        "logPerformedBy": "Performed by",
        "logFrom": "From",
        "logTo": "To",
        "logAction_statusChanged": "Status changed",
        "logAction_dunningAdvanced": "Dunning level changed",
        "logAction_dunningResent": "Dunning notice re-sent",
        "logResendChannel_email": "Email",
        "logResendChannel_post": "Letter",
        "logResendChannel_both": "Email + letter",
        "resendDunning": "Resend dunning notice",
        "resendDunningBtn": "Resend",
        "dunningDowngradeWarning": "Lowering the dunning level restarts automatic dunning from the day you save: the next level follows after the interval set in the dunning settings. To stop it, pause dunning for this invoice.",
        "resendDunningPausedHint":"Dunning is paused",
        "resendDunningUnsavedHint": "Save your changes first",
        "resendDunningTitle": "Resend dunning notice",
        "resendDunningMsg": "The {{level}} for invoice {{id}} will be sent again {{channel}} to {{name}}. Dunning level and fee stay unchanged.",
        "resendDunningConfirm": "Send",
        "dunningNotice_1": "payment reminder (M1)",
        "dunningNotice_2": "dunning notice (M2)",
        "dunningNotice_3": "final notice (M3)",
        "resendDunningChannel_email": "by email",
        "resendDunningChannel_letter": "by letter",
        "resendDunningChannel_both": "by email and letter",
        "saveDunningSendTitle": "Send dunning notice now?",
        "saveDunningSendMsg": "The dunning level will change to {{level}}. Send the {{level}} {{channel}} to {{name}} now?",
        "saveDunningSendConfirm": "Save & send",
        "saveDunningSaveOnly": "Save only",
        "toastDunningResentEmail": "Dunning notice sent by email",
        "toastDunningResentLetter": "Dunning notice sent by letter",
        "toastDunningResentBoth": "Dunning notice sent by email and letter",
        "toastDunningResentPartial": "Dunning notice only partly sent – one channel failed",
        "toastDunningResendNoChannel": "Recipient can't be reached for this level (no email address or post only, and no letter fallback)",
        "toastDunningResendFailed": "Dunning notice could not be sent",
        "paymentReceiptSend": "Send payment confirmation",
        "paymentReceiptResend": "Resend payment confirmation",
        "paymentReceiptMsg": "Send the payment confirmation for invoice {{id}} to {{email}}?",
        "paymentReceiptFailed": "Payment confirmation could not be delivered",
        "toastPaymentReceiptSent": "Payment confirmation sent",
        "toastPaymentReceiptFailed": "Payment confirmation could not be sent",
        "logAction_paywiseSubmitted": "Submitted to Paywise",
        "logAction_dunningFeeChanged": "Dunning fee changed",
        "logAction_sent": "Portal link sent",
        "logAction_reSent": "Portal link re-sent",
        "logAction_sentPost": "Sent by post",
        "logAction_reSentPost": "Re-sent by post",
        "logAction_bankTransactionMatched": "Bank match",
        "logAction_sumupPayment": "Card payment (SumUp)",
        "logAction_paidAmountChanged": "Paid amount updated",
        "noEmailOrTel": "Recipient has no email address",
        "letterStatus": "Letter Status",
        "resendViaPost": "Send by post again",
        "resendViaPostNotice": "This invoice has already been sent by post. Sending it again is a new letter and costs postage again.",
        "resendViaPostConfirm": "Send again",
        "toastLxResent": "Invoice sent by post again.",
        "sendLinkTitle": "Send Invoice Link",
        "sendLinkDesc": "The invoice link will be sent to:",
        "invoiceTitle": "Invoice {{id}}",
        "nextInvoice": "Next invoice",
        "nextInvoiceTitle": "Next invoice {{number}} – {{name}}",
        "lxJobTitle": "Letter Job #{{id}}",
        "lxStatus": "Status",
        "lxDispatchDate": "Dispatch date",
        "lxSubmitted": "Submitted",
        "lxCost": "Cost",
        "lxJobDraft": "Draft (test mode)",
        "lxJobHold": "On hold",
        "lxJobQueue": "In queue",
        "lxJobSent": "Sent",
        "lxJobCanceled": "Canceled",
        "amounts": "Amounts",
        "total": "Total",
        "paidField": "Paid (€)",
        "paidTotal": "Total paid",
        "dunningFine": "Dunning fee",
        "removeFine": "Remove dunning fee",
        "fineAlreadyPaidHint": "This fee has already been paid and can no longer be removed.",
        "dunningFineTooltip": "A late payment fee of €{{amount}} was applied to this invoice because it was not settled by the due date ({{date}}).",
        "totalWithFine": "Total incl. dunning fee",
        "newPayment": "New payment (€)",
        "paymentRequiresSent": "Record payments only after the invoice has been sent.",
        "paymentBlockedHint": "Send the invoice first to record a payment.",
        "materialCosts": "Material costs",
        "eyebrowInvoice": "Invoice",
        "eyebrowCreated": "Created",
        "eyebrowSource": "Source",
        "sourcePad": "PAD upload",
        "sourceManual": "Manual",
        "summaryOutstanding": "outstanding",
        "summaryInclFine": "— incl. € {{amount}} late fee",
        "summaryOverdueDays": "{{count}} days overdue",
        "samePersonShort": "Same person",
        "selfPayerLabel": "Self-payer",
        "datesDunning": "Dates & dunning",
        "datesDunningLead": "Adjust the due date and the dunning level manually. Changes apply when you save.",
        "nextEscalation": "Next escalation",
        "escalationAuto": "auto",
        "daysOverdueShort": "{{count}} d overdue",
        "pauseDunningLead": "Hold next reminder. Patient stays at current level until you toggle off.",
        "lifecycleViaPad": "via PAD upload",
        "lifecycleViaPadTime": "via PAD upload · {{time}}",
        "lifecyclePortalSeen": "portal link · seen {{date}}",
        "lifecyclePending": "— pending",
        "patientBornAge": "Born {{date}} ({{age}} y)",
        "patientBorn": "Born {{date}}",
        "lifecycleManual": "manual entry",
        "lifecyclePortalLink": "portal link",
        "lifecycleNotSent": "not sent",
        "lifecycleOverdueSub": "{{days}} days overdue · M{{level}} reached",
        "lifecycleDunningSub": "M{{level}} dunning initiated",
        "lifecycleDuePending": "pending",
        "lifecycleNotReceived": "not received",
        "lifecycleReceived": "received",
        "lifecyclePaidBankAuto": "automatic bank match",
        "lifecyclePaidBankManual": "matched from bank",
        "lifecyclePaidCard": "by card (SumUp)",
        "cardPayment": "Card payment (SumUp)",
        "lifecyclePaidManually": "manually",
        "lifecyclePaidManuallyBy": "manually · {{name}}",
        "sidebarHistory": "History",
        "sidebarTotalInvoiced": "Total invoiced",
        "sidebarAcrossInvoices": "across {{count}} invoices",
        "sidebarPaidOnTime": "Paid on time",
        "sidebarOpenBalance": "Open balance",
        "sidebarThisInvoice": "this invoice",
        "sidebarActivity": "Activity",
        "sidebarViewLog": "View full log",
        "sidebarOtherInvoices": "Other invoices · {{name}}",
        "sidebarAllInvoices": "All {{count}} invoices",
        "unsavedChanges": "{{count}} unsaved changes",
        "discard": "Discard",
        "datesStatus": "Dates & Status",
        "createdSent": "Created / Sent",
        "dueDate": "Due date",
        "pauseDunning": "Pause dunning",
        "noRecipient": "No recipient",
        "noPatient": "No patient",
        "samePersonBadge": "= Patient",
        "selfPays": "self",
        "viewPatient": "View patient",
        "examDate": "Date",
        "examQty": "Qty.",
        "examPosition": "Position",
        "examDescription": "Description",
        "examValue": "Value",
        "goaPoints": "Points",
        "examFactor": "Factor",
        "examAmount": "Amount",
        "editServicesHint": "Edit services for this date",
        "editServicesTitle": "Services from {{date}}",
        "justification": "Justification",
        "justificationPlaceholder": "optional",
        "addService": "Add service",
        "deleteService": "Remove",
        "restoreService": "Restore",
        "factorAllowedRange": "Allowed: {{min}}–{{max}}",
        "unknownCode": "Unknown GOÄ code",
        "materialLines": "Expenses & costs",
        "addMaterialLine": "Add expense",
        "materialLineCost": "Cost (€)",
        "kindMaterial": "Expense / Material",
        "kindMedication": "Medication",
        "kindPostage": "Postage",
        "kindExpertReport": "Expert report",
        "kindFee": "Fee",
        "kindCompensation": "Compensation",
        "originalAnnotations": "Original text (PAD import, read-only)",
        "examsEditHint": "Click a date to edit the services",
        "padDivergenceTitle": "Invoice will be changed",
        "originManual": "Created by hand",
        "originManualHint": "Created by hand in Medinvoice – its services can be corrected on every plan until it's sent.",
        "originImported": "Imported",
        "originImportedHint": "Taken from the practice software (uploaded file or desktop app).",
        "padDivergenceWarning": "These changes diverge from the originally imported data and directly affect the invoice. Continue?",
        "replyOpen": "Reply",
        "replyHide": "Cancel reply",
        "replyPlaceholder": "Write your reply…",
        "replySend": "Send reply",
        "replySending": "Sending…",
        "attachFiles": "Attach files",
        "lifecycleCreated": "Created",
        "lifecycleSent": "Sent",
        "lifecycleDue": "Due",
        "lifecycleOverdue": "Due · Overdue",
        "lifecyclePaid": "Paid",
        "lifecycleWrittenOff": "Written Off",
        "overdueWarning": "This invoice is overdue — due date was {{date}}.",
        "outstandingBalance": "Outstanding Balance",
        "overpaidBy": "Overpaid by € {{amount}}",
        "net": "Net",
        "vat": "VAT ({{rate}}%)",
        "vatBadge": "incl. {{rate}}% VAT",
        "vatIncluded": "This invoice includes {{rate}}% VAT. The amount shown is the gross total.",
        "vatBadgeMixed": "incl. VAT",
        "vatIncludedMixed": "This invoice includes different VAT rates per line item (see Services). The amount shown is the gross total.",
        "lineVatRateAmount": "{{rate}}% VAT ({{amount}})",
        "lineVatExempt": "VAT-exempt",
        "lineVatOverrideHint": "This line has its own VAT rate",
        "vatNotApplicable": "— not applicable",
        "totalBeforeFees": "Total before fees",
        "collected": " collected",
        "recordManualPayment": "Record manual payment",
        "recordManualPaymentLead": "Cash, transfer, or other payment received outside the portal.",
        "dunningFineWhen": "from M{{level}}",
        "paid": "paid",
        "remaining": "remaining",
        "apply": "Apply",
        "roleRecipient": "Recipient",
        "rolePatient": "Patient",
        "paywiseBannerTitle": "Ready for debt collection",
        "paywiseBannerDesc": "This invoice has reached the legal dunning level. You can now submit it to Paywise for automated debt collection.",
        "paywiseSubmitBtn": "Submit to Paywise",
        "paywiseAlreadySubmitted": "Submitted to Paywise",
        "paywiseCaseId": "Case ID",
        "paywiseConfirmTitle": "Submit to Paywise?",
        "paywiseConfirmDesc": "The following information will be shared with Paywise for debt collection:",
        "paywiseConfirmDataName": "Full name",
        "paywiseConfirmDataAddress": "Address",
        "paywiseConfirmDataContact": "Contact (email / phone)",
        "paywiseConfirmDataAmount": "Outstanding amount",
        "paywiseConfirmDataRef": "Invoice reference",
        "paywiseConfirmNote": "No medical details, diagnoses, or exam information will be shared.",
        "paywiseConfirmBtn": "Confirm & Submit",
        "paywiseSuccess": "Case submitted to Paywise. Case ID: {{caseId}}",
        "paywiseError": "Paywise submission failed. Please try again.",
        "paywisePlanRequired": "Paywise integration requires a Plus plan or above.",
        "paywiseNoKey": "No Paywise API key configured. Add one in Settings → Dunning.",
        "paywiseNotConfirmed": "You must confirm the DSGVO notice in Settings → Dunning before submitting to Paywise.",
        "deleteInvoice": "Delete invoice",
        "deleteInvoiceBtn": "Delete",
        "deleteMsg": "Are you sure you want to delete invoice {{id}}?",
        "paymentReceivedDate": "Payment received",
        "paymentConfirmation": "Payment confirmation",
        "sendConfirmation": "Send confirmation",
        "sending": "Sending…",
        "toastConfirmationSent": "Payment confirmation sent to recipient.",
        "toastConfirmationFailed": "Failed to send payment confirmation."
    },
    "uploads": {
        "title": "Uploads",
        "fetching": "Fetching...",
        "search": "Search by name or ID",
        "noUploads": "No uploads yet",
        "fileId": "File ID",
        "uploadDate": "Upload Date",
        "parseDate": "Parse Date",
        "totalAmount": "Total Amount",
        "actions": "Actions",
        "reread": "Reread",
        "delete": "Delete",
        "rereading": "Rereading…",
        "rereadSuccess": "File reread successfully",
        "rereadFailed": "Failed to reread file",
        "deleteFailed": "Failed to delete upload",
        "confirmDelete": "Delete this upload record?",
        "noFileData": "No file data stored — cannot reread",
        "count_one": "{{count}} File",
        "count_other": "{{count}} Files",
        "status": {
            "uploaded": "Uploaded",
            "read": "Read",
            "partial": "Partial",
            "failed": "Failed",
            "unknown": "Unknown"
        }
    },
    "fileUpload": {
        "uploadError": "Upload Error",
        "attachFiles": "Attach Files",
        "dropFiles": "Drop files here or",
        "browse": "browse",
        "anyType": "Any file type accepted",
        "noFiles": "No files selected yet",
        "uploaded": "uploaded",
        "upload": "Upload",
        "uploading": "Uploading…",
        "uploadFailed": "Upload failed:",
        "invalidFileType": "Invalid file type. Only .xml, .pad and .dat files are accepted.",
        "duplicateFile": "This file has already been uploaded.",
        "uploadTitle": "Upload file",
        "uploadForDoctorLabel": "Which doctor are these invoices for?",
        "uploadForDoctorPlaceholder": "Please select",
        "uploadAcceptedTypes": "PAD, PADNext format · .pad, .dat and .xml files",
        "uploadedFiles": "Uploaded files",
        "filesWillAppear": "The files you'll upload\nwill appear here.",
        "uploadSuccess": "File uploaded — invoices updated.",
        "summaryInvoices": "Invoices",
        "summaryAccountPatients": "Recipients",
        "summaryLinkedPatients": "Linked patients",
        "summarySamePerson_one": "{{count}} invoice where the billed patient is the invoice recipient",
        "summarySamePerson_other": "{{count}} invoices where the billed patient is the invoice recipient",
        "summaryTotal": "Total amount",
        "possibleDuplicatesTitle_one": "{{count}} possible duplicate skipped — same patient, same billed services already on file",
        "possibleDuplicatesTitle_other": "{{count}} possible duplicates skipped — same patient, same billed services already on file",
        "duplicateUploadSame": "You already uploaded this file on {{date}}.",
        "duplicateUploadOther": "This file was already uploaded by {{name}} on {{date}}.",
        "duplicateUploadUnknownDoctor": "another member of the practice",
        "duplicateUploadConfirmTitle": "Already-uploaded file detected",
        "duplicateUploadConfirmSubtitle": "Do you want to upload it anyway?",
        "duplicateUploadConfirmUploadAnyway": "Upload anyway",
        "whatsNextTitle": "What's next?",
        "whatsNextMissingEmailBody": "Complete recipient details — at least one imported recipient has no email yet. Email is required to send invoices, portal links, and questionnaires.",
        "whatsNextPatientsCta": "Go to patients",
        "uploadFile": "Upload file",
        "phaseReading": "Reading file…",
        "phaseParsing": "Parsing data…",
        "phaseStoring": "Storing values…",
        "phaseComplete": "Uploaded successfully",
        "checking": "Checking…",
        "conflictsTitle": "The following invoices already exist:",
        "conflictsSubtitle": "Choose which invoices to replace. Unselected invoices are left unchanged.",
        "conflictRecipientLabel": "Invoice recipient",
        "conflictPatientLabel": "Patient",
        "conflictDateLabel": "Created on",
        "conflictAmountLabel": "Amount",
        "conflictsReplace": "Replace selected",
        "conflictsReplaceNone": "Replace none, continue",
        "semanticDuplicatesTitle": "Possible duplicates found — please review",
        "semanticDuplicatesSubtitle": "Same patient, same billed services and amount as an invoice already on file. Check any you want to import anyway — the rest are skipped.",
        "semanticDuplicateExistingLabel": "Already on file as",
        "semanticDuplicatesImportSelected_one": "Import selected anyway ({{count}})",
        "semanticDuplicatesImportSelected_other": "Import selected anyway ({{count}})",
        "semanticDuplicatesSkipAll": "Skip all, continue",
        "demoDisabled": "Upload is disabled in demo mode.",
        "recipientConflictsTitle": "Possible duplicates found – please review",
        "recipientConflictFilePad": "In this file",
        "recipientConflictExisting": "Existing record",
        "recipientConflictMerge": "Same person – merge",
        "recipientConflictCreateNew": "Different person – create new",
        "recipientConflictsContinue": "Continue & import",
        "emailsSent": "{{count}} email sent",
        "emailsSent_other": "{{count}} emails sent",
        "emailsFailed": "{{count}} send failed – please send manually",
        "emailsFailed_other": "{{count}} sends failed – please send manually",
        "uploadSuccessWithFailures": "Upload successful — {{count}} invoice could not be sent automatically",
        "uploadSuccessWithFailures_other": "Upload successful — {{count}} invoices could not be sent automatically",
        "sendFailuresTitle": "These invoices weren't sent",
        "sendFailureReasonNO_RECIPIENT_EMAIL": "No email address on file",
        "sendFailureReasonLEGAL_NOT_ACCEPTED": "Consent (Einwilligung) not yet signed — send it first",
        "sendFailureReasonPOST_ONLY": "Patient is marked \"Post only\"",
        "sendFailureReasonEMAIL_FAILED": "Email delivery failed",
        "sendFailureReasonUnknown": "Could not be sent",
        "flowHowItWorks": "How it works",
        "flowStoryboardTitle": "From PAD file to paid invoice",
        "flowStep1Title": "Drop the PAD file",
        "flowStep1Desc": "Upload your PAD export here—one file kicks off the whole billing journey.",
        "flowStep2Title": "We read the roster",
        "flowStep2Desc": "Invoices, recipients, and linked patients are parsed automatically—no spreadsheet detective work.",
        "flowStep3Title": "Add recipient email",
        "flowStep3Desc": "Enter the recipient's email in the app so questionnaires and links can reach their inbox.",
        "flowStep4Title": "Send the consent request",
        "flowStep4Desc": "Email the consent request (via the questionnaire) first — required before the invoice can be sent.",
        "flowStep5Title": "Consent signed",
        "flowStep5Desc": "The patient fills in required fields and signs the consent (Einwilligung) digitally — this unlocks sending the invoice.",
        "flowStep6Title": "Send the invoice link",
        "flowStep6Desc": "Share the patient-portal link so they can open the bill whenever they are ready.",
        "flowStep7Title": "Portal or SMS PDF",
        "flowStep7Desc": "They open the link: quick SMS one-time code for a PDF, or register / log in for the full portal.",
        "flowStep8Title": "Mark as paid",
        "flowStep8Desc": "When funds arrive, mark the invoice paid in Medinvoice—clean close on your side."
    },
    "patientPage": {
        "notFound": "Patient not found",
        "linkRecipient": "Add Recipient",
        "changeRecipient": "Change Recipient",
        "saving": "Saving…",
        "saveChanges": "Save Changes",
        "recipientUnlinked": "Recipient unlinked",
        "failedUnlink": "Failed to unlink recipient.",
        "failedLoadRecipients": "Failed to load recipients.",
        "recipientLinked": "Recipient linked",
        "failedLink": "Failed to link recipient.",
        "noInvoices": "No invoices found",
        "noRecipient": "No recipient linked",
        "unlink": "Unlink",
        "invoicesCard": "Invoices",
        "recipientCard": "Recipient",
        "validationError": "Last name is required.",
        "tab_details": "Patient",
        "tab_invoices": "Invoices",
        "tab_recipient": "Recipient",
        "tab_questionnaire": "Consent",
        "nextPatient": "Next patient",
        "statusRecipient": "Recipient",
        "statusRecipientLinked": "Linked",
        "statusRecipientNone": "Not linked",
        "statusRecipientSubLinked": "Recipient active",
        "statusRecipientSubNone": "No recipient on file",
        "statusQuestionnaireNeedsRecipient": "Link a recipient first",
        "statusUnsent": "Unsent",
        "statusUnsentNone": "All sent",
        "statusUnsentSub": "{{count}} invoices not yet sent",
        "noEmailBanner": "This patient has no email address on file. Dunning letters will be sent by post — this incurs additional costs!",
        "changeRecipientTitle": "Change Recipient",
        "changeRecipientOwnOption": "Patient is their own recipient",
        "changeRecipientOwnDesc": "Creates a new recipient using this patient's data.",
        "changeRecipientMinorNote": "Minors need a parent or guardian as billing recipient. Pick an existing one or create a new one.",
        "changeRecipientSelfExists":"This person is already a billing recipient in your practice. Pick that recipient instead of creating a second one:",
        "changeRecipientSelfExistsPick": "Same name and birth date — will be marked as the recipient themselves",
        "changeRecipientSearch": "Search recipients…",
        "changeRecipientConfirm": "Set recipient",
        "changeRecipientSuccess": "Recipient changed.",
        "changeRecipientFailed": "Failed to change recipient.",
        "changeRecipientNew": "Create new recipient",
        "changeRecipientCreate": "Create & assign",
        "identityReviewPending": "Patient submitted different info on the questionnaire — needs review",
        "identityReviewTitle": "Different info submitted on the questionnaire",
        "identityReviewDesc": "The questionnaire was filled out with different details than what's on file. Please confirm this is the same patient before applying it.",
        "identityReviewName": "Name",
        "identityReviewAddress": "Address",
        "identityReviewAccept": "Accept",
        "identityReviewReject": "Reject",
        "identityReviewAcceptSuccess": "Info was applied.",
        "identityReviewRejectSuccess": "Change was discarded, existing info kept.",
        "identityReviewFailed": "Action failed."
    },
    "recipientPage": {
        "notFound": "Patient not found",
        "sendQuestionnaire": "Send questionnaire via email link",
        "resendQuestionnaire": "Resend questionnaire via email link",
        "sendQuestionnaireSms": "Send questionnaire via SMS",
        "resendQuestionnaireSms": "Resend questionnaire via SMS",
        "smsCostNote": "This SMS will cost 0.09 €.",
        "smsLanguageLabel": "Language",
        "smsToLabel": "Recipient phone",
        "smsTitleLabel": "Title",
        "smsTextLabel": "Message",
        "questionnaireSmsLinkSent": "Questionnaire link sent via SMS.",
        "questionnaireSmsFailed": "Failed to send questionnaire link via SMS.",
        "addPatient": "Add patient",
        "requestConsentRevoke": "Revoke consent",
        "requestConsentRevokeQrTitle": "Revoke – QR code",
        "requestConsentRevokeQrHint": "Scan this QR code so the patient can confirm revoking their consent.",
        "requestConsentRevokeOr": "or send the link via",
        "sendConsentRevokeEmail": "Send by email",
        "sendConsentRevokeSms": "Send by SMS",
        "consentRevokeEmailSent": "Revoke link sent by email.",
        "consentRevokeEmailFailed": "Failed to send the revoke link by email.",
        "consentRevokeSmsSent": "Revoke link sent by SMS.",
        "consentRevokeSmsFailed": "Failed to send the revoke link by SMS.",
        "markAsPatient": "Also register as patient",
        "markAsPatientHint": "Use this if the recipient (e.g. a parent) is also being treated themselves but was never added as a patient.",
        "markAsPatientDone": "Recipient was also registered as a patient and linked.",
        "linkExistingPatient": "Link existing",
        "unlinkPatient": "Unlink",
        "saving": "Saving…",
        "saveChanges": "Save Changes",
        "questionnaireSent": "Questionnaire link sent successfully.",
        "questionnaireFailed": "Failed to send questionnaire link.",
        "questionnairePdfFailed": "Failed to load questionnaire PDF.",
        "digitalSendingLabel": "Digital sending",
        "postConsentLabel": "By post",
        "questionnaireSectionTitle": "Consent (digital)",
        "consentSectionTitle": "Consent (post)",
        "sendQuestionnaireEmail": "Send via email",
        "resendQuestionnaireEmail": "Resend via email",
        "sendQuestionnaireSmsShort": "Send via SMS",
        "resendQuestionnaireSmsShort": "Resend via SMS",
        "questionnaireQrScan": "QR code – scan on-site",
        "postOnlyConsentHint": "Every patient of this recipient is marked \"Post only\" — consent can only be collected on paper (by post).",
        "setConsentManually": "Set consent manually",
        "questionnaireQr": "QR Code",
        "questionnaireQrHint": "Let the recipient scan this code with their phone to fill in the consent form on-site.",
        "qrFailed": "Failed to generate QR code.",
        "patientUnlinked": "Patient unlinked",
        "failedUnlink": "Failed to unlink patient.",
        "failedLoadPatients": "Failed to load patients.",
        "patientLinked": "Patient linked",
        "failedLink": "Failed to link patient.",
        "unsentInvoices": "Unsent invoices",
        "validationError": "Last name, birth date and salutation are required.",
        "patientsCard": "Patients",
        "noPatients": "No patients linked",
        "noExtraPatientsConnected": "No additional patients connected to {{name}}.",
        "unlink": "Unlink",
        "colName": "Name",
        "colBirthDate": "Birth date",
        "colEmail": "Email",
        "tab_patients": "Patients",
        "tab_details": "Patient",
        "tab_recipient": "Recipient",
        "tab_invoices": "Invoices",
        "tab_questionnaire": "Consent",
        "eyebrowPatient": "Patient",
        "summaryPatients": "{{count}} patients",
        "summaryOpenInvoices": "{{count}} open invoices",
        "statusPortal": "Portal",
        "statusPortalActive": "Active",
        "statusPortalInactive": "Not registered",
        "statusPortalSubActive": "Can sign in",
        "statusPortalSubInactive": "No portal account",
        "statusQuestionnaire": "Questionnaire",
        "statusQuestionnaireNone": "Not sent",
        "statusQuestionnaireSub": "Send from toolbar",
        "statusPatients": "Patients",
        "statusPatientsSub": "{{count}} linked",
        "statusInvoices": "Invoices",
        "statusInvoicesSub": "{{open}} open · {{done}} paid",
        "nextRecipient": "Next patient",
        "nextRecipientTitle": "Next patient – {{name}}",
        "questionnaire_submission": "Submission",
        "questionnaire_submittedAt": "Submitted at",
        "questionnaire_submitted": "Consent signed",
        "questionnaire_viewPdf": "View PDF",
        "questionnaire_additionalPatients_one": "{{count}} additional patient in submission",
        "questionnaire_additionalPatients_other": "{{count}} additional patients in submission",
        "questionnaire_patients": "Patients",
        "questionnaire_noSubmission": "No consent signed yet.",
        "questionnaire_previousSubmissions": "Previous submissions",
        "questionnaire_questions": "Questions",
        "questionnaire_noQuestions": "No questions submitted.",
        "questionnaire_openCount_one": "{{count}} open",
        "questionnaire_openCount_other": "{{count}} open",
        "questionnaire_allResolved": "All resolved",
        "questionnaire_resolve": "Mark resolved",
        "questionnaire_resolved": "Resolved",
        "questionnaire_history": "History",
        "questionnaire_event_sent": "Consent request sent",
        "questionnaire_event_resent": "Consent request resent",
        "questionnaire_event_opened": "Consent request opened",
        "questionnaire_event_submitted": "Consent signed",
        "questionnaire_event_revoked": "Consent revoked",
        "category_general": "General",
        "category_billing": "Billing",
        "category_appointment": "Appointment",
        "category_treatment": "Treatment",
        "category_insurance": "Insurance",
        "colActions": "Actions",
        "sameAsMeButton": "This is me",
        "sameAsMeBadge": "Same as recipient",
        "sameAsMeTitle": "Match patient with recipient?",
        "sameAsMeIntro": "Contact and identity fields will be merged: each side fills in blanks from the other, and when both have a value the recipient's value is kept. The patient is then marked as the same person as this recipient.",
        "sameAsMeReplaceWarning": "{{name}} is already marked as this recipient. If you continue, that link will be removed and {{newName}} will be linked instead.",
        "sameAsMeConfirm": "Merge & link",
        "sameAsMeClearTitle": "Remove same-person link?",
        "sameAsMeClearIntro": "This clears the \"this patient is the recipient\" link. Merged data will not be reverted automatically.",
        "sameAsMeClearLink": "Remove link",
        "sameAsMeClearConfirm": "Remove link",
        "sameAsMeSuccess": "Identity merged and link saved.",
        "sameAsMeClearSuccess": "Link removed.",
        "sameAsMeFailed": "Could not save."
    },
    "onboarding": {
        "avvTitle": "Data Processing Agreement",
        "avvDesc": "Before you start, please read and accept the Data Processing Agreement (AVV) in accordance with Art. 28 GDPR. This is required for GDPR-compliant use of Medinvoice.",
        "avvAccept": "I accept the",
        "avvLink": "Data Processing Agreement (AVV)",
        "avvSignatureLabel": "Digital signature",
        "avvSignaturePlaceholder": "Type your full name",
        "avvSignatureHint": "By typing your name you sign this agreement digitally.",
        "avvSign": "Accept & continue",
        "next": "Next",
        "back": "Back",
        "finish": "Get started",
        "gettingStartedTitle": "Getting started",
        "gettingStartedDesc": "Work through these chapters to get the most out of Medinvoice.",
        "percentCompleted": "{{percent}}% completed",
        "loadingProgress": "Loading progress …",
        "openSettings": "Open in settings",
        "goTo": "View",
        "viewDocs": "Docs: {{chapter}}",
        "flowOtherWays": "No practice software? \"Create invoice\" lets you write invoices directly in Medinvoice. With practice software you can skip uploads altogether through the practice software sync. You'll find both in the next step.",
        "firstInvoiceTitle": "Get invoices into Medinvoice",
        "stepSyncConnect": "Review the practice software sync",
        "stepSyncConnectHint": "With practice software, patients and invoices come in automatically — through the Windows desktop app or in the browser (Chrome/Edge). Without practice software, just opening the page once is enough.",
        "stepInvoiceFirst": "Create or upload your first invoice",
        "stepInvoiceFirstHint": "\"View\" opens \"Create invoice\": pick a patient, enter the diagnosis and GOÄ codes, check, create. An invoice from a PAD file or the sync counts just the same.",
        "goaCheckTitle": "GOÄ check",
        "stepGoaCheckRun": "Ran your first GOÄ check",
        "stepGoaCheckRunHint": "The check runs by itself: in step 4 of \"Create invoice\", and in the \"Services\" tab of existing invoices. It reports codes that exclude each other and exceeded limits.",
        "layoutTitle": "Invoice Layout",
        "stepLayoutLogo": "Upload your logo and choose its position",
        "stepLayoutHeaderFooter": "Set up header and footer",
        "stepLayoutQr": "Activate QR code for payment",
        "stepLayoutInvoiceText": "Customise the invoice text",
        "bankTitle": "Bank & Payments",
        "stepBankIban": "Enter IBAN and tax number",
        "stepBankScanPay": "Set the SCAN & PAY name",
        "stepBankFinapi": "Connect your account via BANKSapi for payment reconciliation",
        "stepBankSepa": "Verify your SEPA direct-debit details",
        "invoiceTitle": "Invoice Settings",
        "stepInvoiceLegalAcceptance": "Review \"legal consent required before sending\"",
        "stepInvoiceSendOnUpload": "Review \"send on upload\"",
        "stepInvoiceEmailLinkModes": "Set email link options",
        "dunningTitle": "Dunning",
        "stepDunningIntervals": "Set the dunning intervals",
        "stepDunningFines": "Configure a late payment fee",
        "stepDunningSendModes": "Set the final reminder's delivery method",
        "goaTitle": "GOÄ Codes",
        "stepGoaFirstCode": "Billed your first GOÄ code",
        "tagsGroupsTitle": "Tags & Groups",
        "stepTagsEnable": "Enable tags",
        "stepTagsCreate": "Create your first tag",
        "stepGroupsEnable": "Enable patient groups",
        "stepGroupsAssign": "Assign your first patient group",
        "consentTitle": "Consent",
        "stepConsentSent": "Sent your first consent request",
        "stepConsentSigned": "Received your first signed consent",
        "teamTitle": "Team & Permissions",
        "stepTeamInvite": "Invited another team member",
        "stepTeamPermissions": "Reviewed team permissions",
        "patientsTitle": "Bring in your patients",
        "stepPatientsImport": "Import existing patients",
        "stepPatientsImportHint": "Export your patient list from your previous software as a CSV file. On the Patients page, click \"…\" at the top right, then \"Import CSV\" — \"View\" opens the import directly. Patients are also created automatically when you upload a PAD file and through the practice software sync."
    },
    "settings": {
        "title": "Settings",
        "bankManageViewOnly": "You can view bank transactions, but only a Doctor or Admin can manage the bank connection itself (connect, disconnect, sync). Ask a Doctor or Admin to set this up here.",
        "pageLead": "Manage your practice profile, team, invoice settings and notifications.",
        "navGeneral": "General",
        "navPractice": "Practice",
        "navInvoicing": "Invoicing",
        "navSending": "Sending",
        "navInfo": "Info",
        "dunningSchedule": "Dunning schedule",
        "dunningScheduleDesc": "When each reminder is sent after the invoice goes out, and how it is delivered.",
        "daysAfterSent": "days after sent",
        "legalFlagged": "Flagged for legal review — no automatic letter",
        "lateFees": "Late fees",
        "lateFeesDesc": "Optional fees added on top of the invoice amount for each dunning level.",
        "back": "Back",
        "praxis": "Praxis",
        "bankDetails": "Bank Details",
        "bankAndPayments": "Bank & Payments",
        "cardPaymentSumup": "Card payment (SumUp)",
        "bankDetailsDesc": "Your bank details that are printed in the PDF invoice. If not provided, the data entered during registration will be used.",
        "bankConnectionDesc": "Connect your bank account so that invoice payments are automatically detected.",
        "sepaPayment": "SEPA Payment",
        "sepaPaymentDesc": "The bank account that MedInvoice is using for the automated monthly billing.",
        "sepaAccountHolder": "Account holder name",
        "sepaAccountHolderPlaceholder": "e.g. Dr. John Smith",
        "sepaMandate": "SEPA Direct Debit",
        "sepaMandateDesc": "Update the bank account used for automatic monthly billing. Changing the IBAN will reset the mandate sequence so the next collection is treated as a first debit.",
        "ibanFallbackNotice": "No IBAN entered — the practice IBAN will be used for your payments.",
        "bicLookingUp": "Looking up BIC…",
        "myProfile": "My Profile",
        "invoices": "Invoice settings",
        "pdfFormat": "Invoice PDF Format",
        "dunning": "Dunning",
        "praxisSoftwareSync": "Practice Software Sync",
        "datev": "DATEV",
        "datevTitle": "DATEV accounting export",
        "datevDesc": "Assigned by your Steuerberater — required before the DATEV/EXTF export can produce a real booking file instead of a plain CSV. A single collective account is used for every patient, not one account per person.",
        "datevBeraterNr": "Berater number",
        "datevBeraterNrDesc": "Your Steuerberater's DATEV consultant number (Beraternummer)",
        "datevMandantNr": "Mandant number",
        "datevMandantNrDesc": "Your practice's DATEV client number (Mandantennummer) with that Steuerberater",
        "datevRevenueAccount": "Revenue account (Konto)",
        "datevRevenueAccountDesc": "The Sachkonto your Steuerberater books GOÄ revenue to, e.g. 8400",
        "datevDebtorAccount": "Debtor account (Gegenkonto)",
        "datevDebtorAccountDesc": "The collective patient/debtor account, e.g. 10000",
        "datevAccountLength": "Account number length",
        "datevAccountLengthDesc": "Sachkontenlänge — how many digits your Steuerberater's chart of accounts uses (usually 4)",
        "fileLocations": "File Locations",
        "teamMembers": "Team Members",
        "email": "Email",
        "emailSmtp": "Email (SMTP)",
        "tabSmtp": "SMTP",
        "tabTemplates": "Templates",
        "docs": "Documentation",
        "zaala": "Medinvoice",
        "generic": "Generic",
        "subscription": "Subscription",
        "subscriptionManage": "Cancel or change plan",
        "subscriptionManageDesc": "Change your subscription plan or cancel your account.",
        "subscriptionManageBtn": "Cancel / edit subscription",
        "dashboard": "Dashboard",
        "activityDays": "Activity window",
        "activityDaysDesc": "Show activities from the last N days on the dashboard.",
        "praxisDetails": "Praxis Details",
        "praxisQrTitle": "Patient self-registration QR",
        "praxisQrDesc": "A permanent QR code your patients can scan to register themselves — download it once and print it, or embed it on your website. Unlike the one-time QR in \"Add patient\", this one never expires and works for any number of patients.",
        "praxisQrRowTitle": "QR code",
        "praxisQrRowDesc": "Scanning it opens the same self-registration questionnaire patients fill in on their own smartphone.",
        "praxisQrGenerate": "Generate QR code",
        "praxisQrGenerating": "Generating…",
        "praxisQrLabelField": "Name on the QR (SVG/PDF)",
        "praxisQrFormatField": "File format",
        "praxisQrSizeField": "Size",
        "praxisQrSizeA7Desc": "74 × 105 mm — Small label",
        "praxisQrSizeA6Desc": "105 × 148 mm — Postcard",
        "praxisQrSizeDinLangDesc": "99 × 210 mm — Rack card",
        "praxisQrSizeA5Desc": "148 × 210 mm — Flyer",
        "praxisQrSizeA4Desc": "210 × 297 mm — Poster",
        "praxisQrSizeA3Desc": "297 × 420 mm — Large poster",
        "praxisQrDownloadBtn": "Download",
        "praxisQrDownloading": "Downloading…",
        "praxisQrDownloadError": "Could not download the QR code. Please try again.",
        "praxisQrWidgetTextField": "Website widget text",
        "praxisQrWidgetTextDesc": "Customize the wording shown on the embedded widget below. Leave a field blank to use the default text.",
        "praxisQrWidgetHeadingField": "Heading",
        "praxisQrWidgetMessageField": "Message",
        "praxisQrWidgetTextSave": "Save text",
        "praxisQrWidgetTextSaving": "Saving…",
        "praxisQrWidgetTextSaved": "Saved",
        "praxisQrWidgetTextError": "Could not save the widget text. Please try again.",
        "praxisQrEmbedField": "Embed on your website",
        "praxisQrEmbedDesc": "Paste this snippet into your website's HTML to show a \"Register as a patient\" card with this QR code. Feel free to adjust the width/height to fit your page.",
        "praxisQrEmbedPreviewTitle": "Widget preview",
        "praxisQrEmbedCopy": "Copy code",
        "praxisQrEmbedCopied": "Copied!",
        "praxisQrEmbedCopyError": "Could not copy — please select and copy the code manually.",
        "praxisQrRegenerate": "Regenerate",
        "praxisQrRegenerateConfirm": "Generate a new QR code? Any previously printed, downloaded, or embedded copy — including the widget on your website — will stop working immediately.",
        "praxisQrLoadError": "Could not load the QR code. Please try again.",
        "praxisQrGenerateError": "Could not generate the QR code. Please try again.",
        "myProfileTitle": "My Profile",
        "deleteAccount": "Delete account",
        "deleteAccountDesc": "Your account will be deactivated and you will be logged out immediately. Your invoicing data is retained as required by law.",
        "deleteAccountConfirmTitle": "Delete account?",
        "deleteAccountConfirmMsg": "You will be logged out immediately. Your login will be deactivated. All invoicing data is retained.",
        "deleteAccountLastAdmin": "You are the last administrator. Please assign another admin first.",
        "roleChangeLastAdmin": "This is the praxis's only Administrator. Assign another member as Administrator first before changing this role.",
        "iban": "IBAN",
        "bic": "BIC",
        "taxNumber": "Tax number",
        "vatId": "VAT ID",
        "scanPayName": "SCAN & PAY name",
        "scanPayNameDesc": "Invoice recipient name shown in the QR code. Defaults to practice name.",
        "scanPayNamePlaceholder": "e.g. Dr. Max Mustermann",
        "dunningIntervals": "Dunning Intervals",
        "dayAfterSent": "Day after the invoice was sent to the recipient.",
        "days": "days",
        "legalSelf": "I handle legal myself",
        "legalSelfDesc": "You manage the legal process with your own lawyer.",
        "legalApi": "Use Paywise API",
        "legalApiDesc": "Hand legal collection over to Paywise automatically.",
        "finalNoticeDelivery": "Final notice delivery",
        "finalNoticeDeliveryDesc": "How the final dunning notice is sent. All other levels use email by default.",
        "emailOnly": "Email only",
        "letterOnly": "Letter only",
        "emailAndLetter": "Email & letter",
        "dunningFinesEnabled": "Dunning fees",
        "dunningFinesEnabledDesc": "Adds a configurable fee for each dunning level.",
        "dunningFineLabel": "Fee",
        "dunningFallbackToLetter": "Letter fallback",
        "dunningFallbackToLetterDesc": "When a recipient has no email address, send a letter instead.",
        "fallback.extraCost": "-> extra cost ~ EUR{{cost}} per letter",
        "sendVia": "Send via",
        "letterDelivery": "Letter delivery",
        "legalHandling": "Inkasso handling",
        "paywiseApiKey": "Paywise API Key",
        "paywiseApiKeyDesc": "Your Paywise API key. Sign up at paywise.de to get one.",
        "paywiseApiKeyPlaceholder": "pw_live_...",
        "paywiseApiKeyConnected": "Key saved",
        "paywiseApiKeyStoredPlaceholder": "•••••••• saved – enter a new key to replace it",
        "paywiseDsgvoConfirm": "I confirm that my practice's Datenschutzerklärung includes a notice that overdue invoices may be passed to a debt collection service.",
        "paywiseSubmitBtn": "Submit to Paywise",
        "paywiseAlreadySubmitted": "Submitted to Paywise",
        "dispatchStandard": "Standard",
        "dispatchR1": "Tracked",
        "dispatchR2": "Registered (RS)",
        "dispatchR1Cost": "Tracked mail (mailbox drop) – approx. +€2–3 per letter",
        "dispatchR2Cost": "Registered mail (signature required) – approx. +€2–4 per letter",
        "dunningM3EmailWarning": "We recommend also notifying the patient by post at this final stage. Email-only final notices are easier to overlook and may weaken your legal standing.",
        "dunningFallbackEnabledNote": "Note: If no email address is on file, dunning letters will be sent by post. This incurs additional costs!",
        "dunningFallbackDisabledWarnM1": "Current setup: patients without an email address will not be notified at the M1 stage.",
        "dunningFallbackDisabledWarnM2": "Current setup: patients without an email address will not be notified at the M2 stage.",
        "dunningFallbackDisabledWarnM1M2": "Current setup: patients without an email address will not be notified at the M1 or M2 stage.",
        "invoiceDueAfter": "Invoice due after",
        "invoiceDueAfterDesc": "How long after sending until an invoice is due.",
        "paymentTolerance": "Payment tolerance",
        "paymentToleranceDesc": "If the remaining amount is less than or equal to this, the invoice is considered paid.",
        "sendMethods": "Send method(s)",
        "sendMethodsDesc": "How invoices are sent to recipients.",
        "sendOnUpload": "Send on upload",
        "sendOnUploadDesc": "Automatically send the email link to the recipient immediately after an invoice file is uploaded.",
        "sendOnUploadHint": "The email will only be sent if the recipient's email address exists.",
        "sendOnQuestionnaireSubmit": "Send after consent signed",
        "sendOnQuestionnaireSubmitDesc": "Automatically send the email link to the recipient as soon as they fill out and sign the consent.",
        "sendOnQuestionnaireSubmitHint": "Only affects invoices that haven't been sent yet, e.g. because the email address or consent was missing beforehand.",
        "requireLegalAcceptance": "Require legal acceptance before sending",
        "requireLegalAcceptanceDesc": "When enabled, invoices can only be sent after the recipient has completed the questionnaire and accepted the terms, conditions and data protection.",
        "requireLegalAcceptanceWarning": "Warning: invoices will be sent without confirming the recipient's legal acceptance of terms, conditions and data protection.",
        "questionnairePostOption": "Offer postal delivery in the e-consent",
        "questionnairePostOptionDesc": "In the e-consent (sent by email or via QR code), patients can choose to receive invoices by post only. Only postal consent is then given and the patient is marked \"Post only\".",
        "requireLegalAcceptanceConfirm": "Are you sure you want to send invoices without the recipient's legal acceptance of terms, conditions and data protection?",
        "questionsEnabled": "Patient questions enabled",
        "questionsEnabledDesc": "When disabled, recipients cannot ask questions via the portal and the questions tab on invoices is hidden.",
        "tagsEnabled": "Tags enabled",
        "tagsEnabledDesc": "When disabled, tags are no longer available in the invoice list, the PAD import, or on invoices.",
        "hideCategoryLabels": "Hide category labels",
        "hideCategoryLabelsDesc": "When enabled, category labels such as \"Auslage / Material:\" or \"Porto:\" are no longer shown on invoices or their PDFs.",
        "groupsEnabled": "Patient groups enabled",
        "groupsEnabledDesc": "When disabled, patient groups are no longer available in the patient list or on patient records.",
        "csvAutoExport": "Automatic CSV export",
        "csvAutoExportDesc": "Regularly sends a CSV invoice export by email.",
        "csvExtraEmails": "Additional recipients",
        "csvExtraEmailsDesc": "Extra email addresses that receive the export.",
        "csvExtraEmailsPlaceholder": "Enter an email address and press Enter",
        "csvInterval": "Send interval",
        "csvIntervalDesc": "How often the export is sent automatically.",
        "csvIntervalDays": "Days",
        "csvIntervalWeeks": "Weeks",
        "csvIntervalMonths": "Months",
        "csvWhichInvoices": "Which invoices?",
        "csvWhichInvoicesDesc": "Which invoices to include in the CSV export.",
        "csvFilterAll": "All",
        "csvFilterPaid": "Paid only",
        "csvFilterPaidPartial": "Paid & partial payment",
        "csvAmountMin": "Min. amount (€)",
        "csvAmountMinDesc": "Only export invoices from this amount upwards.",
        "emailLink": "Email link",
        "postOffice": "Post office",
        "bdtFileLocation": "BDT file location",
        "bdtFileLocationDesc": "Path to the BDT file used for importing patient data.",
        "padFolderLocation": "PAD folder location",
        "padFolderLocationDesc": "Folder where PAD billing files are stored.",
        "smtpConfigured": "Your custom SMTP server will be used to send emails.",
        "smtpNotConfigured": "No custom SMTP configured — Medinvoice's email server will be used.",
        "smtpDisabled": "SMTP disabled — emails will not be sent via this server.",
        "smtpActive": "SMTP enabled",
        "smtpActiveDesc": "Turn SMTP on or off.",
        "smtpClear": "Clear fields",
        "smtpHost": "Host",
        "smtpHostDesc": "e.g. smtp.example.com",
        "smtpPort": "Port",
        "smtpPortDesc": "Common values: 587 (STARTTLS) or 465 (SSL/TLS)",
        "smtpSecure": "SSL/TLS",
        "smtpSecureDesc": "Enable for port 465. Leave off for STARTTLS (port 587).",
        "smtpSecureLabel": "Use SSL/TLS",
        "smtpUsername": "Username",
        "smtpUsernameDesc": "SMTP login username or email",
        "smtpPassword": "Password / API key",
        "smtpPasswordDesc": "SMTP password or app-specific key",
        "smtpFromAddress": "From address",
        "smtpFromAddressDesc": "The sender's email address.",
        "smtpFromName": "Sender name",
        "smtpFromNameDesc": "Display name shown to recipients as the sender.",
        "smtpFromNamePlaceholder": "e.g. Praxis Müller",
        "smtpTest": "Test server",
        "smtpTestTitle": "Send test email",
        "smtpTestDesc": "Enter an email address to send a test message to.",
        "smtpTestSend": "Send",
        "smtpTestSending": "Sending…",
        "smtpTestOk": "Test email sent successfully.",
        "smtpTestFailed": "Failed to send test email.",
        "emailTemplates": "Email Templates",
        "emailSubjectPlaceholder": "Email subject (optional)",
        "emailSubject": "Subject",
        "emailBody": "Message",
        "emailPreview": "Preview",
        "emailSendToMe": "Send to me",
        "emailSendConfirmDesc": "This test email will be sent with sample data.",
        "emailSendTo": "To",
        "emailPreviewTitle": "Email Preview",
        "emailTemplateInvoice": "New invoice",
        "emailTemplateInvoiceDesc": "Text included when a new invoice is sent.",
        "emailTemplateResent": "Re-sent invoice",
        "emailTemplateResentDesc": "Text included when an invoice is re-sent.",
        "emailTemplateFriendly": "Friendly reminder",
        "emailTemplateFriendlyDesc": "Text for the first dunning notice.",
        "emailTemplateDemanding": "Demanding reminder",
        "emailTemplateDemandingDesc": "Text for the second dunning notice.",
        "emailTemplateFinal": "Final notice",
        "emailTemplateFinalDesc": "Text for the final dunning notice.",
        "emailTemplateQuestionnaire": "Consent",
        "emailTemplateQuestionnaireDesc": "Text sent with the digital-invoice consent link.",
        "tabPost": "Post",
        "tabLetterTemplates": "Letter Templates",
        "letterTemplatesDesc": "These texts are printed as a cover sheet before the invoice when sending by post.",
        "letterTemplateInvoice": "Invoice",
        "letterTemplateLegal": "Collections / Legal",
        "letterTemplateInvoiceInfo": "The invoice is sent as a medical bill, exactly as shown in 'View PDF'. No separate cover letter is required.",
        "letterTemplateLegalInfo": "Legal action information is already declared within the M3 dunning letter. No separate template is needed.",
        "letterTemplateDesc": "Printed as a cover page before the invoice. Leave blank for no cover page.",
        "letterQrCode": "Include Scan & Pay QR code",
        "letterPreview": "Preview",
        "letterPreviewTitle": "Letter Preview",
        "noTeamMembers": "No team members found.",
        "teamPlanHint": "Your plan includes {{doctors}} doctor(s)/admin(s) and {{staff}} staff member(s). Extra doctors/admins cost €39/month, extra staff €9,90/month (excl. 19% VAT).",
        "addMemberCostWarn": "Adding this member costs {{fee}}/month (excl. 19% VAT) and is billed in full for the current month, effective immediately. You can remove them again at any time; our Terms of Service (AGB) apply.",
        "deleteMemberBillingNote": "This month's {{fee}}/month charge for this seat still applies, whichever option you choose — the reduction only appears on your invoice from the 1st of next month.",
        "deleteAckLabel": "I understand that {{fee}}/month will still be charged for {{name}} this month.",
        "deleteModeImmediate": "Delete immediately",
        "deleteModeImmediateDesc": "Access is revoked right away. To undo this, you'll need to add them again as a new member.",
        "deleteModeEndOfMonth": "Delete at end of month",
        "deleteModeEndOfMonthDesc": "They keep full access until then. Removal happens automatically on the 1st of next month — you can cancel it anytime before that.",
        "scheduledForRemoval": "removal scheduled: {{date}}",
        "cancelScheduledRemoval": "Cancel removal",
        "deleteMemberTitle": "Remove {{name}}?",
        "roleDesc": {
            "1": "No invoice access by default — view and edit access can be granted per person in the table below. Sees the whole praxis's patients.",
            "2": "Sees own invoices; can create, edit and delete invoices. Sees the whole praxis's patients.",
            "3": "Full access to settings and team members; sees own invoices unless granted broader access. Sees the whole praxis's patients.",
            "5": "Sees all praxis invoices by default; view and edit access can be adjusted per person in the table below. Sees the whole praxis's patients."
        },
        "rolesInfoBtn": "Roles Info",
        "rolesInfoTitle": "Role Overview",
        "sharedSettingsNoticeP1": "Settings like dunning schedules, invoice format, or email templates apply praxis-wide — they can't be set separately per doctor or member.",
        "sharedSettingsNoticeP2": "Bank & Payments and the invoice PDF layout are the exception: each doctor/admin's IBAN/BIC, bank-feed connection, and PDF layout (header/footer, logo, fonts) are their own, and only fall back to the praxis's default when nothing's been set individually. Everyone only edits their own.",
        "sharedSettingsNoticeP3": "The permissions below only control who can view or change these settings.",
        "permissionsHeading": "Permissions",
        "rolesTable": {
            "hint": "Invoices are private to each person by default — not visible to other doctors. Patients, on the other hand, are shared across the whole praxis. This table controls invoice visibility and other permissions.",
            "feature": "Feature",
            "groupInvoices": "Invoices & Patients",
            "groupAdmin": "Practice Administration",
            "groupBank": "Bank",
            "groupTags": "Tags & Groups",
            "groupDashboard": "Dashboard",
            "viewAllInvoices": "All invoices (practice-wide)",
            "viewAllInvoicesHint": "Without this permission, this person only sees their own invoices. With it, they see every doctor's.",
            "viewAllInvoicesSub": "otherwise: own only",
            "viewAllFixedHint": "This role always sees and edits only their own invoices — this is fixed behavior, not a grantable permission.",
            "bankFixedOwnHint": "This role always sees and reconciles only their own bank account — this is fixed behavior, not a grantable permission.",
            "accessNone": "Off",
            "accessView": "View",
            "accessEdit": "Edit",
            "accessEditDelete": "Edit + Delete",
            "editInvoices": "Create / edit invoices",
            "deleteInvoices": "Delete invoices",
            "viewPatients": "View patients",
            "editPatients": "Edit patients",
            "manageRecipients": "Manage recipients & patients",
            "manageRecipientsHint": "Patients are visible to everyone in the practice — not part of this permission. \"Edit\" allows creating/updating; \"Edit + Delete\" also allows deleting (which may remove other doctors' invoices for that same patient too) — on by default for Doctors and Admins, MedicalAssistant/Accounting need it explicitly granted.",
            "bankPayments": "Bank & payments",
            "bankReconcile": "Reconcile bank transactions",
            "bankReconcileHint": "Manually match a transaction to an invoice, unmatch it, ignore/unignore it, and notify a patient about a possible duplicate payment. Independent of \"Bank & payments\" (View) — someone can see the statements without being allowed to act on them. Connecting/disconnecting/syncing the bank connection itself always stays with Doctors/Admins.",
            "reports": "Reports & CSV export",
            "dunning": "Dunning & Inkasso",
            "datev": "DATEV export",
            "datevHint": "Steuerberater (accountant) account config for the DATEV export (EXTF). Admin-only by default, since an incorrect value misdirects the praxis's real accounting.",
            "datevSub": "otherwise: Admin only",
            "createForOthers": "Create invoices for other doctors",
            "createForOthersSub": "Upload and create by hand – otherwise only for themselves",
            "createForOthersHint": "Doctors and admins create and upload invoices only for themselves by default. With this right they pick the treating doctor. Staff without invoices of their own always pick.",
            "createForOthersStaff": "always picks",
            "createForOthersStaffHint": "Staff have no invoices of their own and always pick the doctor when creating one.",
            "manageSettings": "Settings & Team",
            "viewTagsGroups": "View tags & groups",
            "editTagsGroups": "Manage tags & groups",
            "dashboardTasks": "Dashboard tasks",
            "dashboardTasksHint": "Shows the task list (unsent invoices, missing consent, open questions, etc.) on the dashboard. Medical assistants and accounting staff otherwise see a simplified dashboard without this list.",
            "dashboardTasksSub": "otherwise: hidden",
            "pvsSavings": "PVS savings figure",
            "pvsSavingsHint": "Shows the cost-savings-vs-PVS figure on the dashboard. The Charges page itself (where it's configured) stays Admin-only regardless — a non-Admin with this granted sees the number but can't open that page.",
            "pvsSavingsSub": "otherwise: hidden",
            "bankDashboard": "Bank summary on Dashboard",
            "cardQr": "Card payment at the desk",
            "cardQrSub": "SumUp QR code and card terminal",
            "cardQrHint": "May show a QR code for card payment via SumUp on open invoices and send the amount to a paired SumUp card terminal; the invoice is marked as paid automatically after payment. Doctors and admins by default, staff only when granted.",
            "bankDashboardHint": "Shows the account balance and a preview of recent transactions on the Dashboard. Independent of \"Bank & payments\" — someone can be allowed to open the Bank page without that figure also appearing unprompted on the shared Dashboard.",
            "bankDashboardSub": "otherwise: hidden",
            "bankDoctorScope": "Account",
            "bankDoctorScopeAll": "All doctors",
            "own": "own",
            "all": "all",
            "allRO": "all (read-only)"
        },
        "addMember": "+ Add Member",
        "newMember": "New Member",
        "editMember": "Edit Member",
        "addMemberBtn": "Add Member",
        "saveChangesBtn": "Save Changes",
        "daysUnit": "Days",
        "weeksUnit": "Weeks",
        "saved": "Saved",
        "saveChanges": "Save changes",
        "emailAccountDesc": "The email address associated with your account.",
        "deviatingAddressTitle": "Alternative invoice sender",
        "deviatingAddressDesc": "Optional. Used as the sender on your invoices instead of the praxis. Leave individual fields empty to use the praxis's value there.",
        "senderOrgName": "Organization name",
        "company": "Company",
        "version": "Version",
        "roleRequired": "Role *",
        "emailRequired": "Email *",
        "passwordLabel": "Password",
        "passwordKeep": "(leave blank to keep)",
        "changePassword": "Change Password",
        "currentPassword": "Current Password",
        "newPassword": "New Password",
        "confirmPassword": "Confirm Password",
        "pwAllFieldsRequired": "All fields are required.",
        "pwTooShort": "Password must be at least 6 characters.",
        "pwMismatch": "Passwords do not match.",
        "pwError": "Failed to change password.",
        "resetMemberPasswords": "Reset Team Passwords",
        "resetMemberPasswordsDesc": "As admin you can reset passwords for other team members.",
        "resetPassword": "Reset",
        "resetPasswordFor": "Reset password for {{name}}",
        "resetPasswordBtn": "Set Password",
        "specialtyRequired": "Specialty *",
        "specialty": "Specialty",
        "selectSpecialty": "select specialty",
        "saving": "Saving…",
        "emailInvalid": "Invalid email address.",
        "passwordTooShort": "Minimum 8 characters required.",
        "passwordNeedsSpecial": "At least one special character required (!@#$%^&* …).",
        "errorAddMember": "Last name, email and password are required.",
        "errorFailedAddDoctor": "Failed to add member.",
        "errorEditMember": "Last name and email are required.",
        "errorFailedSave": "Failed to save changes.",
        "errorBugTitleDesc": "Title and description are required.",
        "errorFailedSend": "Failed to send. Please try again.",
        "emailLinkEnable": "Enable email link",
        "emailLinkEnableDesc": "An email link will be sent to the recipient.",
        "emailLinkOptions": "Email link options",
        "emailLinkOptionsDesc": "Choose how the recipient receives and accesses their invoice. At least one option must be active.",
        "emailLinkLoginDesc": "Recipient logs in with their email and password to access their invoice.",
        "emailLinkSmsOtpDesc": "Recipient receives the invoice directly via a one-time SMS code — no account login required.",
        "postSendOnUploadDesc": "Automatically send invoice by post as soon as a PAD file is uploaded.",
        "post": "Post",
        "postBillingNotice": "Notice: Every letter sent via post office will be charged to your account. Costs are collected at the end of each month.",
        "postTrialDisabled": "Post sending is not available during the trial period. Please upgrade your plan to send letters.",
        "postEnable": "Enable post sending",
        "postEnableDesc": "Allows sending invoices by post.",
        "postColor": "Color",
        "postColorDesc": "Print color for letters.",
        "postColorOption": "Color",
        "postPrint": "Print",
        "postPrintDesc": "Single-sided or double-sided printing.",
        "postEnvelope": "Envelope",
        "postEnvelopeDesc": "Type of envelope to use.",
        "postDispatch": "Dispatch",
        "postDispatchDesc": "How quickly the letter is dispatched.",
        "postDispatchStandard": "Standard",
        "postRegisteredMail": "Registered Mail",
        "postRegisteredMailDesc": "Send letter as registered mail (Einschreiben).",
        "postRegisteredMailNone": "No registered mail",
        "postRegisteredMailR1": "r1 – Einschreiben Einwurf",
        "postRegisteredMailR2": "r2 – Einschreiben (standard)",
        "postRegisteredMailNationalOnly": "Registered mail can only be sent nationally.",
        "postShipping": "Shipping",
        "postShippingDesc": "Delivery region for the letter.",
        "postShippingNational": "National",
        "postShippingInternational": "International",
        "postEstimatedCost": "Cost per letter:",
        "postEstimatedCostSuffix": "(estimate)",
        "postColorBW": "B&W",
        "postPrintSimplex": "Simplex",
        "postPrintDuplex": "Duplex",
        "postEnvelopeWindowRight": "Window (right)",
        "postEnvelopeWindowLeft": "Window (left)",
        "postEnvelopeC4": "C4 (window)",
        "postWillBeSentTo": "Will be sent to",
        "postWillBeSentFrom": "Will be sent from",
        "postPages": "Pages",
        "postPagesDesc": "Number of pages for cost estimation",
        "postVatIncluded": "incl. 19% VAT",
        "reports": "Reports",
        "reportInterval": "Report interval",
        "reportIntervalDesc": "How often a report should be automatically generated.",
        "monthsUnit": "Months",
        "everyDay": "Every day",
        "everyWeek": "Every week",
        "everyNWeeks": "Every X weeks",
        "everyMonth": "Every month",
        "everyNMonths": "Every X months",
        "monday": "Mon",
        "tuesday": "Tue",
        "wednesday": "Wed",
        "thursday": "Thu",
        "friday": "Fri",
        "saturday": "Sat",
        "sunday": "Sun",
        "firstDayOfMonth": "First day",
        "lastDayOfMonth": "Last day",
        "generateReport": "Generate report now",
        "generateReportDesc": "Download a PDF report of all invoice activity for the logged-in doctor.",
        "generateNow": "Generate now",
        "generating": "Generating…"
    },
    "docs": {
        "eyebrow": "DOCUMENTATION",
        "title": "Documentation",
        "pageLead": "How invoices, dunning and bank reconciliation work in your practice.",
        "schnellstart": {
            "title": "Quick Start",
            "q0": "The complete journey from billing file to paid invoice — in 8 steps.",
            "a0": "<ol class=\"docs-steps\"><li><strong>Upload the PAD or PADnext file</strong><br>Export your PAD or PADnext file from your practice software and upload it in the dashboard. One file kicks off the entire billing process.<br><span class=\"docs-path\">Dashboard › Upload</span></li><li><strong>Invoices &amp; recipients are parsed</strong><br>Medinvoice analyses the file automatically — invoices, recipients and linked patients are detected and created. No manual entry needed.</li><li><strong>Add the recipient's email address</strong><br>Enter the recipient's email address the first time so that the questionnaire and invoice link can be delivered. If you run onboarding on-site (see step 4), the billing recipient will provide this themselves.<br><span class=\"docs-path\">Patients › Open recipient › Edit email</span></li><li><strong>Send the questionnaire</strong><br>Send the questionnaire to the patient first — this step is required before the invoice can be sent digitally. The patient can alternatively scan a QR code on-site to go straight to the questionnaire.<br><em>Tip: The questionnaire is the best first touchpoint — it collects patient data, consent and billing address in one step. Any corrections are automatically applied in Medinvoice.</em></li><li><strong>Patient completes &amp; signs consent</strong><br>The patient fills in the required fields and accepts digital invoice delivery and data protection with their digital signature. The details are automatically imported into Medinvoice and the questionnaire is stored as a PDF.</li><li><strong>Send the invoice link</strong><br>Send the personal patient portal link by email — individually, for multiple invoices, or automatically for all. The patient can open the invoice at any time — no app required.<br><em>Note: Invoices not yet sent can be partially edited (amount, master data). Direct editing is not possible after sending.</em></li><li><strong>Patient receives the invoice link</strong><br>The patient opens the link and chooses:<br>1) Download the invoice as a PDF immediately — via SMS one-time code (OTP)<br>2) Register in the portal to view and pay all invoices from Medinvoice® practices in one place.</li><li><strong>Mark as paid</strong><br>Once a payment is received, the invoice is automatically marked as paid via bank reconciliation. For unclear payments, the match can be done manually.<br><span class=\"docs-path\">Invoices › Open invoice › Mark as paid</span></li></ol>"
        },
        "onboarding": {
            "title": "Onboarding",
            "note": "Patient data and billing recipient data are only partially included in uploaded invoice files. Email address and mobile number are not transmitted.",
            "q0": "How does the system obtain the billing recipient's email address and mobile number?",
            "a0": "The email address and mobile number can be entered manually by the practice team. A more elegant approach is via the patient questionnaire.",
            "q1": "Can the billing recipient fill in the questionnaire right at the practice?",
            "a1": "The questionnaire can be delivered to the billing recipient in 2 ways:\na) By email, after the email address has been entered manually in the billing recipient's master data.\nb) More elegantly: select the billing recipient, scan the QR code (phone/tablet) – the questionnaire can be filled in on-site.",
            "q2": "Can additional persons be assigned to a billing recipient via the questionnaire, even if they have not yet received an invoice?",
            "a2": "Yes! Once the billing recipient receives the questionnaire, they can fill it in once — for themselves and all persons in their care. Note: this feature is especially useful for paediatric practices, but also for patients where a different billing recipient must be recorded (guardian, institution, etc.).",
            "q3": "What happens to the questionnaire after the billing recipient submits it?",
            "a3": "The completed and signed questionnaire is stored in the patient's record and can be opened as a PDF in the Questionnaire tab. At the same time, the data is reconciled and imported. Patients not yet in the system are created and automatically assigned to the billing recipient.",
            "q4": "Do I need to obtain the patient's consent for digital invoice delivery?",
            "a4": "Yes. For digital invoice delivery it is advisable to obtain the billing recipient's consent. Medinvoice has implemented this as part of the questionnaire process.",
            "q5": "Can I bring over my existing patients from my previous software?",
            "a5": "Yes, with a CSV file. Export the patient list from your previous software, open the Patients page and choose \"…\" at the top right → \"Import CSV\". Medinvoice recognises the columns, shows every patient for review (you can untick single rows) and skips patients that already exist. Minors are assigned to a billing recipient. Without a CSV, patients are also created automatically when you upload a PAD file or through the practice software sync.<br><span class=\"docs-path\">Patients › … › Import CSV</span>"
        },
        "invoices": {
            "title": "Invoices",
            "q0": "Can I upload multiple invoices at once?",
            "a0": "Yes. Batch upload of multiple invoices is supported so that larger billing runs can be processed efficiently.",
            "q1": "What delivery options are available?",
            "a1": "Email with a personal invoice link (patient opens the invoice in their browser) or physical letter dispatch via our interface. Both options can be enabled simultaneously.<br><span class=\"docs-path\">Settings › Invoices</span>",
            "q2": "Can multiple invoices be sent at the same time?",
            "a2": "Yes, multiple invoices can be sent both digitally and by letter. Select the relevant invoices and follow the available sending options.",
            "q3": "How are invoices sent digitally?",
            "a3": "The invoice can be made available via a secure download link or through the patient portal. Patients receive a notification by email and can retrieve the invoice digitally.",
            "q4": "Can access be additionally secured?",
            "a4": "Yes. Access is secured via OTP (SMS) or portal login. Which option is used depends on the desired security level and the practice's decision.",
            "q5": "Is there an expiry date for download links?",
            "a5": "Yes. Download links can be time-limited, keeping access controlled and traceable.",
            "q6": "What do the invoice statuses mean?",
            "a6": "<table class=\"docs-table\"><thead><tr><th>Status</th><th>Meaning</th></tr></thead><tbody><tr><td><strong>Uploaded – not sent</strong></td><td>Imported, not yet sent</td></tr><tr><td><strong>Sent – open</strong></td><td>Invoice has been delivered to the recipient</td></tr><tr><td><strong>Overdue</strong></td><td>At least one dunning level triggered (M1 / M2 / M3)</td></tr><tr><td><strong>Paid</strong></td><td>Payment recorded or matched via bank reconciliation</td></tr><tr><td><strong>Written off</strong></td><td>Receivable manually written off</td></tr></tbody></table>",
            "q7": "Can I correct an invoice after the fact?",
            "a7": "Invoices not yet sent can be partially edited — master data and invoice amount can be changed before sending. Already sent invoices can only be cancelled and recreated.<br><em>Important: Direct editing is not possible after sending — cancel the invoice and create a new one.</em>",
            "q8": "Can I send invoices individually?",
            "a8": "Yes. You can send each invoice with a single click after reviewing it. You can also select multiple invoices and send them all at once.",
            "q9": "Can invoices be sent automatically after uploading?",
            "a9": "1) Digitally: yes, if email address, mobile number (needed for 2FA via SMS) and consent are on file — otherwise not.\n2) By letter: always possible.\n3) Both options must be configured in Settings first.<br><span class=\"docs-path\">Settings › Invoice settings › Enable send on upload</span>",
            "q10": "Can invoices still be sent by letter?",
            "a10": "Yes. There will be patients who prefer the traditional route.<br><em>Note: Letter dispatch is billed separately and is not included in the subscription price.</em>",
            "q11": "Can an invoice be resent?",
            "a11": "Yes. The link can be resent or a new notification sent if the patient cannot retrieve the invoice or can no longer find the email.<br><span class=\"docs-path\">Invoice view › Resend invoice</span>",
            "q12": "Can the practice see whether an invoice has been received?",
            "a12": "The practice can see whether an invoice has been sent and retrieved. This makes the invoice status more transparent than with traditional letter delivery.",
            "q13": "Can I see whether patients have downloaded the invoice?",
            "a13": "Yes. The retrieval/download status is a central feature. It lets the practice see whether an invoice has already been viewed.",
            "q14": "Is there an audit log per invoice?",
            "a14": "Yes. An invoice log shows when an invoice was created, sent, retrieved, reminded, dunned or paid.<br><span class=\"docs-path\">Invoices › Select invoice › Audit Log tab</span>",
            "q15": "Can I filter open invoices?",
            "a15": "Yes. Filterable by: open, overdue, retrieved, not retrieved, paid, dunned."
        },
        "createInvoice": {
            "title": "Creating invoices",
            "note": "Without practice software – or for the odd invoice in between: write invoices directly in Medinvoice, step by step, with GOÄ help.",
            "q0": "How do I create an invoice without practice software?",
            "a0": "Click <strong>Create invoice</strong> – on the Dashboard or the Invoices page. Five steps on one page: <strong>Patient</strong> (search or add), <strong>Treatment</strong> (doctor, treatment days, at least one diagnosis – from ICD-10-GM with certainty G/V/A/Z and, if needed, side R/L/B, or as free text), <strong>Services</strong> (search a GOÄ code – digits search the number, with letters the description; single rate and factor range are filled in; drag by the handle to reorder), <strong>Check</strong> and <strong>Preview</strong> with the PDF. Then <em>Create</em> or <em>Create &amp; send</em>. There's no invoice date to enter – as for every invoice, it's the day it's sent.<br><span class=\"docs-path\">Invoices › Create invoice</span>",
            "q1": "What is checked before creating?",
            "a1": "<strong>Red – blocks creating:</strong> no patient or recipient, no doctor, a treatment day in the future, no diagnosis, a day without services, a line without code, description or single rate, a factor outside the range, a missing justification above the threshold, neither email nor postal address.<br><strong>Amber – a hint only:</strong> a code outside the GOÄ catalogue (e.g. analogue codes), missing consent, the same code more than once on one day (confirm it once as <em>Bill like this on purpose</em>).<br><em>The PDF can be viewed once patient, treatment and services are complete.</em>",
            "q2": "Is my work lost if I close the page?",
            "a2": "No. Everything is saved as a <strong>draft</strong> automatically. <strong>Exit</strong> leaves the page at any step; continue from the violet <strong>Drafts</strong> button on the Invoices page. Drafts are personal and don't count as invoices.<br><span class=\"docs-path\">Invoices › Drafts</span>",
            "q3": "How do I use invoice templates?",
            "a3": "Save recurring services as a <strong>template</strong> – for yourself or the whole practice. In step 3 every treatment day has <em>Insert template</em> and <em>Save as template</em>; templates over several days fill the following treatment days. Any existing invoice can also be saved as a template from its Services tab.<br><span class=\"docs-path\">Settings › Invoice templates</span>",
            "q4": "What do the GOÄ check and suggestions do?",
            "a4": "<strong>GOÄ check (Pro):</strong> codes that may not be billed together, per-session limits, missing base codes – each finding is corrected or confirmed as <em>Bill like this on purpose</em>.<br><strong>Suggestions (Plus and above):</strong> codes you usually bill together or with this diagnosis, your usual factor – each with the GOÄ name and the reason, only from your practice's own invoices. Already in step 2 diagnoses you often enter together, in step 3 the codes for the diagnoses. Diagnoses marked A or V don't trigger suggestions.",
            "q5": "Consent, sending and afterwards?",
            "a5": "If consent is missing, get it in step 1 – at the desk by QR code or on paper, otherwise by link via email or SMS. Creating works without it; only sending waits. <strong>Create &amp; send</strong> emails the portal link right away. Afterwards it's a normal invoice (<em>Created by hand</em>); until it's sent, its services can be corrected on every plan."
        },
        "dunning": {
            "title": "Dunning",
            "q0": "How do I configure the dunning levels?",
            "a0": "Set the intervals in days after the due date for each dunning level and the delivery method per level. Medinvoice triggers reminders automatically. Days are counted from the date the invoice was sent.<br><br><table class=\"docs-table\"><thead><tr><th>Level</th><th>Name</th><th>Delivery</th></tr></thead><tbody><tr><td>No dunning</td><td>Invoice open within payment period</td><td>none</td></tr><tr><td>M1</td><td>Payment reminder</td><td>Email, letter or both</td></tr><tr><td>M2</td><td>Dunning notice</td><td>Email, letter or both</td></tr><tr><td>M3</td><td>Final notice</td><td>Email, letter or both</td></tr><tr><td>Collections</td><td>Handover to debt collection possible</td><td>Email from system to practice only</td></tr><tr><td>Handed over</td><td>Invoice handed to debt collection or lawyer</td><td>Email from system to practice only</td></tr></tbody></table><br><em>Note: For the final dunning level, the default delivery is letter and email.</em><br><span class=\"docs-path\">Settings › Dunning</span>",
            "q1": "Can I charge dunning fees?",
            "a1": "Yes. Enable dunning fees and set the amount per level. Fees are legally stated in the reminder.<br><span class=\"docs-path\">Settings › Dunning</span>",
            "q2": "Can I use custom dunning texts?",
            "a2": "Yes. The practice can store custom text templates or adjust the existing ones per dunning level. This applies to both email and letter delivery.<br><em>Tip: You can very easily send a test email to yourself to check your changes.</em>",
            "q3": "Is there a traffic-light status indicator?",
            "a3": "Yes. A traffic-light status helps identify critical invoices at a glance: green for uncritical, orange for dunning level, and red for final notice.",
            "q4": "What happens after the final dunning level?",
            "a4": "It is up to you which path you take. You can hand the receivable over to a debt collection agency of your choice, or use the built-in Paywise interface to assign the invoice digitally directly from the invoice view. You would need to open an account with Paywise once.<br><em>Note: The handover to collections is a manual step — Medinvoice does not trigger it automatically. The system flags the overdue invoice and notifies the practice.</em>",
            "q5": "Can I pause dunning for a specific invoice?",
            "a5": "Yes. Simply enable this function directly on the relevant invoice.<br><span class=\"docs-path\">Invoices › Select invoice › Enable pause dunning</span>"
        },
        "bank": {
            "title": "Bank Reconciliation & Connection",
            "q0": "How do I connect my account?",
            "a0": "Follow the guided open banking process. You will be asked to log in as you would for online banking and select the account for incoming payments. No direct access to transactions is granted – only read access to incoming payments. We do not require your login credentials for the reconciliation.\n\nSettings › Bank & Payments › Connect bank",
            "q1": "Is the account access secure?",
            "a1": "Yes. We use the access provided by BANKSapi. BANKSapi is regulated by BaFin, and through this Medinvoice gains access to the Account Information Service (AIS) required for reconciliation.",
            "q2": "Can Medinvoice automatically detect incoming payments?",
            "a2": "Yes. Via a bank connection, incoming payments can be matched against open invoices.",
            "q3": "How does payment reconciliation work?",
            "a3": "Matching is done using invoice number, amount, billing recipient name and other references. Unambiguous matches can be assigned automatically.",
            "q4": "What happens with unclear payments?",
            "a4": "Unclear payments are not booked blindly but are added to a list for manual review.",
            "q5": "Is anything posted directly to accounting?",
            "a5": "Medinvoice can assign incoming payments and update the invoice status. A direct posting to a financial accounting system does not currently exist.",
            "q6": "Can patients pay by card?",
            "a6": "Coming soon, on every plan, through your own SumUp account. Patients will then pay in the patient portal by card, Apple Pay or Google Pay on a secure SumUp payment page; the money goes straight to your practice and Medinvoice never sees card details. The invoice is marked as paid automatically. At the desk, patients pay by QR code with their own phone or – with a paired SumUp Solo – on the card terminal Medinvoice sends the amount to. This only applies to payments started in Medinvoice: Medinvoice can't see amounts you enter yourself on the SumUp terminal or in the SumUp app, or your own SumUp links – please mark those invoices as paid manually. An Admin chooses where card payment is offered (portal, QR code, card terminal) on the same settings page. SumUp charges you a fee per payment – a surcharge for patients is not allowed.\n\nSettings › Card payment (SumUp)"
        },
        "portal": {
            "title": "Patient Portal",
            "q0": "What does the patient portal offer?",
            "a0": "Patients can view, download and pay invoices (via QR code), check the current dunning status, and contact the practice with questions.",
            "q1": "Is the patient portal free for patients?",
            "a1": "Yes. The patient portal is free for patients.",
            "q2": "Is the patient portal mandatory for patients?",
            "a2": "No! To receive an invoice, the billing recipient can also download it directly by requesting a one-time code via SMS (OTP).",
            "q3": "Can patients see multiple invoices in one place?",
            "a3": "Yes. The goal is a central portal where patients can see all their invoices from participating practices clearly listed in one place.",
            "q4": "Can parents see their children's invoices?",
            "a4": "Yes. For families, a billing recipient function is useful where multiple patients can be assigned to one billing recipient.",
            "q5": "Is there a QR code for bank transfers?",
            "a5": "Yes. A QR payment code for bank transfers simplifies the payment process and avoids typing errors.",
            "q6": "Can invoices be forwarded to private health insurance (PKV) or Beihilfe?",
            "a6": "Medinvoice can help patients prepare invoices for PKV or Beihilfe. Direct handover depends on the interfaces of the respective insurer or app.",
            "q7": "Can patients ask questions about their invoice?",
            "a7": "Yes. A communication function to the practice is available so that queries about a specific invoice can be raised. For example, proof of material costs can be transmitted on request. This function can be disabled by the practice if needed."
        },
        "team": {
            "title": "Team Members",
            "note": "Depending on the size of the practice, it may make sense to configure multiple roles.",
            "q0": "Are there different role and permission assignments?",
            "a0": "Yes. Depending on the plan booked, multiple doctors and team members can be defined.",
            "q1": "Can individual members receive different permissions?",
            "a1": "Yes. The administrator sets up the roles for team members (Administrator, Doctor, Medical Assistant, Accounting) and can assign individual permissions to each.",
            "q2": "Can multiple doctors be set up and can they bill separately?",
            "a2": "Yes. This is designed for group practices (BAG) and medical care centres (MVZ). Each doctor has their own sub-account linked to the practice/MVZ. Each doctor can also set up their own bank details for incoming payments and connect their own bank account."
        },
        "videos": {
            "title": "User Videos",
            "q0": "Are there tutorial videos for Medinvoice?",
            "a0": "We are currently building a video library with step-by-step guides for all key features. The videos will be available here shortly."
        }
    },
    "bugReport": {
        "title": "Zaala",
        "reportBug": "Report a Bug",
        "thankYou": "Thank you! Your report has been sent.",
        "close": "Close",
        "bugArea": "Area *",
        "bugAreaPlaceholder": "Select an area…",
        "areaInvoices": "Invoices",
        "areaPatients": "Patients / Recipients",
        "areaEmail": "Email / Notifications",
        "areaPortal": "Patient Portal",
        "areaSettings": "Settings",
        "areaBilling": "Billing / Subscription",
        "areaOther": "Other",
        "bugTitle": "Title *",
        "bugTitlePlaceholder": "Short summary of the issue",
        "bugDescription": "Description *",
        "bugDescriptionPlaceholder": "Steps to reproduce, what you expected, what happened...",
        "cancel": "Cancel",
        "sending": "Sending…",
        "sendReport": "Send Report"
    },
    "suggestion": {
        "helpUsImprove": "Help us improve",
        "modalTitle": "Share a suggestion",
        "modalLead": "Have an idea for a new feature or an improvement? Tell us — we read everything.",
        "titleLabel": "What would you like to see? *",
        "titlePlaceholder": "Short summary of your idea",
        "descLabel": "Tell us more",
        "descPlaceholder": "Any details, context or examples that would help us understand…",
        "send": "Send",
        "sendPortalLink": "Send portal link",
        "sending": "Sending…",
        "thankYou": "Thank you! We appreciate your feedback.",
        "cancel": "Cancel"
    },
    "referral": {
        "button": "Refer a colleague",
        "modalTitle": "Recommend Medinvoice",
        "modalLead": "Open your email client with a ready-to-send message — or copy the text and share it however you like.",
        "messageLabel": "Message (editable)",
        "copy": "Copy text",
        "copied": "Copied ✓",
        "openEmail": "Open in email client",
        "subject": "Recommendation: Medinvoice – digital private billing",
        "close": "Close"
    },
    "form": {
        "salutation": "Salutation",
        "salutationRequired": "Salutation *",
        "title": "Title",
        "firstName": "First name",
        "lastName": "Last name",
        "gender": "Gender",
        "birthDate": "Birth date",
        "email": "Email",
        "phone": "Phone",
        "phonePlaceholder": "+491511234567",
        "street": "Street",
        "streetAndNumber": "Street & Nr.",
        "streetError": "Must include a house number (e.g. Hauptstraße 22a)",
        "houseNumber": "No.",
        "plz": "PLZ",
        "city": "City",
        "address": "Address",
        "photo": "Photo",
        "logo": "Logo",
        "change": "Change",
        "remove": "Remove",
        "addPhone": "Add phone number",
        "personal": "Personal",
        "contactAddress": "Contact & Address",
        "contact": "Contact",
        "personalContact": "Personal – Contact",
        "externalId": "ID",
        "externalIdHint": "The patient number from your practice software. It's taken over automatically during the practice-software sync and is used to recognise this patient on later imports. It can't be edited here.",
        "externalIdHintManual": "The patient number from your practice software. Enter it so later imports recognise this patient and documents can be written back to the practice software.",
        "externalIdTaken": "This patient number is already assigned to another patient.",
        "herr": "Herr",
        "frau": "Frau",
        "male": "Male",
        "female": "Female",
        "diverse": "Diverse / not specified",
        "selectGender": "— select —",
        "drPlaceholder": "Dr.",
        "cancel": "Cancel",
        "save": "Save",
        "ok": "OK",
        "delete": "Delete",
        "clear": "Clear",
        "name": "Name",
        "tel": "Tel",
        "patient": "Patient",
        "insuranceProvider": "Insurance provider",
        "insuranceNumber": "Insurance number",
        "postOnly": "Post only",
        "postOnlyHint": "Only ever send this patient's invoices by post — email/portal-link sending is disabled",
        "postOnlyConfirm": "By enabling this, this patient's invoices will only ever be sent by post. Auto-send by email (on upload, on questionnaire submission) will be skipped, and the manual email/portal-link button will be disabled — post remains the only way to send them their invoices. Dunning reminders won't go out by email either. Once every patient of the recipient is post-only, consent is no longer requested by email, SMS or QR code — only on paper.",
        "bankAccountName": "Bank account name",
        "bankAccountNamePlaceholder": "Leave empty if same as recipient name",
        "imageTooLarge": "Image must be smaller than 5 MB",
        "emailInvalid": "Invalid email address."
    },
    "createPatient": {
        "title": "New patient",
        "editTitle": "Edit patient",
        "lastNameRequired": "Please enter the last name.",
        "birthDateRequired": "Please enter the birth date.",
        "createError": "Failed to create patient.",
        "linkSelfError": "The patient was created but could not be linked as the recipient themselves. Please try again.",
        "dupIntro": "{{name}}, born {{birthDate}}, already exists in your practice. Use the existing record instead of creating the person twice.",
        "dupPatient": "Patient: {{name}}",
        "dupRecipient": "Billing recipient: {{name}}",
        "dupRecipientHint": "Already pays invoices in your practice but isn't a patient yet.",
        "dupNoRecipient": "No billing recipient",
        "dupAlreadyHere": "Already a patient of this billing recipient",
        "dupPaysSelf": "Pays for themselves ({{name}})",
        "dupPaidBy": "Billing recipient: {{name}}",
        "dupUse": "Use this one",
        "dupMoveHere": "Move here",
        "dupLinkSelf": "Mark as the recipient themselves",
        "dupCreateAsSelf": "Create as the recipient themselves",
        "dupAddToRecipient": "Create under this recipient",
        "dupMoveHint": "Moving a patient takes their invoices along. A billing recipient left without patients is removed.",
        "dupCreateAnyway": "Create anyway",
        "dupUseError": "Could not take over the existing patient. Please try again.",
        "updateError": "Failed to save patient.",
        "deleteError": "Failed to delete patient.",
        "deleteConfirm": "Delete this patient?",
        "creating": "Creating…",
        "create": "Create patient",
        "recipientSection": "Billing Recipient",
        "recipientNone": "None",
        "recipientLinkExisting": "Link existing",
        "recipientCreateNew": "Create new",
        "recipientSearch": "Search name…",
        "recipientNoResults": "No results",
        "recipientNewValidation": "Last name for the billing recipient is required.",
        "recipientCreateFailed": "Failed to create billing recipient.",
        "recipientSelf": "Self-payer",
        "recipientSelfHint": "A billing recipient will be created using the patient's data and linked automatically.",
        "recipientHasRecipient": "Has billing recipient",
        "billingQuestion": "Who should receive invoices?",
        "recipientOptionSelf": "The patient",
        "recipientOptionSelfDesc": "Invoice sent to the patient's own contact details",
        "recipientOptionOther": "Another person",
        "recipientOptionOtherDesc": "Parent, insurer, legal guardian…",
        "stepPatient": "Patient",
        "stepBilling": "Billing contact",
        "billingContactTitle": "Billing contact",
        "next": "Next",
        "back": "Back",
        "patientContext": "Patient: {{name}}"
    },
    "createRecipient": {
        "title": "New patient",
        "birthDateOptional": "Birth date (optional)",
        "validationError": "Last name is required.",
        "createError": "Failed to create patient.",
        "creating": "Creating…",
        "create": "Create patient",
        "patientSection": "Patient",
        "patientNone": "No patient",
        "patientSelf": "Self-payer",
        "patientSelfHint": "A patient will be created with the same data and linked to this recipient.",
        "patientLinkExisting": "Link existing patient",
        "patientSearch": "Search patient…",
        "patientNew": "Pays for another patient",
        "patientNewValidation": "Patient last name is required.",
        "tabRecipient": "Billing Recipient",
        "tabPatient": "Patient",
        "patientQuestion": "Is the patient the same person?",
        "patientOptionSelf": "Same person",
        "patientOptionSelfDesc": "The billing contact and patient are the same",
        "patientOptionOther": "Different patient",
        "patientOptionOtherDesc": "Child, family member, etc.",
        "stepRecipient": "Billing contact",
        "stepPatient": "Patient",
        "patientTitle": "Patient details",
        "recipientContext": "Billing contact: {{name}}",
        "next": "Next",
        "back": "Back",
        "modeQr": "Scan QR code",
        "modeQrDesc": "Patient fills in the questionnaire on their smartphone — no email address needed.",
        "modeManual": "Enter manually",
        "modeManualDesc": "Type in the patient's details directly.",
        "qrTitle": "Register patient via QR code",
        "qrHint": "Show this QR code to the patient. They can fill in the questionnaire on their smartphone right now.",
        "qrError": "Could not generate QR code. Please try again.",
        "qrPrint": "Print"
    },
    "table": {
        "id": "ID",
        "status": "Status",
        "recipient": "Recipient",
        "patient": "Patient",
        "amount": "Amount",
        "paid": "Paid",
        "remaining": "Remaining",
        "dunning": "Dunning",
        "dates": "Dates",
        "created": "Created",
        "sent": "Sent",
        "due": "Due",
        "gender": "Gender",
        "birthDate": "Birth date",
        "birthDateInvalid": "Birth date must be in the past and no more than 100 years ago.",
        "invDone": "Paid",
        "invOpen": "Open",
        "invNotSent": "Not sent",
        "name": "Name",
        "billingRecipient": "Rechnungsempfänger",
        "email": "Email",
        "info": "Info"
    },
    "filters": {
        "filters": "Filters",
        "clearAll": "Clear all",
        "createdFrom": "Created from",
        "createdTo": "to",
        "overdue": "Overdue",
        "dunningGte3": "Dunning ≥ 3",
        "sent": "Sent",
        "notSent": "Not sent",
        "all": "All",
        "amountGte": "Amount ≥",
        "amountPlaceholder": "e.g. 100",
        "hasOpen": "Has open",
        "hasPaid": "Has paid",
        "invoices": "Invoices",
        "portal": "Portal",
        "questionnaire": "Consent",
        "hasReceivedLink": "Received link",
        "questionnaireSubmitted": "Consent signed",
        "questionnaireNotSubmitted": "Sent, not signed",
        "questionnaireNotSent": "Consent not sent",
        "vat": "VAT",
        "vatIncluded": "VAT included",
        "reviewFlags": "Review flags",
        "origin": "Origin",
        "originUpload": "Uploaded",
        "originManual": "Created by hand",
        "goaConflict": "GOÄ conflicts",
        "amountMismatch": "Amount mismatch",
        "sendingStatus": "Sending status",
        "readyForPost": "Ready for post",
        "readyForPostHint": "Unsent open invoices that can only go out by post (post only, no email, or postal consent only) and are ready to: full address and consent on file.",
        "doctor": "Doctor",
        "noQuestionnaireSent": "No consent request sent",
        "addressPlaceholder": "Street, city or PLZ…",
        "search": "Search…",
        "status": {
            "open": "Open",
            "unsent": "Not sent",
            "sendFailed": "Send failed",
            "paid": "Paid",
            "overdue": "Overdue",
            "writtenOff": "Written off",
            "deleted": "Deleted",
            "unknown": "Unknown"
        },
        "dunningLevels": {
            "paused": "Paused",
            "none": "No dunning",
            "friendly": "Friendly",
            "demanding": "Demanding",
            "final": "Final",
            "legal": "Legal"
        },
        "missingInfo": "Missing info",
        "noEmail": "No email",
        "noTel": "No phone",
        "noAddress": "No address"
    },
    "a11y": {
        "skipToContent": "Skip to main content"
    },
    "planDetails": {
        "1": {
            "line1": "1 doctor included",
            "line2": "100 invoices / doctor"
        },
        "2": {
            "line1": "1 doctor + 1 staff",
            "line2": "200 invoices / doctor"
        },
        "3": {
            "line1": "2 doctors + 2 staff",
            "line2": "Unlimited invoices"
        },
        "4": {
            "line1": "Custom plan",
            "line2": "Contact sales"
        }
    },
    "quickTips": {
        "title": "Quick Tips",
        "bank": {
            "title": "Connect your bank",
            "steps": [
                "Go to Settings → Bank Connection",
                "Click \"Connect bank\"",
                "Complete the OAuth flow with your bank",
                "Most transactions match to invoices automatically",
                "Review and manually match anything left on the Bank page"
            ],
            "action": "Go to Settings"
        },
        "cardPayment": {
            "title": "Card payment for patients (SumUp)",
            "steps": [
                "Open a SumUp business account (sumup.de) – if you already use a SumUp card terminal, you have one",
                "Settings → Card payment (SumUp) → \"Connect with SumUp\"",
                "Log in to SumUp and allow access",
                "Under \"Where card payment is offered\" choose: in the patient portal, by QR code at the desk, on the card terminal (Admin) – then \"Save changes\"",
                "Optional: pair a SumUp Solo under \"Card terminals\" – \"Send to card terminal\" on an invoice then puts the amount straight on the reader",
                "Patients pay by card, Apple Pay or Google Pay – in the portal, with their own phone via the QR code, or at the terminal",
                "Paid invoices are marked as paid automatically – overview under Bank → Card payments",
                "Only payments started in Medinvoice are recorded automatically (portal, QR code, Send to card terminal) – mark amounts entered yourself on the terminal or in the SumUp app as paid manually",
                "SumUp pays out to your bank account in batches; just mark those payouts as reviewed in bank matching"
            ],
            "action": "Set up card payment"
        },
        "pad": {
            "title": "Upload a PAD/PADnext file",
            "steps": [
                "Click \"Upload file\" in the navigation",
                "Select your PAD or PADnext file (.pad, .dat or .xml)",
                "Review the imported invoices",
                "Send them directly to recipients"
            ]
        },
        "createInvoice": {
            "title": "Create an invoice without practice software",
            "steps": [
                "Click \"Create invoice\" (Dashboard or Invoices)",
                "Pick or add the patient – get consent right there by QR code, paper, email or SMS",
                "Enter the treatment days and at least one diagnosis – search ICD-10-GM by code or term, then set G/V/A/Z and, if needed, side R/L/B",
                "Search GOÄ codes (digits = code, with letters = description) – single rate and factor range fill in automatically, templates save time, drag lines by the handle into the right order",
                "Review findings and suggestions in the check step (GOÄ check from Pro, suggestions from Plus)",
                "View the PDF, then \"Create\" or \"Create & send\"",
                "Everything is saved as a draft automatically – continue under Invoices → Drafts"
            ],
            "action": "Create invoice"
        },
        "csvImport": {
            "title": "Import patients from CSV",
            "steps": [
                "Export your patient list from your previous software as CSV",
                "On the Patients page, click \"…\" at the top right → \"Import CSV\"",
                "Drop the file, review the detected patients, untick any rows you don't want",
                "Import — patients already on file are skipped"
            ],
            "action": "Open CSV import"
        },
        "praxisSoftwareSync": {
            "title": "Sync your practice software automatically",
            "steps": [
                "Tested with MEDICAL OFFICE — T2med, tomedo and medatixx are coming soon",
                "Your practice software vendor sets up the GDT interface",
                "Then connect the folder on the Sync page (Chrome/Edge) or install the Windows desktop app",
                "New files are detected automatically — no manual upload"
            ],
            "action": "Go to Settings"
        },
        "send": {
            "title": "Send an invoice",
            "sections": [
                {
                    "heading": "Send digitally",
                    "steps": [
                        "Recipient must have an email address on file",
                        "Send the consent request and have the recipient sign it",
                        "Recipient must have signed the consent (Einwilligung)",
                        "Open the invoice and click Send → Email"
                    ]
                },
                {
                    "heading": "Send via post",
                    "steps": [
                        "Recipient must have a postal address on file",
                        "Recipient must have signed the consent (Einwilligung)",
                        "Open the invoice and click Send → Post"
                    ]
                }
            ],
            "action": "Go to invoices"
        },
        "personalize": {
            "title": "Personalise invoices",
            "steps": [
                "Go to Settings → PDF Template",
                "Customise logo, colour and font",
                "Add your own header and footer text",
                "Preview directly in the browser"
            ],
            "action": "Go to Settings"
        },
        "dunning": {
            "title": "Dunning process",
            "steps": [
                "M1 – Payment reminder (after due date)",
                "M2 – Formal reminder with fee",
                "M3 – Final notice before collections",
                "Collections (Inkasso) – automatic escalation, Plus plan and above",
                "Checked automatically every morning at 04:15",
                "Can be paused per invoice manually"
            ]
        },
        "charges": {
            "title": "Charges & revenue",
            "steps": [
                "Overview of all open and paid amounts",
                "Filter by date range and status",
                "Revenue charts on the dashboard",
                "CSV export available"
            ],
            "action": "Go to charges"
        },
        "tags": {
            "title": "Tag invoices",
            "steps": [
                "Open an invoice and click \"Tags\"",
                "Create or assign one or more tags",
                "Filter and bulk-manage invoices by tag"
            ],
            "action": "Go to invoices"
        },
        "groups": {
            "title": "Patient groups",
            "steps": [
                "Select multiple rows on the Patients page",
                "Click \"Add to group\"",
                "Create a new group or choose an existing one",
                "Filter the patient list by group"
            ],
            "action": "Go to patients"
        },
        "statistics": {
            "title": "Dashboard statistics",
            "steps": [
                "Click \"Statistics\" on the dashboard",
                "See revenue, invoice and dunning trends",
                "Switch tabs for different breakdowns",
                "Updates as invoices change"
            ],
            "action": "Go to dashboard"
        },
        "goaChecker": {
            "title": "GOÄ conflict checker",
            "steps": [
                "Open an invoice's Exams tab",
                "Conflicting or excluded GOÄ codes are flagged automatically",
                "Click a warning to see which rule applies"
            ],
            "action": "Go to invoices"
        },
        "reports": {
            "title": "Automated reports",
            "steps": [
                "Go to Settings → General",
                "Set a report interval (daily, weekly, monthly, ...)",
                "Generate a PDF report on demand or automatically"
            ],
            "action": "Go to settings"
        },
        "planBadge": {
            "2": "Plus",
            "3": "Pro"
        },
        "docs": {
            "title": "Documentation",
            "steps": [
                "Full guide to all features",
                "GOÄ rules and billing notes",
                "Processes, FAQ and templates",
                "Always up to date in the \"Docs\" section"
            ],
            "action": "Open docs"
        }
    },
    "common": {
        "refresh": "Refresh",
        "back": "Back",
        "notFound": "Not found",
        "pageNotFound": "Page not found",
        "loading": "Loading…",
        "fetching": "Fetching...",
        "search": "Search",
        "footer": "medinvoice® – powered by exipnon GmbH",
        "at": "at",
        "notSent": "Not sent",
        "allSent": "All sent",
        "nothingToSend": "Nothing to send",
        "paid": "paid",
        "open": "open",
        "willAlsoDelete": "The following will also be deleted:",
        "invoicesWillAlsoBeDeleted": "The following invoices will also be deleted:",
        "deleteAlsoOtherDoctorsInvoices": "This patient is visible practice-wide. Deleting them will also remove invoices belonging to {{doctors}}.",
        "doctorInvoiceCount_one": "{{name}} ({{count}} invoice)",
        "doctorInvoiceCount_other": "{{name}} ({{count}} invoices)",
        "deletingData": "Deleting {{count}} records…",
        "cleaningUp": "Cleaning things up…",
        "sendingProgress": "Sending ({{done}}/{{total}})…",
        "cancel": "Cancel",
        "cancelling": "Cancelling…",
        "cancelledProgress": "Cancelled after {{done}} of {{total}}.",
        "bulkSendingProgress": "Sending {{subject}} — {{done}} of {{total}} sent",
        "bulkSendMoreQueued_one": "+{{count}} more waiting",
        "bulkSendMoreQueued_other": "+{{count}} more waiting",
        "bulkSendSubjectQuestionnaires": "questionnaires",
        "bulkSendSubjectPortalLinks": "portal links",
        "bulkSendSubjectLetters": "letters",
        "demoSimulated": "Simulated in demo — no real action was performed.",
        "changesSaved": "Changes saved.",
        "saving": "Saving…",
        "saved": "Saved",
        "saveFailed": "Changes could not be saved.",
        "unknownError": "Unknown error",
        "updatedAt": "Updated {{time}}",
        "recency": {
            "today": "Today",
            "yesterday": "Yesterday",
            "daysAgo_one": "{{count}} day ago",
            "daysAgo_other": "{{count}} days ago",
            "weeksAgo_one": "{{count}} week ago",
            "weeksAgo_other": "{{count}} weeks ago",
            "monthsAgo_one": "{{count}} month ago",
            "monthsAgo_other": "{{count}} months ago",
            "yearsAgo_one": "{{count}} year ago",
            "yearsAgo_other": "{{count}} years ago"
        }
    },
    "invoiceRow": {
        "openInvoice": "Open invoice",
        "paidByCard": "Paid by card (SumUp): € {{amount}}",
        "sendPortalLink": "Send patient portal link",
        "resendPortalLink": "Resend patient portal link",
        "sendViaPost": "Send via post",
        "sendViaPostMsg": "Mark invoice {{id}} as sent via post?",
        "noAddress": "Recipient has no address",
        "postConsentRequired": "Consent missing — postal sending requires a signed Einwilligung",
        "consentNeededHint": "Consent (Einwilligung) not yet signed — required before this invoice can be sent digitally",
        "cannotSendYet": "Can't send yet",
        "goToRecipient": "Go to recipient",
        "noEmail": "Recipient has no email address",
        "noEmailOrTel": "Recipient has no email address",
        "sendLinkMsg": "Send patient portal link for invoice {{id}} to the recipient's email?",
        "resendLinkMsg": "Resend patient portal link for invoice {{id}} to the recipient's email?",
        "deleteInvoice": "Delete invoice",
        "deleteInvoiceBtn": "delete",
        "deleteMsg": "Are you sure you want to delete invoice {{id}}?",
        "cannotDeleteSent": "Cannot delete — invoice has already been sent",
        "cannotDeletePaid": "Cannot delete — invoice has already been paid",
        "cannotDeleteOverdue": "Cannot delete — invoice is overdue"
    },
    "tags": {
        "tag": "Tag",
        "manageTags": "Manage tags",
        "newTagPlaceholder": "New tag…",
        "addTag": "Add",
        "noTags": "No tags created yet.",
        "noTag": "— no tag —",
        "rename": "rename",
        "delete": "delete",
        "deleteConfirm": "Delete tag \"{{name}}\"? It will be removed from all invoices it's assigned to.",
        "createFailed": "Could not create tag.",
        "renameFailed": "Could not rename tag.",
        "deleteFailed": "Could not delete tag.",
        "assignFailed": "Could not assign tag to invoice.",
        "tagThisBatch": "Tag this upload"
    },
    "groups": {
        "group": "Group",
        "manageGroups": "Manage groups",
        "addToGroup": "Add to group",
        "newGroupPlaceholder": "New group…",
        "addGroup": "Add",
        "noGroups": "No groups created yet.",
        "noGroup": "— no group —",
        "rename": "rename",
        "delete": "delete",
        "deleteConfirm": "Delete group \"{{name}}\"? It will be removed from all patients it's assigned to.",
        "createFailed": "Could not create group.",
        "renameFailed": "Could not rename group.",
        "deleteFailed": "Could not delete group.",
        "assignFailed": "Could not assign group to patient.",
        "bulkGroupsApplied_one": "Added {{count}} patient to group(s)",
        "bulkGroupsApplied_other": "Added {{count}} patients to group(s)"
    },
    "popup": {
        "confirm": "Confirm",
        "cancel": "Cancel",
        "ok": "OK",
        "done": "Done",
        "close": "Close"
    },
    "pdfSettings": {
        "praxisDefaultNotice": "You haven't saved your own PDF layout yet — the praxis's default is currently used. Once you save here, this layout will apply only to your own invoices.",
        "content": "Content",
        "clearAll": "Clear all",
        "previewPdf": "Preview PDF",
        "generating": "Generating…",
        "recreating": "Recreating PDF…",
        "clearTitle": "Clear PDF settings",
        "clearMessage": "Reset all PDF settings to defaults? This cannot be undone.",
        "previewTitle": "PDF Preview (sample data)",
        "tabGeneric": "Generic",
        "tabHeader": "Page Header",
        "tabFooter": "Page Footer",
        "tabBody": "Body Text",
        "showQrCode": "Show Scan & Pay QR code",
        "showQrCodeDesc": "EPC QR code for bank transfer on the invoice",
        "showRecipientEmail": "Show recipient email",
        "showRecipientEmailDesc": "Email address line in the patient info block",
        "showExams": "Show exam table",
        "showExamsDesc": "If off, only the total amount line is shown",
        "showUstgNote": "VAT exemption note",
        "showUstgNoteDesc": "Show \"exempt from VAT pursuant to § 4 No. 14 UStG\" below the total amount",
        "infoLine": "Praxis info line",
        "infoLineDesc": "Fields shown in the small info line at the top of the invoice",
        "infoShowPraxisName": "Praxis name",
        "infoShowDoctor": "Doctor name",
        "infoShowSpecialization": "Specialization",
        "infoShowAddress": "Address",
        "headerHint": "If nothing is set, the standard praxis info line is used.",
        "footerHint": "If nothing is set, bank details are shown in the invoice body instead.",
        "boxStyle": "Box style",
        "border": "Border",
        "borderWidth": "Width",
        "insetH": "Inset H",
        "insetV": "Inset V",
        "marginBottom": "Margin bottom",
        "marginTop": "Margin top",
        "logo": "Logo",
        "logoDesc": "Image shown in the column selected below",
        "logoSize": "Size (height)",
        "logoOffset": "Fine position",
        "logoOffsetDesc": "Nudges the logo pixel-by-pixel from its column position — negative values move it up/left.",
        "logoOffsetX": "Horizontal",
        "logoOffsetY": "Vertical",
        "logoPosition": "Logo position",
        "logoPositionDesc": "Which column of the header the logo appears in",
        "logoSlotNone": "None",
        "logoSlotLeft": "Left column",
        "logoSlotCenter": "Center column",
        "logoSlotRight": "Right column",
        "colLeft": "Left column",
        "colCenter": "Center column",
        "colRight": "Right column",
        "colLeftDesc": "If all three columns are empty, the custom header is not shown.",
        "logoColNotice": "Logo is shown in this column",
        "colPlaceholder": "e.g. {praxis.name}",
        "bold": "Bold",
        "italic": "Italic",
        "underline": "Underline",
        "fontSize": "Size",
        "alignHorizontal": "Horizontal align",
        "alignVertical": "Vertical align",
        "alignLeft": "Left",
        "alignCenter": "Center",
        "alignRight": "Right",
        "alignTop": "Top",
        "alignMiddle": "Middle",
        "alignBottom": "Bottom",
        "showBankDetails": "Show bank details",
        "showBankDetailsDesc": "IBAN, BIC and payment reference in the footer",
        "showAddress": "Show practice address",
        "showAddressDesc": "Practice name and address in the footer",
        "headerRepeatOnEveryPage": "Header on every page",
        "headerRepeatOnEveryPageDesc": "Repeat the header on all pages of the invoice",
        "bodyHint": "Customize the fixed body text on the invoice. Leave blank to use the default German text.",
        "bodyHeading": "Invoice heading",
        "bodyHeadingDesc": "Large heading above the patient section",
        "bodyHeadingPlaceholder": "Liquidation für ambulante ärztliche Behandlung nach GOÄ",
        "bodyChargeLine": "Charge line",
        "bodyChargeLineDesc": "Line below the patient info, before the service table",
        "bodyChargeLinePlaceholder": "für unsere ärztlichen Bemühungen erlaube ich mir zu berechnen:",
        "bodyPaymentTerms": "Payment terms",
        "bodyPaymentTermsDesc": "Text below the total — use {invoice.id} and {invoice.dueDate} as placeholders",
        "bodyPaymentTermsPlaceholder": "Zahlungsbedingungen: Zahlbar unter Angabe der Rechnungsnummer {invoice.id} ohne Abzug bis zum {invoice.dueDate}."
    },
    "charges": {
        "title": "Monthly Charges",
        "subtitle": "Billing summary for the selected month",
        "invoices": "Invoices",
        "sms": "SMS Notifications",
        "letters": "Letters",
        "count": "Count",
        "basePrice": "Base price",
        "surcharge": "Surcharge",
        "total": "Total",
        "grandTotal": "Grand Total",
        "perInvoice": "per invoice",
        "perSms": "per SMS",
        "perLetter": "per letter",
        "zaalaFeePerLetter": "Zaala fee per letter",
        "zaalaFee": "Zaala fee",
        "letterPriceNote": "Letter cost varies by specs (B/W, color, duplex…) + €0.10 Zaala fee",
        "letterCostFormula": "letter cost + €0.10",
        "letterCostCol": "Cost (LX + fee)",
        "tier": "Tier",
        "noCharges": "No activity this month",
        "amount": "Amount",
        "invoiceId": "Invoice ID",
        "recipient": "Recipient",
        "patient": "Patient",
        "sentDate": "Sent",
        "paidDate": "Paid",
        "notSent": "Not sent",
        "notPaid": "Not paid",
        "phone": "Phone",
        "address": "Address",
        "letterRef": "Letter ref.",
        "letterDetails": "Details",
        "color": "Color",
        "bw": "B&W",
        "duplex": "Duplex",
        "simplex": "Simplex",
        "cost": "Cost",
        "type": "Type",
        "kind_sms": "SMS",
        "kind_otp": "OTP",
        "smsDetail": "SMS detail",
        "letterDetail": "Letter detail",
        "timeSaved": "Time saved this month",
        "timeSavedDesc": "Every paid invoice processed through Medinvoice saves ~5 min vs. manual post: print, mail, track & follow up vs. import, auto-send, auto-track. Delivery: instant vs. 2–5 business days.",
        "timeSavedMinutes": "{{min}} min saved",
        "timeSavedHours": "{{h}}h {{min}}min saved",
        "timeSavedBasis": "{{count}} paid invoice × ~5 min",
        "co2Saved": "Paper & CO₂ saved",
        "co2Desc": "Each digital invoice avoids printing, enveloping and posting ~2 sheets of paper. 1 tree ≈ 8,333 sheets.",
        "co2Sheets": "{{n}} sheets saved",
        "co2Co2": "≈ {{g}}g CO₂",
        "co2Trees": "≈ {{pct}}% of a tree",
        "co2Basis": "{{count}} digital invoice × ~2 sheets",
        "doctor": "Doctor",
        "invoiceCount": "Invoices",
        "rate": "Rate",
        "billed": "Billed",
        "byDoctor": "Breakdown by doctor",
        "previous": "Previous",
        "next": "Next",
        "current": "Current",
        "clickForDetails": "Click any row for details",
        "rowPlan": "Plan",
        "rowDoctors": "Doctors",
        "rowStaff": "Staff",
        "messages": "{{count}} messages",
        "rowSent": "{{count}} sent",
        "doctorsIncluded": "{{count}} doctor · {{included}} included",
        "doctorsIncludedPlural": "{{count}} doctors · {{included}} included",
        "doctorsOverage": "{{total}} total · {{included}} incl. + {{extra}} × €39",
        "staffIncluded": "{{count}} staff member · {{included}} included",
        "staffIncludedPlural": "{{count}} staff members · {{included}} included",
        "staffOverage": "{{total}} total · {{included}} incl. + {{extra}} × €9.90",
        "invoicesUnlimited": "{{count}} invoices · unlimited",
        "invoicesAllowance": "{{count}} used / {{total}} incl. ({{perDoctor}}/doctor)",
        "subtotal": "Subtotal",
        "discount": "Discount (netto)",
        "discountWithPercentage": "Discount ({{pct}}%, netto)",
        "netTotal": "Net total",
        "vat19": "VAT (19%)",
        "totalInclVat": "Total incl. VAT",
        "addOns": "Add-ons",
        "addOnCancelsOn": "Cancels {{date}}",
        "cancel": "Cancel",
        "undo": "Undo",
        "paid": "PAID",
        "paidOn": "PAID · {{date}}",
        "unpaid": "UNPAID",
        "free": "FREE",
        "popupPlans": "Plans",
        "popupDoctors": "Doctors",
        "close": "Close",
        "updateIban": "Update payment IBAN",
        "updateIbanHint": "Enter the new IBAN for your SEPA Direct Debit mandate. The next collection will be treated as a first debit.",
        "ibanRequired": "IBAN is required",
        "ibanSaveError": "Failed to update IBAN. Please try again.",
        "ibanSaved": "IBAN updated successfully",
        "pvsSavingsLabel": "Cost savings this month vs. a PVS billing service:",
        "pvsConfigButton": "Configure calculation",
        "pvsResetButton": "Reset to 0",
        "pvsCommissionLabel": "Billing commission in %",
        "pvsPerInvoiceLabel": "Additional cost per invoice in EUR (net)",
        "pvsPerMonthLabel": "Other costs per month in EUR (net)",
        "pvsNotConfigured": "Not yet configured — use \"Configure calculation\" to calculate your savings.",
        "pvsSavingsNegativeSuffix": "more expensive than PVS",
        "pvsSaved": "Settings saved",
        "pvsSaveError": "Could not save settings. Please try again.",
        "pvsCommissionRangeError": "Commission must be between 0 and 100%",
        "pvsPerInvoiceRangeError": "Cost per invoice must be between 0 and 50",
        "pvsPerMonthRangeError": "Cost per month must be between 0 and 5000",
        "noDoctors": "No doctors found",
        "never": "Never",
        "colStatus": "Status",
        "statusOpen": "Open",
        "statusSent": "Sent",
        "statusPaid": "Paid",
        "statusWrittenOff": "Written off",
        "roleMedicalAssistant": "Medical Assistant",
        "roleDoctor": "Doctor",
        "roleAdmin": "Admin",
        "roleAccounting": "Accounting",
        "colName": "Name",
        "colRole": "Role",
        "colSpecialty": "Specialty",
        "colLastLogin": "Last login",
        "colBillingStatus": "Billing",
        "roleStaff": "Staff",
        "billingStatusIncluded": "Included in plan",
        "billingStatusExtra": "Extra · billed",
        "billingStatusRemoved": "Removed {{date}} · still billed",
        "planCompBaseFee": "Base fee / mo",
        "planCompIncludedDoctors": "Included doctors",
        "planCompIncludedStaff": "Included staff",
        "planCompDoctorSingular": "doctor included",
        "planCompDoctorPlural": "doctors included",
        "planCompStaffIncluded": "staff included",
        "planCompExtraDoctor": "Extra doctor",
        "planCompExtraStaff": "Extra staff",
        "planCompInvoicesPerDoctor": "Invoices / praxis / mo",
        "planCompOverageRate": "Per extra invoice",
        "planUnlimited": "Unlimited",
        "planIncluded": "Included",
        "planBilled": "Billed",
        "planCustom": "Custom",
        "extraFeatures": "Extra features (charged separately depending on plan)",
        "addonTagging": "Tagging & patient groups",
        "addonGoaChecker": "GOÄ checker",
        "addOnAdd": "Add · +€{{price}}/mo",
        "addOnAdded": "Added",
        "changePlan": "Change plan",
        "changePlanHint": "Select the plan you'd like to switch to. Our team will contact you to confirm the change.",
        "changePlanSubmit": "Request change",
        "changePlanDone": "Your request has been received. We'll be in touch shortly to confirm the plan change.",
        "cancelSubscription": "Cancel subscription",
        "cancelNotice": "Your subscription will remain active until the end of the current billing month. After that, your account will be deactivated. Our team will process your request and confirm via email.",
        "cancelConfirm": "Yes, cancel",
        "cancelDone": "Your cancellation request has been received. We'll confirm via email.",
        "changePlanNote": "The new plan will be applied from the 1st of next month.",
        "pendingPlan": "{{plan}} from {{date}}",
        "cancelPlanChangeTitle": "Cancel plan change",
        "cancelPlanChangeMsg": "The switch to {{plan}} scheduled for {{date}} will be cancelled. You stay on your current plan.",
        "cancelPlanChangeConfirm": "Cancel change",
        "confirmPlan": "Confirm",
        "currentPlan": "(current)",
        "billingEyebrow": "BILLING",
        "pageTitle": "Charges",
        "pageLead": "Your monthly invoice and subscription overview",
        "invoiceHistory": "Invoice history",
        "downloadPdf": "Download PDF",
        "periodLabel": "PERIOD",
        "dueOn": "DUE {{date}}",
        "netShort": "net",
        "vatShort": "VAT (19%)",
        "billedOn": "billed {{date}}",
        "sepaOnFile": "SEPA on file · {{iban}}",
        "subMetaEach": "€{{base}} base + usage · billed 1st of each month · {{doctors}} doctors, {{staff}} staff",
        "managePlan": "Manage plan",
        "updatePaymentMethod": "Update payment method",
        "thisMonth": "This month",
        "overageHint": "click an overage row to see usage",
        "planLineSub": "{{plan}} · {{doctors}} doctor + {{staff}} staff included",
        "rowExtraDoctors": "Extra doctors",
        "doctorsOverageRate": "{{count}} doctors over plan · €39 each",
        "removedButBilled": "includes {{names}} — removed this month, still billed",
        "doctorsIncludedShort": "{{count}} doctors · {{included}} included",
        "invoiceOverageDetail": "{{used}} of {{total}} included · 0.5% per overage",
        "lettersSub": "{{count}} sent · VAT incl.",
        "smsOtp": "SMS & OTP",
        "smsSub": "{{count}} sent · €0.09 each · VAT incl.",
        "withinPlan": "Within plan — {{count}} line items",
        "withinPlanSub": "Extra staff · Bank-feed access · all included",
        "whyBillHigher": "Why your bill is ↑ €{{amount}} higher than {{month}}",
        "whyBillLower": "Why your bill is ↓ €{{amount}} lower than {{month}}",
        "topContributors": "Top contributors",
        "comparePlansHint": "Press U to compare plans",
        "whyInvoiceOverageDoctor": "+{{count}} invoice overages on {{name}}",
        "whyInvoiceOverageDetail": "{{used}} vs {{allowance}} included",
        "whyExtraDoctors": "+{{count}} extra doctors",
        "whyLetters": "{{count}} letters",
        "whyLettersLess": "digital delivery up",
        "whySms": "{{count}} SMS vs last month",
        "today": "Today",
        "downloadInvoice": "Download invoice",
        "viewOnStripe": "View on Stripe",
        "receiptEmailed": "Also sent to your practice email after billing.",
        "receiptAfterBilling": "A copy is also emailed after SEPA billing.",
        "downloading": "Downloading…",
        "downloadFailed": "Could not download receipt",
        "totalEyebrow": "{{period}} · INVOICE READY",
        "totalPaidEyebrow": "{{period}} · PAID {{date}}",
        "invoiceReady": "INVOICE READY",
        "vsLastMonth": "vs",
        "manageSubscription": "Manage subscription",
        "invoiceOverage": "Invoice overage",
        "invoiceOverageSub": "Per-doctor surcharge above allowance",
        "noPaymentMethod": "No payment method on file",
        "subMeta": "€{{base}} base + usage · billed 1st of month · {{doctors}} doctors, {{staff}} staff",
        "whyHigherTitle": "Why higher than {{month}}",
        "whyLowerTitle": "Why lower than {{month}}",
        "ecoInvoices": "{{count}} invoices",
        "ecoTime": "~{{time}} est. saved",
        "ecoPaper": "{{sheets}} sheets · {{co2}} kg CO₂ avoided",
        "methodology": "methodology",
        "methodologyTitle": "Estimates methodology",
        "methodologyBody": "Time saved: ~5 minutes per digital invoice vs. manual post. Paper: ~2 sheets per invoice. CO₂: ~10 g per sheet avoided. Figures are illustrative, not audited."
    },
    "stripe": {
        "billingTitle": "Subscription & Payment",
        "sepaTitle": "Payment Method",
        "optional": "Optional",
        "sepaHint": "Add your SEPA bank account to continue your subscription automatically after the free trial.",
        "ibanLabel": "IBAN",
        "confirmSepa": "Save payment method",
        "confirming": "Saving…",
        "sepaConfirmed": "Payment method saved successfully",
        "confirmError": "Could not confirm payment method. Please try again.",
        "mandateText": "By providing your IBAN and confirming this mandate, you authorise Zaala GmbH to send instructions to your bank to debit your account in accordance with those instructions. You are entitled to a refund from your bank under the terms and conditions of your agreement with your bank.",
        "addPaymentMethod": "Add payment method",
        "updatePaymentMethod": "Update",
        "sepaOnFile": "SEPA Direct Debit",
        "notConfigured": "Payment not configured",
        "trialEnds": "Trial ends {{date}}",
        "pastDueWarning": "Payment overdue – please update your payment method",
        "status_trialing": "Trial",
        "status_active": "Active",
        "status_past_due": "Past due",
        "status_canceled": "Canceled",
        "status_incomplete": "Incomplete"
    },
    "verifyEmail": {
        "verifying": "Verifying your email address…",
        "successTitle": "Email verified!",
        "successText": "Your email address has been confirmed. You can now sign in.",
        "errorTitle": "Verification failed",
        "errorText": "The link is invalid or has already been used. Please contact support."
    },
    "briefing": {
        "howItWorks": "How it works",
        "uploadInvoices": "Upload invoices",
        "moreOptions": "More options",
        "hideActivity": "Hide Activity",
        "showActivity": "Show Activity",
        "hideBank": "Hide Bank",
        "showBank": "Show Bank",
        "weekShort": "Week {{n}}",
        "todayClear": "You're all caught up. Treat yourself to a coffee.",
        "outstanding": "Outstanding",
        "thisMonth": "This month",
        "trend12w": "12-week trend",
        "rowMonthSent": "Sent",
        "rowMonthPaid": "Paid",
        "rowMonthNewOverdue": "New overdue",
        "rowPlanQuota": "Plan quota",
        "deltaPctVsPrev12w": "↓ {{pct}}% paid vs prev. 12 w",
        "stackUnsent": "Unsent",
        "stackOverdue": "Overdue",
        "stackAwaiting": "Awaiting payment",
        "feedBank": "Bank",
        "feedActivity": "Activity",
        "syncedAgo": "synced {{time}}",
        "last30days": "Last 30 days",
        "lastNDays": "Last {{n}} days",
        "bankMatched": "Matched to invoice {{id}}",
        "bankSuggested": "Suggested: invoice {{id}}",
        "bankNoMatch": "No match — possibly a duplicate or refund",
        "bankExpense": "Expense · auto-categorised",
        "bankBtnMatch": "Match",
        "bankBtnFind": "Find invoice",
        "bankBtnDone": "Done",
        "bankBtnFiled": "Filed",
        "actionCtaSendNext": "Send M{{next}}",
        "actionCtaSendPortal": "Send portal link",
        "actionCtaOpenThread": "Open thread",
        "actionTitleM3": "Final dunning ready",
        "actionTitleM2": "Demanding reminder due",
        "actionTitleM1": "Friendly reminder due",
        "actionTitleLegal": "Legal escalation pending",
        "actionTitleUnsent": "Invoices waiting to be sent",
        "actionTitleQuestion": "Patient asked a question",
        "actionMetaDaysOverdue": "{{days}} days overdue",
        "actionMetaCreatedAgo": "created {{days}} days ago",
        "actionMetaDaysAgo": "{{days}} days ago",
        "actionContextM3": "Letter cost ~€ 1.84 · M4 escalates to legal.",
        "actionContextM12": "Portal already sent · re-send via email or post.",
        "actionContextUnsentSelf": "Patient is the invoice recipient · portal link is fastest.",
        "actionContextUnsentOther": "Send portal link or post.",
        "bankBtnIgnore": "Mark irrelevant",
        "bankBtnUnmatch": "Unmatch",
        "bankBtnRestore": "Restore",
        "bankBtnOut": "Outgoing",
        "bankNoTransactions": "No recent transactions.",
        "bankUnknown": "Unknown sender",
        "bankMatched2": "Matched to an invoice",
        "timeJustNow": "just now",
        "timeMinAgo": "{{n}} min ago",
        "timeHourAgo": "{{n}}h ago",
        "timeDayAgo": "{{n}}d ago",
        "timeM": "m",
        "timeH": "h",
        "timeD": "d",
        "timeW": "w",
        "timeMo": "mo",
        "actPaid": "paid",
        "actInvoice": "Invoice",
        "actEscalatedTo": "escalated to",
        "actBankMatched": "Bank transaction matched to invoice",
        "actAskedQuestion": "asked a question",
        "actViewedInvoice": "viewed invoice",
        "actReminderSend": "Reminder to send",
        "actDOld": "d old",
        "actPortalRegistered": "registered for the portal",
        "actSmsVerified": "used SMS verification",
        "actQuestionnaire": "filled the questionnaire",
        "actBilling": "Billing charged:",
        "recipient": "Recipient",
        "invoice": "invoice",
        "invoices": "invoices",
        "todayNeedYou": "need you today.",
        "todayQueue": "€ {{amount}} across the queue.",
        "todayNothing": "Nothing",
        "todayNothingNeeds": "needs you today.",
        "activityEmpty": "No recent activity.",
        "viewAllActivity": "View all activity"
    },
    "trial": {
        "badge": "TRIAL",
        "daysLeft_one": "{{count}} day left",
        "daysLeft_other": "{{count}} days left",
        "daysLeft_zero": "Last day",
        "invoices": "Invoices",
        "sms": "SMS",
        "limitsTitle": "Trial limits",
        "of": "of",
        "endedTitle": "Your trial has ended",
        "endedSubtitle": "Would you like to continue using Medinvoice?",
        "continueButton": "Yes, continue",
        "declineButton": "No, cancel subscription",
        "chargingInfo": "If you continue, billing starts at the end of the current month. The current month is charged only for the days after your trial ended — so you only pay for what you actually use.",
        "planLabel": "Your plan",
        "acceptSuccess": "Welcome! Your subscription is now active.",
        "declineSuccess": "Your subscription has been cancelled. You can still access your data.",
        "declineConfirmTitle": "Cancel subscription?",
        "declineConfirmMsg": "Are you sure? You will lose access to Medinvoice features. Your data will be retained.",
        "invoiceLimitReached": "Invoice limit reached. You can create up to 20 invoices during the trial.",
        "smsLimitReached": "SMS limit reached. Your practice has used all 50 SMS verifications included in the trial.",
        "greetingMale": "Dear",
        "greetingFemale": "Dear",
        "greeting": "Dear",
        "expiredBody": "your free trial for the <strong>{{plan}}</strong> subscription plan has now ended.",
        "expiredContinue": "To continue using medinvoice® without interruption, please complete your order using the button below.",
        "expiredProration": "For the current month, we will of course only charge you the pro-rated monthly price from the start of your paid subscription.",
        "expiredFeedbackPrompt": "If we haven't convinced you, we would greatly appreciate your feedback.",
        "selectedPlan": "Selected plan",
        "price": "Price",
        "vatNote": "* excl. VAT",
        "perMonth": "/ mo",
        "completeOrder": "Complete order",
        "sendFeedback": "Send feedback",
        "reject": "Reject",
        "feedbackTitle": "Your feedback",
        "feedbackDescription": "What could we have done better? We read every response.",
        "feedbackPlaceholder": "Your feedback…",
        "feedbackSubmit": "Submit feedback",
        "feedbackBack": "Back",
        "feedbackSentTitle": "Thank you for your feedback.",
        "feedbackSentBody": "You can still complete your order or log out below.",
        "logOut": "Log out",
        "activatedLogin": "Log in now →",
        "activatedTitle": "Congratulations!",
        "activatedBody": "Your account has been activated. You can now use your plan to its full extent. We look forward to working with you!",
        "activatedSignature": "The medinvoice® team"
    },
    "inactivity": {
        "message": "You will be logged out in {{count}} seconds due to inactivity.",
        "stayLoggedIn": "Stay logged in"
    },
    "csvImport": {
        "title": "Import patients from CSV",
        "dropLabel": "Drop CSV file here",
        "dropSub": "or select a file (.csv only)",
        "browse": "Choose file",
        "hint": "Supported columns: First name, Last name, Date of birth, Gender, Salutation, Title, Street, Postal code, City, Phone, Email",
        "parse": "Load preview",
        "back": "Back",
        "cancel": "Cancel",
        "import_one": "Import {{count}} patient",
        "import_other": "Import {{count}} patients",
        "importing": "Importing…",
        "close": "Close",
        "rowsFound": "rows found",
        "rowsSelected": "selected",
        "toggleAll": "Select / deselect all",
        "colName": "Name",
        "colBornGender": "DOB / Gender",
        "colAddress": "Address",
        "colContact": "Contact",
        "colLastName": "Last name",
        "colFirstName": "First name",
        "colBirthDate": "Date of birth",
        "colGender": "Gender",
        "colTitle": "Title",
        "colStreet": "Street",
        "colPlz": "Postal code",
        "colCity": "City",
        "colTel": "Phone",
        "colEmail": "Email",
        "colIsRecipient": "Role",
        "minor": "Minor",
        "stepLabelFile": "File",
        "stepLabelReview": "Review",
        "stepLabelDone": "Done",
        "previewIntro": "Review the detected patients below. Uncheck any rows you don't want to import.",
        "isRecipientYes": "Recipient + Patient",
        "isRecipientNo": "Patient only",
        "stepParsing": "Reading CSV…",
        "stepValidating": "Validating data…",
        "stepCreating": "Creating patients…",
        "stepFinalizing": "Finalizing…",
        "doneTitle": "Import complete",
        "doneCreated_one": "{{count}} patient created",
        "doneCreated_other": "{{count}} patients created",
        "doneSkipped_one": "{{count}} skipped (duplicate)",
        "doneSkipped_other": "{{count}} skipped (duplicates)",
        "errorNotCsv": "Please upload only .csv files.",
        "errorEmpty": "The file contains no recognizable rows.",
        "errorParse": "Error reading the file. Please check the format.",
        "errorImport": "Import failed. Please try again.",
        "errorNoColumns": "No columns could be recognised. Please check the detected columns below.",
        "showColumns": "Show detected columns",
        "hideColumns": "Hide columns",
        "detectedCols": "Detected column headers",
        "colMappedAs": "Imported as «{{field}}»",
        "colIgnored": "Not recognised — will be ignored",
        "noColsMatched": "No column could be matched to a known field. Please check the column headers in your file (e.g. First name, Last name, Date of birth, Email).",
        "skippedLabel": "Skipped rows:",
        "skippedNoName": "(no name)",
        "skipReason_empty_name": "No last name",
        "skipReason_duplicate_db": "Already exists",
        "skipReason_duplicate_csv": "Duplicate in CSV",
        "downloadTemplate": "Download template",
        "doneRecipients_one": "{{count}} recipient created",
        "doneRecipients_other": "{{count}} recipients created",
        "warnNoRecipients": "No recipients were created — email or phone missing, or columns not recognised."
    },
    "registerWidgetDefaults": {
        "heading": "Register as a new patient",
        "message": "Scan the QR code with your phone, or tap below to get started in just a couple of minutes."
    },
    "updateBanner": {
        "label": "Update",
        "text": "A new version of Medinvoice is available.",
        "reload": "Reload"
    },
    "whatsNew": {
        "title": "What's new",
        "button": "What's new",
        "empty": "Nothing published yet."
    }
}
